/*
* @描述:
* @版本: 1.0
* @作者: 冯强
* @创建时间: 2024-12-17 18:28:27
*/
<template>
    <div id="template_review_wrap"
         ref="template_review_wrap"
         v-loading="loading"
         class="template_review_wrapper">
        <div v-if="project_quotation_tmpl_form==='project_quotation_tmpl_1'"
             ref="project_quotation_tmpl_1"
             class="template_1_wrap">
            <div class="template_header_wrap">
                <div :class="{'no_border':quotationForm.company_logo!==''}"
                     class="logo_wrap"
                     @click="handleClickUploadLogo">
                    <img v-if="quotationForm.company_logo"
                         :src="quotationForm.company_logo"
                         alt=""
                         class="logo">
                    <div v-else class="upload_text">点击替换公司logo</div>
                </div>
                <div class="quotation_title">
                    <span v-if="templateType==='detail'" v-text="quotationForm.title"></span>
                    <el-input v-else
                              v-model="quotationForm.title"
                              maxlength="20"
                              placeholder="请输入标题"
                              size="small"></el-input>
                </div>
            </div>
            <div class="template_content_wrap">
                <draggable :animation="300"
                           :disabled="templateType==='detail'"
                           :list="templateFieldsList"
                           :move="onDragFormItemMove"
                           class="form_module_content_wrap"
                           @end="onDragFormItemEnd">
                    <div v-for="(field,index) in templateFieldsList"
                         :class="'col_span_'+field.extend.col_span"
                         :style="{'border-right':field.extend.col_span===12&&handleIconIsShow(index)?'1px solid rgba(0, 0, 0, 0.08)':''}"
                         class="template_field_item_wrap">
                        <template v-if="field.field_type==='input'">
                            <div class="input_field_wrap">
                                <div class="field_label_wrap">
                                    <el-input v-model="field.field_name"
                                              :disabled="templateType==='detail'||field.is_system===1"
                                              autosize
                                              maxlength="10"
                                              :placeholder="templateType=='add'?'请输入标题':''"
                                              type="textarea"></el-input>
                                </div>
                                <div class="field_value_wrap">
                                    <div v-if="field.field_key==='project_name'">
                                        <el-popover v-model="projectListVisible"
                                                    placement="bottom"
                                                    popper-class="project_list_popover"
                                                    trigger="manual"
                                                    width="300">
                                            <el-input slot="reference"
                                                      v-model="quotationForm[field.field_key].value"
                                                      :disabled="templateType!=='add'"
                                                      :placeholder="field.is_system===1?field.extend.placeholder:'请输入'+field.field_name"
                                                      autosize
                                                      type="textarea"
                                                      @input="handleProjectNameInput(field)">
                                            </el-input>
                                            <ul class="project_list">
                                                <li v-for="item in projectList"
                                                    :key="item.project_id"
                                                    class="project_item"
                                                    @click="handleClickProjectName(item,field)"
                                                    v-text="item.name.value"></li>
                                            </ul>
                                        </el-popover>
                                    </div>
                                    <el-input v-model="quotationForm[field.field_key].value"
                                              v-else
                                              :disabled="templateType!=='add'"
                                              :placeholder="templateType=='add'?field.is_system===1?field.extend.placeholder:'请输入'+field.field_name:''"
                                              autosize
                                              type="textarea">
                                    </el-input>
                                </div>
                            </div>
                        </template>
                        <template v-else-if="field.field_type==='textarea'">
                            <div class="textarea_field_label">
                                <div v-if="field.is_system===1" class="field_name" v-text="field.field_name"></div>
                                <el-input v-else v-model="field.field_name" placeholder="请输入标题"></el-input>
                            </div>
                            <div class="textarea_field_value">
                                <el-input v-model="quotationForm[field.field_key].value"
                                          v-if="templateType==='add'"
                                          :placeholder="field.is_system===1?field.extend.placeholder:'请输入'+field.field_name"
                                          autosize
                                          type="textarea">
                                </el-input>
                                <div v-else class="detail_field_value"
                                     v-text="quotationForm[field.field_key].value"></div>
                            </div>
                        </template>
                        <template v-else-if="field.field_type==='contact'">
                            <div class="input_field_wrap">
                                <div class="field_label_wrap">
                                    <div class="field_name" v-text="field.field_name"></div>
                                </div>
                                <div class="field_value_wrap">
                                    <el-select :ref="`${field.field_key}_contact_select`"
                                               v-if="templateType==='add'"
                                               v-model="quotationForm[field.field_key].value"
                                               :multiple-limit="1"
                                               :placeholder="field.placeholder"
                                               :remote-method="getUserList"
                                               collapse-tags
                                               filterable
                                               multiple
                                               remote
                                               @focus="handleContactSelectFocus"
                                               @remove-tag="handleRemoveContactTag($event,field)">
                                        <el-option v-for="user in userList"
                                                   :key="user.uid"
                                                   :label="user.name"
                                                   :value="user.uid"
                                                   @click.native="handleClickContactItem(user,field)">
                                        </el-option>
                                    </el-select>
                                    <div v-else
                                         class="detail_field_value"
                                         v-text="quotationForm[field.field_key].text&&quotationForm[field.field_key].text.length?quotationForm[field.field_key].text[0].name:''"></div>
                                </div>
                            </div>
                        </template>
                        <template v-else-if="field.field_type==='radio_customer'">
                            <div class="input_field_wrap">
                                <div class="field_label_wrap">
                                    <div class="field_name" v-text="field.field_name"></div>
                                </div>
                                <div class="field_value_wrap">
                                    <div class="customer_contact_select_wrap">
                                        <el-select :key="field.field_key"
                                                   v-model="quotationForm[field.field_key].value"
                                                   :disabled="templateType!=='add'"
                                                   :placeholder="field.extend.placeholder"
                                                   :remote-method="query=>getCustomerList(query,field)"
                                                   filterable
                                                   remote
                                                   @focus="handleRelateCustomerRadioFocus(field)">
                                            <el-option v-for="item in field.extend.options"
                                                       :key="item.id"
                                                       :label="item.name.value"
                                                       :value="item.id"
                                                       @click.native="handleClickRelateCustomerRadio(item,field)"></el-option>
                                        </el-select>
                                        <i v-if="templateType==='add'"
                                           class="el-icon-circle-plus"
                                           @click="handleClickAddRelateForm(field,'customers')"></i>
                                    </div>
                                </div>
                            </div>
                        </template>
                        <template v-else-if="field.field_type==='customer_contact'">
                            <div class="input_field_wrap">
                                <div class="field_label_wrap">
                                    <div class="field_name" v-text="field.field_name"></div>
                                </div>
                                <div class="field_value_wrap">
                                    <div v-if="templateType==='add'" class="customer_contact_select_wrap">
                                        <el-select :ref="`customer_contact_select_${field.field_key}`"
                                                   v-model="quotationForm[field.field_key].value"
                                                   :multiple-limit="1"
                                                   :placeholder="quotationForm.customer_id && quotationForm.customer_id.value === ''?'请先选择关联客户':field.placeholder"
                                                   clearable
                                                   multiple
                                                   @focus="handleCustomerContactSelectFocus(field)"
                                                   @remove-tag="handleRemoveCustomerContactSelectTag">
                                            <el-option v-for="item in field.options"
                                                       :label="item.name"
                                                       :value="item.id"
                                                       @click.native="handleSelectCustomerContact(item)"></el-option>
                                        </el-select>
                                        <i class="el-icon-circle-plus"
                                           @click="handleClickAddRelateForm(field,'customer_contacts')"></i>
                                    </div>
                                    <div v-else class="detail_field_value"
                                         v-text="quotationForm[field.field_key].text&&quotationForm[field.field_key].text.length?quotationForm[field.field_key].text[0].name:''"></div>
                                </div>
                            </div>
                        </template>
                        <template v-else-if="field.field_type==='telephone'">
                            <div class="input_field_wrap">
                                <div class="field_label_wrap">
                                    <div class="field_name" v-text="field.field_name"></div>
                                </div>
                                <div class="field_value_wrap">
                                    <el-input v-model="quotationForm[field.field_key].value"
                                              :disabled="templateType!=='add'"
                                              :placeholder="field.is_system===1?field.extend.placeholder:'请输入'+field.field_name"
                                              autosize
                                              type="textarea">
                                    </el-input>
                                </div>
                            </div>
                        </template>
                        <template v-else-if="field.field_type==='date'">
                            <div class="input_field_wrap">
                                <div class="field_label_wrap">
                                    <div class="field_name" v-text="field.field_name"></div>
                                </div>
                                <div class="field_value_wrap">
                                    <el-date-picker :ref="'date_picker_'+field.field_key"
                                                    v-model="quotationForm[field.field_key].value"
                                                    v-if="templateType==='add'"
                                                    :editable="false"
                                                    :placeholder="field.extend.placeholder"
                                                    format="yyyy年MM月dd日"
                                                    type="date"
                                                    value-format="yyyy-MM-dd"
                                                    @change="handleSelectDateChange(field)">
                                    </el-date-picker>
                                    <div v-else class="detail_field_value"
                                         v-text="quotationForm[field.field_key].value"></div>
                                </div>
                            </div>
                        </template>
                        <template v-else-if="field.field_type==='explain'">
                            <div class="explain_field_wrap">
                                <div v-if="templateType==='detail'||field.is_system===1"
                                     class="explain_field"
                                     v-text="field.field_name"></div>
                                <el-input v-else
                                          v-model="field.field_name"
                                          maxlength="15"
                                          placeholder="请输入标题"></el-input>
                            </div>
                        </template>
                        <template v-else-if="field.field_type==='goods'">
                            <div>
                                <el-table :data="quotationForm[field.field_key]" border>
                                    <el-table-column align="center" label="序号" type="index"
                                                     width="50"></el-table-column>
                                    <el-table-column v-for="child in field._child"
                                                     :align="child.field_type==='money'||child.field_type==='number'||child.field_type==='money_compute_mode'?'right':'left'"
                                                     :min-width="child.extend.table_width">
                                        <template slot="header" slot-scope="{row}">
                                            <div v-if="child.field_type==='money'" class="table_header_wrap">
                                                <span v-text="child.field_name"></span>
                                                <el-select v-model="currency"
                                                           :disabled="templateType!=='add'"
                                                           placeholder="请选择币种"
                                                           size="mini"
                                                           @change="handlePriceUnitChange">
                                                    <el-option key="CNY" label="人民币" value="CNY"></el-option>
                                                    <el-option key="USD" label="美元" value="USD"></el-option>
                                                </el-select>
                                            </div>
                                            <span v-else v-text="child.field_name"></span>
                                        </template>
                                        <template slot-scope="{row}">
                                            <div v-if="child.field_type==='input'" class="table_input_field_wrap">
                                                <el-input v-model="row[child.field_key]"
                                                          :disabled="templateType!=='add'"
                                                          autosize
                                                          placeholder="请输入"
                                                          type="textarea">
                                                </el-input>
                                                <div v-if="child.field_key==='goods_name'&&templateType==='add'"
                                                     class="handle_icon_wrap"
                                                     @click="handleClickSelectProject(row,child)">
                                                    <i class="iconfont icon-cangku1"></i>
                                                </div>
                                            </div>
                                            <div v-else-if="child.field_type==='money'">
                                                <el-input v-model="row[child.field_key].text"
                                                          :disabled="templateType!=='add'"
                                                          autosize
                                                          placeholder="请输入"
                                                          type="textarea"
                                                          @blur="handlePriceInputBlur(child,row)">
                                                </el-input>
                                            </div>
                                            <div v-else-if="child.field_type==='number'">
                                                <el-input v-model="row[child.field_key]"
                                                          :disabled="templateType!=='add'"
                                                          autosize
                                                          placeholder="请输入"
                                                          type="textarea"
                                                          @blur="handleNumberInputBlur(child,row)">
                                                </el-input>
                                            </div>
                                            <div v-else-if="child.field_type==='money_compute_mode'">
                                                <el-input v-model="row[child.field_key].text"
                                                          autosize
                                                          placeholder="自动计算"
                                                          readonly
                                                          type="textarea">
                                                </el-input>
                                            </div>
                                            <div v-else-if="child.field_type==='textarea'">
                                                <el-input v-model="row[child.field_key]"
                                                          :disabled="templateType!=='add'"
                                                          autosize
                                                          placeholder="请输入"
                                                          type="textarea">
                                                </el-input>
                                            </div>
                                        </template>
                                    </el-table-column>
                                </el-table>
                            </div>
                        </template>
                        <template v-else-if="field.field_type==='money_compute_mode'">
                            <div class="total_price_wrap">总计：<span
                                    v-text="quotationForm[field.field_key].text"></span></div>
                        </template>
                        <div v-if="templateType!=='detail'&&!field.extend.hasOwnProperty('handle_icon_show')&&handleIconIsShow(index)"
                             class="field_handle_icon_wrap">
                            <div class="remove_icon_wrap">
                                <i v-if="field.is_system===0||(field.field_type==='goods'&&quotationForm[field.field_key].length>1)"
                                   class="el-icon-remove"
                                   @click="handleClickDelTemplateField(field,index)"></i>
                            </div>
                            <div class="plus_icon_wrap">
                                <i class="el-icon-circle-plus" @click="handleClickAddTemplateField(field,index)"></i>
                            </div>
                        </div>
                    </div>
                </draggable>
            </div>
        </div>
        <div v-else-if="project_quotation_tmpl_form==='project_quotation_tmpl_2'"
             ref="project_quotation_tmpl_2"
             class="template_2_wrap">
            <div class="template_header_wrap">
                <div class="quotation_title">
                    <el-input v-if="templateType==='add'"
                              v-model="quotationForm.title"
                              maxlength="20"
                              placeholder="请输入标题"
                              size="small"></el-input>
                    <span v-else v-text="quotationForm.title"></span>
                </div>
                <div :class="{'no_border':quotationForm.company_logo!==''}"
                     class="logo_wrap"
                     @click="handleClickUploadLogo">
                    <img v-if="quotationForm.company_logo" :src="quotationForm.company_logo" alt=""
                         class="logo">
                    <div v-else class="upload_text">点击上传LOGO</div>
                </div>
            </div>
            <div class="template_content_wrap">
                <draggable :animation="300"
                           :disabled="templateType==='detail'"
                           :list="templateFieldsList"
                           :move="onDragFormItemMove"
                           class="form_module_content_wrap"
                           filter=".is_can_not_drag"
                           @end="onDragFormItemEnd">
                    <div v-for="(field,index) in templateFieldsList"
                         :class="{'col_span_24':field.extend.col_span===24,
                                     'is_can_not_drag':field.extend.hasOwnProperty('can_draggable'),
                                     'top_three_field':index<=2,
                                     'the_fifth_field':index===2}"
                         :style="{'padding':field.field_type==='goods'||field.field_type==='money_compute_mode'?'0':'4px 24px'}"
                         class="template_field_item_wrap">
                        <template v-if="field.field_type==='input'">
                            <div class="input_field_wrap">
                                <div class="field_label_wrap">
                                    <el-input v-model="field.field_name"
                                              :disabled="templateType==='detail'||field.is_system===1"
                                              autosize
                                              maxlength="10"
                                              :placeholder="templateType=='add'?'请输入标题':''"
                                              type="textarea"></el-input>
                                </div>
                                <div class="field_value_wrap">
                                    <div v-if="field.field_key==='project_name'">
                                        <el-popover v-model="projectListVisible"
                                                    placement="bottom"
                                                    popper-class="project_list_popover"
                                                    trigger="manual"
                                                    width="300">
                                            <el-input slot="reference"
                                                      v-model="quotationForm[field.field_key].value"
                                                      :disabled="templateType!=='add'"
                                                      :placeholder="field.is_system===1?field.extend.placeholder:'请输入'+field.field_name"
                                                      autosize
                                                      type="textarea"
                                                      @input="handleProjectNameInput(field)">
                                            </el-input>
                                            <ul class="project_list">
                                                <li v-for="item in projectList"
                                                    :key="item.project_id"
                                                    class="project_item"
                                                    @click="handleClickProjectName(item,field)"
                                                    v-text="item.name.value"></li>
                                            </ul>
                                        </el-popover>
                                    </div>
                                    <el-input v-model="quotationForm[field.field_key].value"
                                              v-else
                                              :disabled="templateType!=='add'"
                                              :placeholder="templateType=='add'?field.is_system===1?field.extend.placeholder:'请输入'+field.field_name:''"
                                              autosize
                                              type="textarea">
                                    </el-input>
                                </div>
                            </div>
                        </template>
                        <template v-else-if="field.field_type==='textarea'">
                            <div class="textarea_field_label">
                                <div v-if="field.is_system===1" class="field_name" v-text="field.field_name"></div>
                                <el-input v-else v-model="field.field_name" placeholder="请输入标题"></el-input>
                            </div>
                            <div class="textarea_field_value">
                                <el-input v-model="quotationForm[field.field_key].value"
                                          v-if="templateType==='add'"
                                          :autosize="{ minRows: 2, maxRows: 10000}"
                                          :placeholder="field.is_system===1?field.extend.placeholder:'请输入'+field.field_name"
                                          autosize
                                          type="textarea">
                                </el-input>
                                <div v-else class="detail_field_value"
                                     v-text="quotationForm[field.field_key].value"></div>
                            </div>
                        </template>
                        <template v-else-if="field.field_type==='contact'">
                            <div class="input_field_wrap">
                                <div class="field_label_wrap">
                                    <div class="field_name" v-text="field.field_name"></div>
                                </div>
                                <div class="field_value_wrap">
                                    <el-select :ref="`${field.field_key}_contact_select`"
                                               v-if="templateType==='add'"
                                               v-model="quotationForm[field.field_key].value"
                                               :multiple-limit="1"
                                               :placeholder="field.placeholder"
                                               :remote-method="getUserList"
                                               collapse-tags
                                               filterable
                                               multiple
                                               remote
                                               @focus="handleContactSelectFocus"
                                               @remove-tag="handleRemoveContactTag($event,field)">
                                        <el-option v-for="user in userList"
                                                   :key="user.uid"
                                                   :label="user.name"
                                                   :value="user.uid"
                                                   @click.native="handleClickContactItem(user,field)">
                                        </el-option>
                                    </el-select>
                                    <div v-else
                                         class="detail_field_value"
                                         v-text="quotationForm[field.field_key].text&&quotationForm[field.field_key].text.length?quotationForm[field.field_key].text[0].name:''"></div>
                                </div>
                            </div>
                        </template>
                        <template v-else-if="field.field_type==='radio_customer'">
                            <div class="input_field_wrap">
                                <div class="field_label_wrap">
                                    <div class="field_name" v-text="field.field_name"></div>
                                </div>
                                <div class="field_value_wrap">
                                    <div class="customer_contact_select_wrap">
                                        <el-select :key="field.field_key"
                                                   v-model="quotationForm[field.field_key].value"
                                                   :disabled="templateType!=='add'"
                                                   :placeholder="field.extend.placeholder"
                                                   :remote-method="query=>getCustomerList(query,field)"
                                                   filterable
                                                   remote
                                                   @focus="handleRelateCustomerRadioFocus(field)">
                                            <el-option v-for="item in field.extend.options"
                                                       :key="item.id"
                                                       :label="item.name.value"
                                                       :value="item.id"
                                                       @click.native="handleClickRelateCustomerRadio(item,field)"></el-option>
                                        </el-select>
                                        <i v-if="templateType==='add'"
                                           class="el-icon-circle-plus"
                                           @click="handleClickAddRelateForm(field,'customers')"></i>
                                    </div>
                                </div>
                            </div>
                        </template>
                        <template v-else-if="field.field_type==='customer_contact'">
                            <div class="input_field_wrap">
                                <div class="field_label_wrap">
                                    <div class="field_name" v-text="field.field_name"></div>
                                </div>
                                <div class="field_value_wrap">
                                    <div v-if="templateType==='add'" class="customer_contact_select_wrap">
                                        <el-select :ref="`customer_contact_select_${field.field_key}`"
                                                   v-model="quotationForm[field.field_key].value"
                                                   :multiple-limit="1"
                                                   :placeholder="quotationForm.customer_id && quotationForm.customer_id.value === ''?'请先选择关联客户':field.placeholder"
                                                   clearable
                                                   multiple
                                                   @focus="handleCustomerContactSelectFocus(field)"
                                                   @remove-tag="handleRemoveCustomerContactSelectTag">
                                            <el-option v-for="item in field.options"
                                                       :label="item.name"
                                                       :value="item.id"
                                                       @click.native="handleSelectCustomerContact(item)"></el-option>
                                        </el-select>
                                        <i class="el-icon-circle-plus"
                                           @click="handleClickAddRelateForm(field,'customer_contacts')"></i>
                                    </div>
                                    <div v-else class="detail_field_value"
                                         v-text="quotationForm[field.field_key].text&&quotationForm[field.field_key].text.length?quotationForm[field.field_key].text[0].name:''"></div>
                                </div>
                            </div>
                        </template>
                        <template v-else-if="field.field_type==='telephone'">
                            <div class="input_field_wrap">
                                <div class="field_label_wrap">
                                    <div class="field_name" v-text="field.field_name"></div>
                                </div>
                                <div class="field_value_wrap">
                                    <el-input v-model="quotationForm[field.field_key].value"
                                              :disabled="templateType!=='add'"
                                              :placeholder="field.is_system===1?field.extend.placeholder:'请输入'+field.field_name"
                                              autosize
                                              type="textarea">
                                    </el-input>
                                </div>
                            </div>
                        </template>
                        <template v-else-if="field.field_type==='date'">
                            <div class="input_field_wrap">
                                <div class="field_label_wrap">
                                    <div class="field_name" v-text="field.field_name"></div>
                                </div>
                                <div class="field_value_wrap">
                                    <el-date-picker :ref="'date_picker_'+field.field_key"
                                                    v-model="quotationForm[field.field_key].value"
                                                    v-if="templateType==='add'"
                                                    :editable="false"
                                                    :placeholder="field.extend.placeholder"
                                                    format="yyyy年MM月dd日"
                                                    type="date"
                                                    value-format="yyyy-MM-dd"
                                                    @change="handleSelectDateChange(field)">
                                    </el-date-picker>
                                    <div v-else class="detail_field_value"
                                         v-text="quotationForm[field.field_key].value"></div>
                                </div>
                            </div>
                        </template>
                        <template v-else-if="field.field_type==='explain'">
                            <div class="explain_field_wrap">
                                <div v-if="templateType==='detail'||field.is_system===1"
                                     class="explain_field"
                                     v-text="field.field_name"></div>
                                <el-input v-else
                                          v-model="field.field_name"
                                          maxlength="15"
                                          placeholder="请输入标题"></el-input>
                            </div>
                        </template>
                        <template v-else-if="field.field_type==='goods'">
                            <div>
                                <el-table :data="quotationForm[field.field_key]" border>
                                    <el-table-column align="center" label="序号" type="index"
                                                     width="50"></el-table-column>
                                    <el-table-column v-for="child in field._child"
                                                     :align="child.field_type==='money'||child.field_type==='number'||child.field_type==='money_compute_mode'?'right':'left'"
                                                     :min-width="child.extend.table_width">
                                        <template slot="header" slot-scope="{row}">
                                            <div v-if="child.field_type==='money'" class="table_header_wrap">
                                                <span v-text="child.field_name"></span>
                                                <el-select v-model="currency"
                                                           :disabled="templateType!=='add'"
                                                           placeholder="请选择币种"
                                                           size="mini"
                                                           @change="handlePriceUnitChange">
                                                    <el-option key="CNY" label="人民币" value="CNY"></el-option>
                                                    <el-option key="USD" label="美元" value="USD"></el-option>
                                                </el-select>
                                            </div>
                                            <span v-else v-text="child.field_name"></span>
                                        </template>
                                        <template slot-scope="{row}">
                                            <div v-if="child.field_type==='input'" class="table_input_field_wrap">
                                                <el-input v-model="row[child.field_key]"
                                                          :disabled="templateType!=='add'"
                                                          autosize
                                                          placeholder="请输入"
                                                          type="textarea">
                                                </el-input>
                                                <div v-if="child.field_key==='goods_name'&&templateType==='add'"
                                                     class="handle_icon_wrap"
                                                     @click="handleClickSelectProject(row,child)">
                                                    <i class="iconfont icon-cangku1"></i>
                                                </div>
                                            </div>
                                            <div v-else-if="child.field_type==='money'">
                                                <el-input v-model="row[child.field_key].text"
                                                          :disabled="templateType!=='add'"
                                                          autosize
                                                          placeholder="请输入"
                                                          type="textarea"
                                                          @blur="handlePriceInputBlur(child,row)">
                                                </el-input>
                                            </div>
                                            <div v-else-if="child.field_type==='number'">
                                                <el-input v-model="row[child.field_key]"
                                                          :disabled="templateType!=='add'"
                                                          autosize
                                                          placeholder="请输入"
                                                          type="textarea"
                                                          @blur="handleNumberInputBlur(child,row)">
                                                </el-input>
                                            </div>
                                            <div v-else-if="child.field_type==='money_compute_mode'">
                                                <el-input v-model="row[child.field_key].text"
                                                          autosize
                                                          placeholder="自动计算"
                                                          readonly
                                                          type="textarea">
                                                </el-input>
                                            </div>
                                            <div v-else-if="child.field_type==='textarea'">
                                                <el-input v-model="row[child.field_key]"
                                                          :disabled="templateType!=='add'"
                                                          autosize
                                                          placeholder="请输入"
                                                          type="textarea">
                                                </el-input>
                                            </div>
                                        </template>
                                    </el-table-column>
                                </el-table>
                            </div>
                        </template>
                        <template v-else-if="field.field_type==='money_compute_mode'">
                            <div class="total_price_wrap">总计：<span
                                    v-text="quotationForm[field.field_key].text"></span></div>
                        </template>
                        <div v-if="templateType!=='detail'&&!field.extend.hasOwnProperty('handle_icon_show')&&handleIconIsShow(index)"
                             class="field_handle_icon_wrap">
                            <div class="remove_icon_wrap">
                                <i v-if="field.is_system===0||(field.field_type==='goods'&&quotationForm[field.field_key].length>1)"
                                   class="el-icon-remove"
                                   @click="handleClickDelTemplateField(field,index)"></i>
                            </div>
                            <div class="plus_icon_wrap">
                                <i class="el-icon-circle-plus" @click="handleClickAddTemplateField(field,index)"></i>
                            </div>
                        </div>
                    </div>
                </draggable>
            </div>
        </div>
        <div v-else-if="project_quotation_tmpl_form==='project_quotation_tmpl_3'"
             ref="project_quotation_tmpl_3"
             class="template_3_wrap">
            <div class="template_header_wrap">
                <div class="header_inner_wrap">
                    <div class="quotation_title">
                        <el-input v-if="templateType==='add'"
                                  v-model="quotationForm.title"
                                  maxlength="20"
                                  placeholder="请输入标题"
                                  size="small"></el-input>
                        <span v-else v-text="quotationForm.title"></span>
                    </div>
                    <div :class="{'no_border':quotationForm.company_logo!==''}"
                         class="logo_wrap"
                         @click="handleClickUploadLogo">
                        <img v-if="quotationForm.company_logo" :src="quotationForm.company_logo" alt=""
                             class="logo">
                        <div v-else class="upload_text">点击上传LOGO</div>
                    </div>
                </div>
            </div>
            <div class="template_content_wrap">
                <draggable :animation="300"
                           :disabled="templateType==='detail'"
                           :list="templateFieldsList"
                           :move="onDragFormItemMove"
                           class="form_module_content_wrap"
                           filter=".is_can_not_drag"
                           @end="onDragFormItemEnd">
                    <div v-for="(field,index) in templateFieldsList"
                         :class="{'col_span_24':field.extend.col_span===24}"
                         class="template_field_item_wrap">
                        <template v-if="field.field_type==='input'">
                            <div class="input_field_wrap">
                                <div class="field_label_wrap">
                                    <el-input v-model="field.field_name"
                                              :disabled="templateType==='detail'||field.is_system===1"
                                              autosize
                                              maxlength="10"
                                              :placeholder="templateType=='add'?'请输入标题':''"
                                              type="textarea"></el-input>
                                </div>
                                <div class="field_value_wrap">
                                    <div v-if="field.field_key==='project_name'">
                                        <el-popover v-model="projectListVisible"
                                                    placement="bottom"
                                                    popper-class="project_list_popover"
                                                    trigger="manual"
                                                    width="300">
                                            <el-input slot="reference"
                                                      v-model="quotationForm[field.field_key].value"
                                                      :disabled="templateType!=='add'"
                                                      :placeholder="field.is_system===1?field.extend.placeholder:'请输入'+field.field_name"
                                                      autosize
                                                      type="textarea"
                                                      @input="handleProjectNameInput(field)">
                                            </el-input>
                                            <ul class="project_list">
                                                <li v-for="item in projectList"
                                                    :key="item.project_id"
                                                    class="project_item"
                                                    @click="handleClickProjectName(item,field)"
                                                    v-text="item.name.value"></li>
                                            </ul>
                                        </el-popover>
                                    </div>
                                    <el-input v-model="quotationForm[field.field_key].value"
                                              v-else
                                              :disabled="templateType!=='add'"
                                              :placeholder="templateType=='add'?field.is_system===1?field.extend.placeholder:'请输入'+field.field_name:''"
                                              autosize
                                              type="textarea">
                                    </el-input>
                                </div>
                            </div>
                        </template>
                        <template v-else-if="field.field_type==='textarea'">
                            <div class="textarea_field_wrap">
                                <div class="textarea_field_label">
                                    <div v-if="field.is_system===1" class="field_name" v-text="field.field_name"></div>
                                    <el-input v-else v-model="field.field_name" placeholder="请输入标题"></el-input>
                                </div>
                                <div class="textarea_field_value">
                                    <el-input v-model="quotationForm[field.field_key].value"
                                              :autosize="{ minRows: 5, maxRows: 10000}"
                                              :placeholder="field.is_system===1?field.extend.placeholder:'请输入'+field.field_name"
                                              autosize
                                              type="textarea">
                                    </el-input>
                                </div>
                            </div>
                        </template>
                        <template v-else-if="field.field_type==='contact'">
                            <div class="input_field_wrap">
                                <div class="field_label_wrap">
                                    <div class="field_name" v-text="field.field_name"></div>
                                </div>
                                <div class="field_value_wrap">
                                    <el-select :ref="`${field.field_key}_contact_select`"
                                               v-if="templateType==='add'"
                                               v-model="quotationForm[field.field_key].value"
                                               :multiple-limit="1"
                                               :placeholder="field.placeholder"
                                               :remote-method="getUserList"
                                               collapse-tags
                                               filterable
                                               multiple
                                               remote
                                               @focus="handleContactSelectFocus"
                                               @remove-tag="handleRemoveContactTag($event,field)">
                                        <el-option v-for="user in userList"
                                                   :key="user.uid"
                                                   :label="user.name"
                                                   :value="user.uid"
                                                   @click.native="handleClickContactItem(user,field)">
                                        </el-option>
                                    </el-select>
                                    <div v-else
                                         class="detail_field_value"
                                         v-text="quotationForm[field.field_key].text&&quotationForm[field.field_key].text.length?quotationForm[field.field_key].text[0].name:''"></div>
                                </div>
                            </div>
                        </template>
                        <template v-else-if="field.field_type==='radio_customer'">
                            <div class="input_field_wrap">
                                <div class="field_label_wrap">
                                    <div class="field_name" v-text="field.field_name"></div>
                                </div>
                                <div class="field_value_wrap">
                                    <div class="customer_contact_select_wrap">
                                        <el-select :key="field.field_key"
                                                   v-model="quotationForm[field.field_key].value"
                                                   :disabled="templateType!=='add'"
                                                   :placeholder="field.extend.placeholder"
                                                   :remote-method="query=>getCustomerList(query,field)"
                                                   filterable
                                                   remote
                                                   @focus="handleRelateCustomerRadioFocus(field)">
                                            <el-option v-for="item in field.extend.options"
                                                       :key="item.id"
                                                       :label="item.name.value"
                                                       :value="item.id"
                                                       @click.native="handleClickRelateCustomerRadio(item,field)"></el-option>
                                        </el-select>
                                        <i v-if="templateType==='add'"
                                           class="el-icon-circle-plus"
                                           @click="handleClickAddRelateForm(field,'customers')"></i>
                                    </div>
                                </div>
                            </div>
                        </template>
                        <template v-else-if="field.field_type==='customer_contact'">
                            <div class="input_field_wrap">
                                <div class="field_label_wrap">
                                    <div class="field_name" v-text="field.field_name"></div>
                                </div>
                                <div class="field_value_wrap">
                                    <div v-if="templateType==='add'" class="customer_contact_select_wrap">
                                        <el-select :ref="`customer_contact_select_${field.field_key}`"
                                                   v-model="quotationForm[field.field_key].value"
                                                   :multiple-limit="1"
                                                   :placeholder="quotationForm.customer_id && quotationForm.customer_id.value === ''?'请先选择关联客户':field.placeholder"
                                                   clearable
                                                   multiple
                                                   @focus="handleCustomerContactSelectFocus(field)"
                                                   @remove-tag="handleRemoveCustomerContactSelectTag">
                                            <el-option v-for="item in field.options"
                                                       :label="item.name"
                                                       :value="item.id"
                                                       @click.native="handleSelectCustomerContact(item)"></el-option>
                                        </el-select>
                                        <i class="el-icon-circle-plus"
                                           @click="handleClickAddRelateForm(field,'customer_contacts')"></i>
                                    </div>
                                    <div v-else class="detail_field_value"
                                         v-text="quotationForm[field.field_key].text&&quotationForm[field.field_key].text.length?quotationForm[field.field_key].text[0].name:''"></div>
                                </div>
                            </div>
                        </template>
                        <template v-else-if="field.field_type==='telephone'">
                            <div class="input_field_wrap">
                                <div class="field_label_wrap">
                                    <div class="field_name" v-text="field.field_name"></div>
                                </div>
                                <div class="field_value_wrap">
                                    <el-input v-model="quotationForm[field.field_key].value"
                                              :disabled="templateType!=='add'"
                                              :placeholder="field.is_system===1?field.extend.placeholder:'请输入'+field.field_name"
                                              autosize
                                              type="textarea">
                                    </el-input>
                                </div>
                            </div>
                        </template>
                        <template v-else-if="field.field_type==='date'">
                            <div class="input_field_wrap">
                                <div class="field_label_wrap">
                                    <div class="field_name" v-text="field.field_name"></div>
                                </div>
                                <div class="field_value_wrap">
                                    <el-date-picker :ref="'date_picker_'+field.field_key"
                                                    v-model="quotationForm[field.field_key].value"
                                                    v-if="templateType==='add'"
                                                    :editable="false"
                                                    :placeholder="field.extend.placeholder"
                                                    format="yyyy年MM月dd日"
                                                    type="date"
                                                    value-format="yyyy-MM-dd"
                                                    @change="handleSelectDateChange(field)">
                                    </el-date-picker>
                                    <div v-else class="detail_field_value"
                                         v-text="quotationForm[field.field_key].value"></div>
                                </div>
                            </div>
                        </template>
                        <template v-else-if="field.field_type==='explain'">
                            <div class="explain_field_wrap">
                                <div v-if="templateType==='detail'||field.is_system===1"
                                     class="explain_field"
                                     v-text="field.field_name"></div>
                                <el-input v-else
                                          v-model="field.field_name"
                                          maxlength="15"
                                          placeholder="请输入标题"></el-input>
                            </div>
                        </template>
                        <template v-else-if="field.field_type==='goods'">
                            <div class="table_field_wrap">
                                <el-table :data="quotationForm[field.field_key]" border>
                                    <el-table-column align="center" label="序号" type="index"
                                                     width="50"></el-table-column>
                                    <el-table-column v-for="child in field._child"
                                                     :width="child.extend.table_width">
                                        <template slot="header" slot-scope="{row}">
                                            <div v-if="child.field_type==='money'" class="table_header_wrap">
                                                <span v-text="child.field_name"></span>
                                                <el-select v-model="currency"
                                                           :disabled="templateType!=='add'"
                                                           placeholder="请选择币种"
                                                           size="mini"
                                                           @change="handlePriceUnitChange">
                                                    <el-option key="CNY" label="人民币" value="CNY"></el-option>
                                                    <el-option key="USD" label="美元" value="USD"></el-option>
                                                </el-select>
                                            </div>
                                            <span v-else v-text="child.field_name"></span>
                                        </template>
                                        <template slot-scope="{row}">
                                            <div v-if="child.field_type==='input'" class="table_input_field_wrap">
                                                <el-input v-model="row[child.field_key]"
                                                          :disabled="templateType!=='add'"
                                                          autosize
                                                          placeholder="请输入"
                                                          type="textarea">
                                                </el-input>
                                                <div v-if="child.field_key==='goods_name'&&templateType==='add'"
                                                     class="handle_icon_wrap"
                                                     @click="handleClickSelectProject(row,child)">
                                                    <i class="iconfont icon-cangku1"></i>
                                                </div>
                                            </div>
                                            <div v-else-if="child.field_type==='money'">
                                                <el-input v-model="row[child.field_key].text"
                                                          :disabled="templateType!=='add'"
                                                          autosize
                                                          placeholder="请输入"
                                                          type="textarea"
                                                          @blur="handlePriceInputBlur(child,row)">
                                                </el-input>
                                            </div>
                                            <div v-else-if="child.field_type==='number'">
                                                <el-input v-model="row[child.field_key]"
                                                          :disabled="templateType!=='add'"
                                                          autosize
                                                          placeholder="请输入"
                                                          type="textarea"
                                                          @blur="handleNumberInputBlur(child,row)">
                                                </el-input>
                                            </div>
                                            <div v-else-if="child.field_type==='money_compute_mode'">
                                                <el-input v-model="row[child.field_key].text"
                                                          autosize
                                                          placeholder="自动计算"
                                                          readonly
                                                          type="textarea">
                                                </el-input>
                                            </div>
                                            <div v-else-if="child.field_type==='textarea'">
                                                <el-input v-model="row[child.field_key]"
                                                          :disabled="templateType!=='add'"
                                                          autosize
                                                          placeholder="请输入"
                                                          type="textarea">
                                                </el-input>
                                            </div>
                                        </template>
                                    </el-table-column>
                                </el-table>
                            </div>
                        </template>
                        <template v-else-if="field.field_type==='money_compute_mode'">
                            <div class="total_price_wrap">总计：<span
                                    v-text="quotationForm[field.field_key].chinese_text||'（大写人民币）'"></span></div>
                        </template>
                        <div v-if="templateType!=='detail'&&!field.extend.hasOwnProperty('handle_icon_show')&&handleIconIsShow(index)"
                             class="field_handle_icon_wrap">
                            <div class="remove_icon_wrap">
                                <i v-if="field.is_system===0||(field.field_type==='goods'&&quotationForm[field.field_key].length>1)"
                                   class="el-icon-remove"
                                   @click="handleClickDelTemplateField(field,index)"></i>
                            </div>
                            <div class="plus_icon_wrap">
                                <i class="el-icon-circle-plus" @click="handleClickAddTemplateField(field,index)"></i>
                            </div>
                        </div>
                    </div>
                </draggable>
            </div>
            <div class="template_footer_wrap"></div>
        </div>
        <div v-else-if="project_quotation_tmpl_form==='project_quotation_tmpl_4'"
             ref="project_quotation_tmpl_4"
             class="template_4_wrap">
            <div class="template_header_wrap">
                <el-input v-if="templateType==='add'"
                          v-model="quotationForm.title"
                          maxlength="20"
                          placeholder="请输入标题"
                          size="small"></el-input>
                <div v-else class="quotation_title" v-text="quotationForm.title"></div>
            </div>
            <div class="template_content_wrap">
                <draggable :animation="300"
                           :disabled="templateType==='detail'"
                           :list="templateFieldsList.slice(0,templateFieldsList.length-5)"
                           :move="onDragFormItemMove"
                           class="form_module_content_wrap"
                           filter=".is_can_not_drag"
                           @end="onDragFormItemEnd">
                    <div v-for="(field,index) in templateFieldsList.slice(0,templateFieldsList.length-5)"
                         :class="{'col_span_24':field.extend.col_span===24}"
                         class="template_field_item_wrap">
                        <template v-if="field.field_type==='input'">
                            <div class="input_field_wrap">
                                <div class="field_label_wrap">
                                    <el-input v-model="field.field_name"
                                              :disabled="templateType==='detail'||field.is_system===1"
                                              autosize
                                              maxlength="10"
                                              :placeholder="templateType=='add'?'请输入标题':''"
                                              type="textarea"></el-input>
                                </div>
                                <div class="field_value_wrap">
                                    <div v-if="field.field_key==='project_name'">
                                        <el-popover v-model="projectListVisible"
                                                    placement="bottom"
                                                    popper-class="project_list_popover"
                                                    trigger="manual"
                                                    width="300">
                                            <el-input slot="reference"
                                                      v-model="quotationForm[field.field_key].value"
                                                      :disabled="templateType!=='add'"
                                                      :placeholder="field.is_system===1?field.extend.placeholder:'请输入'+field.field_name"
                                                      autosize
                                                      type="textarea"
                                                      @input="handleProjectNameInput(field)">
                                            </el-input>
                                            <ul class="project_list">
                                                <li v-for="item in projectList"
                                                    :key="item.project_id"
                                                    class="project_item"
                                                    @click="handleClickProjectName(item,field)"
                                                    v-text="item.name.value"></li>
                                            </ul>
                                        </el-popover>
                                    </div>
                                    <el-input v-model="quotationForm[field.field_key].value"
                                              v-else
                                              :disabled="templateType!=='add'"
                                              :placeholder="templateType=='add'?field.is_system===1?field.extend.placeholder:'请输入'+field.field_name:''"
                                              autosize
                                              type="textarea">
                                    </el-input>
                                </div>
                            </div>
                        </template>
                        <template v-else-if="field.field_type==='textarea'">
                            <div class="textarea_field_wrap">
                                <div class="textarea_field_label">
                                    <div v-if="field.is_system===1" class="field_name" v-text="field.field_name"></div>
                                    <el-input v-else v-model="field.field_name" placeholder="请输入标题"></el-input>
                                </div>
                                <div class="textarea_field_value">
                                    <el-input v-model="quotationForm[field.field_key].value"
                                              v-if="templateType==='add'"
                                              :autosize="{ minRows: 2, maxRows: 10000}"
                                              :placeholder="field.is_system===1?field.extend.placeholder:'请输入'+field.field_name"
                                              autosize
                                              type="textarea">
                                    </el-input>
                                    <div v-else class="detail_field_value"
                                         v-text="quotationForm[field.field_key].value"></div>
                                </div>
                            </div>
                        </template>
                        <template v-else-if="field.field_type==='contact'">
                            <div class="input_field_wrap">
                                <div class="field_label_wrap">
                                    <div class="field_name" v-text="field.field_name"></div>
                                </div>
                                <div class="field_value_wrap">
                                    <el-select :ref="`${field.field_key}_contact_select`"
                                               v-if="templateType==='add'"
                                               v-model="quotationForm[field.field_key].value"
                                               :multiple-limit="1"
                                               :placeholder="field.placeholder"
                                               :remote-method="getUserList"
                                               collapse-tags
                                               filterable
                                               multiple
                                               remote
                                               @focus="handleContactSelectFocus"
                                               @remove-tag="handleRemoveContactTag($event,field)">
                                        <el-option v-for="user in userList"
                                                   :key="user.uid"
                                                   :label="user.name"
                                                   :value="user.uid"
                                                   @click.native="handleClickContactItem(user,field)">
                                        </el-option>
                                    </el-select>
                                    <div v-else
                                         class="detail_field_value"
                                         v-text="quotationForm[field.field_key].text&&quotationForm[field.field_key].text.length?quotationForm[field.field_key].text[0].name:''"></div>
                                </div>
                            </div>
                        </template>
                        <template v-else-if="field.field_type==='radio_customer'">
                            <div class="input_field_wrap">
                                <div class="field_label_wrap">
                                    <div class="field_name" v-text="field.field_name"></div>
                                </div>
                                <div class="field_value_wrap">
                                    <div class="customer_contact_select_wrap">
                                        <el-select :key="field.field_key"
                                                   v-model="quotationForm[field.field_key].value"
                                                   :disabled="templateType!=='add'"
                                                   :placeholder="field.extend.placeholder"
                                                   :remote-method="query=>getCustomerList(query,field)"
                                                   filterable
                                                   remote
                                                   @focus="handleRelateCustomerRadioFocus(field)">
                                            <el-option v-for="item in field.extend.options"
                                                       :key="item.id"
                                                       :label="item.name.value"
                                                       :value="item.id"
                                                       @click.native="handleClickRelateCustomerRadio(item,field)"></el-option>
                                        </el-select>
                                        <i v-if="templateType==='add'"
                                           class="el-icon-circle-plus"
                                           @click="handleClickAddRelateForm(field,'customers')"></i>
                                    </div>
                                </div>
                            </div>
                        </template>
                        <template v-else-if="field.field_type==='customer_contact'">
                            <div class="input_field_wrap">
                                <div class="field_label_wrap">
                                    <div class="field_name" v-text="field.field_name"></div>
                                </div>
                                <div class="field_value_wrap">
                                    <div v-if="templateType==='add'" class="customer_contact_select_wrap">
                                        <el-select :ref="`customer_contact_select_${field.field_key}`"
                                                   v-model="quotationForm[field.field_key].value"
                                                   :multiple-limit="1"
                                                   :placeholder="quotationForm.customer_id && quotationForm.customer_id.value === ''?'请先选择关联客户':field.placeholder"
                                                   clearable
                                                   multiple
                                                   @focus="handleCustomerContactSelectFocus(field)"
                                                   @remove-tag="handleRemoveCustomerContactSelectTag">
                                            <el-option v-for="item in field.options"
                                                       :label="item.name"
                                                       :value="item.id"
                                                       @click.native="handleSelectCustomerContact(item)"></el-option>
                                        </el-select>
                                        <i class="el-icon-circle-plus"
                                           @click="handleClickAddRelateForm(field,'customer_contacts')"></i>
                                    </div>
                                    <div v-else class="detail_field_value"
                                         v-text="quotationForm[field.field_key].text&&quotationForm[field.field_key].text.length?quotationForm[field.field_key].text[0].name:''"></div>
                                </div>
                            </div>
                        </template>
                        <template v-else-if="field.field_type==='telephone'">
                            <div class="input_field_wrap">
                                <div class="field_label_wrap">
                                    <div class="field_name" v-text="field.field_name"></div>
                                </div>
                                <div class="field_value_wrap">
                                    <el-input v-model="quotationForm[field.field_key].value"
                                              :disabled="templateType!=='add'"
                                              :placeholder="field.is_system===1?field.extend.placeholder:'请输入'+field.field_name"
                                              autosize
                                              type="textarea">
                                    </el-input>
                                </div>
                            </div>
                        </template>
                        <template v-else-if="field.field_type==='date'">
                            <div class="input_field_wrap">
                                <div class="field_label_wrap">
                                    <div class="field_name" v-text="field.field_name"></div>
                                </div>
                                <div class="field_value_wrap">
                                    <el-date-picker :ref="'date_picker_'+field.field_key"
                                                    v-model="quotationForm[field.field_key].value"
                                                    v-if="templateType==='add'"
                                                    :editable="false"
                                                    :placeholder="field.extend.placeholder"
                                                    format="yyyy年MM月dd日"
                                                    type="date"
                                                    value-format="yyyy-MM-dd"
                                                    @change="handleSelectDateChange(field)">
                                    </el-date-picker>
                                    <div v-else class="detail_field_value"
                                         v-text="quotationForm[field.field_key].value"></div>
                                </div>
                            </div>
                        </template>
                        <template v-else-if="field.field_type==='explain'">
                            <div class="explain_field_wrap">
                                <div v-if="templateType==='detail'||field.is_system===1"
                                     class="explain_field"
                                     v-text="field.field_name"></div>
                                <el-input v-else
                                          v-model="field.field_name"
                                          maxlength="15"
                                          placeholder="请输入标题"></el-input>
                            </div>
                        </template>
                        <template v-else-if="field.field_type==='goods'">
                            <div class="table_field_wrap">
                                <el-table :data="quotationForm[field.field_key]" border>
                                    <el-table-column align="center" label="序号" type="index"
                                                     width="50"></el-table-column>
                                    <el-table-column v-for="child in field._child"
                                                     :align="child.field_type==='money'||child.field_type==='number'||child.field_type==='money_compute_mode'?'right':'left'"
                                                     :min-width="child.extend.table_width">
                                        <template slot="header" slot-scope="{row}">
                                            <div v-if="child.field_type==='money'" class="table_header_wrap">
                                                <span v-text="child.field_name"></span>
                                                <el-select v-model="currency"
                                                           :disabled="templateType!=='add'"
                                                           placeholder="请选择币种"
                                                           size="mini"
                                                           @change="handlePriceUnitChange">
                                                    <el-option key="CNY" label="人民币" value="CNY"></el-option>
                                                    <el-option key="USD" label="美元" value="USD"></el-option>
                                                </el-select>
                                            </div>
                                            <span v-else v-text="child.field_name"></span>
                                        </template>
                                        <template slot-scope="{row}">
                                            <div v-if="child.field_type==='input'" class="table_input_field_wrap">
                                                <el-input v-model="row[child.field_key]"
                                                          :disabled="templateType!=='add'"
                                                          autosize
                                                          placeholder="请输入"
                                                          type="textarea">
                                                </el-input>
                                                <div v-if="child.field_key==='goods_name'&&templateType==='add'"
                                                     class="handle_icon_wrap"
                                                     @click="handleClickSelectProject(row,child)">
                                                    <i class="iconfont icon-cangku1"></i>
                                                </div>
                                            </div>
                                            <div v-else-if="child.field_type==='money'">
                                                <el-input v-model="row[child.field_key].text"
                                                          :disabled="templateType!=='add'"
                                                          autosize
                                                          placeholder="请输入"
                                                          type="textarea"
                                                          @blur="handlePriceInputBlur(child,row)">
                                                </el-input>
                                            </div>
                                            <div v-else-if="child.field_type==='number'">
                                                <el-input v-model="row[child.field_key]"
                                                          :disabled="templateType!=='add'"
                                                          autosize
                                                          placeholder="请输入"
                                                          type="textarea"
                                                          @blur="handleNumberInputBlur(child,row)">
                                                </el-input>
                                            </div>
                                            <div v-else-if="child.field_type==='money_compute_mode'">
                                                <el-input v-model="row[child.field_key].text"
                                                          autosize
                                                          placeholder="自动计算"
                                                          readonly
                                                          type="textarea">
                                                </el-input>
                                            </div>
                                            <div v-else-if="child.field_type==='textarea'">
                                                <el-input v-model="row[child.field_key].value"
                                                          :disabled="templateType!=='add'"
                                                          autosize
                                                          placeholder="请输入"
                                                          type="textarea">
                                                </el-input>
                                            </div>
                                        </template>
                                    </el-table-column>
                                </el-table>
                            </div>
                        </template>
                        <template v-else-if="field.field_type==='money_compute_mode'">
                            <div class="total_price_wrap">
                                总计：<span v-text="quotationForm[field.field_key].text"></span>
                                <br>
                                大写：<span
                                    v-text="quotationForm[field.field_key].chinese_text?quotationForm[field.field_key].chinese_text:'人民币'"></span>
                            </div>
                        </template>
                        <div v-if="templateType!=='detail'&&!field.extend.hasOwnProperty('handle_icon_show')&&handleIconIsShow(index)"
                             class="field_handle_icon_wrap">
                            <div class="remove_icon_wrap">
                                <i v-if="field.is_system===0||(field.field_type==='goods'&&quotationForm[field.field_key].length>1)"
                                   class="el-icon-remove"
                                   @click="handleClickDelTemplateField(field,index)"></i>
                            </div>
                            <div class="plus_icon_wrap">
                                <i class="el-icon-circle-plus" @click="handleClickAddTemplateField(field,index)"></i>
                            </div>
                        </div>
                    </div>
                </draggable>
            </div>
            <div class="template_footer_wrap">
                <div class="footer_left_wrap">
                    <div :class="{'no_border':quotationForm.company_logo!==''}"
                         class="logo_wrap"
                         @click="handleClickUploadLogo">
                        <img v-if="quotationForm.company_logo" :src="quotationForm.company_logo" alt=""
                             class="logo">
                        <div v-else class="upload_text">点击上传LOGO</div>
                    </div>
                </div>
                <div class="footer_right_wrap">
                    <div class="form_module_content_wrap">
                        <div v-for="(field,index) in templateFieldsList.slice(templateFieldsList.length-5)"
                             :class="{'col_span_24':field.extend.col_span===24}"
                             class="template_field_item_wrap">
                            <template v-if="field.field_type==='input'">
                                <div class="input_field_wrap">
                                    <div class="field_label_wrap">
                                        <el-input v-model="field.field_name"
                                                  :disabled="templateType==='detail'||field.is_system===1"
                                                  autosize
                                                  maxlength="10"
                                                  placeholder="请输入标题"
                                                  type="textarea"></el-input>
                                    </div>
                                    <div class="field_value_wrap">
                                        <el-input v-model="quotationForm[field.field_key].value"
                                                  :disabled="templateType!=='add'"
                                                  :placeholder="field.is_system===1?field.extend.placeholder:'请输入'+field.field_name"
                                                  autosize
                                                  type="textarea">
                                        </el-input>
                                    </div>
                                </div>
                            </template>
                            <template v-else-if="field.field_type==='textarea'">
                                <div class="textarea_field_wrap">
                                    <div class="textarea_field_label">
                                        <div v-if="field.is_system===1" class="field_name"
                                             v-text="field.field_name"></div>
                                        <el-input v-else v-model="field.field_name" placeholder="请输入标题"></el-input>
                                    </div>
                                    <div class="textarea_field_value">
                                        <el-input v-model="quotationForm[field.field_key].value"
                                                  v-if="templateType==='add'"
                                                  :autosize="{ minRows: 2, maxRows: 10000}"
                                                  :placeholder="field.is_system===1?field.extend.placeholder:'请输入'+field.field_name"
                                                  autosize
                                                  type="textarea">
                                        </el-input>
                                        <div v-else class="detail_field_value"
                                             v-text="quotationForm[field.field_key].value"></div>
                                    </div>
                                </div>
                            </template>
                            <template v-else-if="field.field_type==='contact'">
                                <div class="input_field_wrap">
                                    <div class="field_label_wrap">
                                        <div class="field_name" v-text="field.field_name"></div>
                                    </div>
                                    <div class="field_value_wrap">
                                        <el-select :ref="`${field.field_key}_contact_select`"
                                                   v-if="templateType==='add'"
                                                   v-model="quotationForm[field.field_key].value"
                                                   :multiple-limit="1"
                                                   :placeholder="field.placeholder"
                                                   :remote-method="getUserList"
                                                   collapse-tags
                                                   filterable
                                                   multiple
                                                   remote
                                                   @focus="handleContactSelectFocus"
                                                   @remove-tag="handleRemoveContactTag($event,field)">
                                            <el-option v-for="user in userList"
                                                       :key="user.uid"
                                                       :label="user.name"
                                                       :value="user.uid"
                                                       @click.native="handleClickContactItem(user,field)">
                                            </el-option>
                                        </el-select>
                                        <div v-else
                                             class="detail_field_value"
                                             v-text="quotationForm[field.field_key].text&&quotationForm[field.field_key].text.length?quotationForm[field.field_key].text[0].name:''"></div>
                                    </div>
                                </div>
                            </template>
                            <template v-else-if="field.field_type==='telephone'">
                                <div class="input_field_wrap">
                                    <div class="field_label_wrap">
                                        <div class="field_name" v-text="field.field_name"></div>
                                    </div>
                                    <div class="field_value_wrap">
                                        <el-input v-model="quotationForm[field.field_key].value"
                                                  :disabled="templateType!=='add'"
                                                  :placeholder="field.is_system===1?field.extend.placeholder:'请输入'+field.field_name"
                                                  autosize
                                                  type="textarea">
                                        </el-input>
                                    </div>
                                </div>
                            </template>
                            <template v-else-if="field.field_type==='date'">
                                <div class="input_field_wrap">
                                    <div class="field_label_wrap">
                                        <div class="field_name" v-text="field.field_name"></div>
                                    </div>
                                    <div class="field_value_wrap">
                                        <el-date-picker :ref="'date_picker_'+field.field_key"
                                                        v-model="quotationForm[field.field_key].value"
                                                        v-if="templateType==='add'"
                                                        :editable="false"
                                                        :placeholder="field.extend.placeholder"
                                                        format="yyyy年MM月dd日"
                                                        type="date"
                                                        value-format="yyyy-MM-dd"
                                                        @change="handleSelectDateChange(field)">
                                        </el-date-picker>
                                        <div v-else class="detail_field_value"
                                             v-text="quotationForm[field.field_key].value"></div>
                                    </div>
                                </div>
                            </template>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div v-else-if="project_quotation_tmpl_form==='project_quotation_tmpl_5'"
             ref="project_quotation_tmpl_5"
             class="template_5_wrap">
            <div class="template_header_wrap">
                <div class="quotation_title">
                    <el-input v-if="templateType==='add'"
                              v-model="quotationForm.title"
                              maxlength="20"
                              placeholder="请输入标题"
                              size="small"></el-input>
                    <span v-else class="quotation_title" v-text="quotationForm.title"></span>
                </div>
                <div class="logo_wrap"
                     @click="handleClickUploadLogo">
                    <img v-if="quotationForm.company_logo" :src="quotationForm.company_logo" alt=""
                         class="logo">
                    <div v-else class="upload_text">点击上传LOGO</div>
                </div>
            </div>
            <div class="template_content_wrap">
                <draggable :animation="300"
                           :disabled="templateType==='detail'"
                           :list="templateFieldsList"
                           :move="onDragFormItemMove"
                           class="form_module_content_wrap"
                           filter=".is_can_not_drag"
                           @end="onDragFormItemEnd">
                    <div v-for="(field,index) in templateFieldsList"
                         :class="{'col_span_24':field.extend.col_span===24,'mb_0':field.field_type==='goods'}"
                         class="template_field_item_wrap">
                        <template v-if="field.field_type==='input'">
                            <div class="input_field_wrap">
                                <div class="field_label_wrap">
                                    <el-input v-model="field.field_name"
                                              :disabled="templateType==='detail'||field.is_system===1"
                                              autosize
                                              maxlength="10"
                                              :placeholder="templateType=='add'?'请输入标题':''"
                                              type="textarea"></el-input>
                                </div>
                                <div class="field_value_wrap">
                                    <div v-if="field.field_key==='project_name'">
                                        <el-popover v-model="projectListVisible"
                                                    placement="bottom"
                                                    popper-class="project_list_popover"
                                                    trigger="manual"
                                                    width="300">
                                            <el-input slot="reference"
                                                      v-model="quotationForm[field.field_key].value"
                                                      :disabled="templateType!=='add'"
                                                      :placeholder="field.is_system===1?field.extend.placeholder:'请输入'+field.field_name"
                                                      autosize
                                                      type="textarea"
                                                      @input="handleProjectNameInput(field)">
                                            </el-input>
                                            <ul class="project_list">
                                                <li v-for="item in projectList"
                                                    :key="item.project_id"
                                                    class="project_item"
                                                    @click="handleClickProjectName(item,field)"
                                                    v-text="item.name.value"></li>
                                            </ul>
                                        </el-popover>
                                    </div>
                                    <el-input v-model="quotationForm[field.field_key].value"
                                              v-else
                                              :disabled="templateType!=='add'"
                                              :placeholder="templateType=='add'?field.is_system===1?field.extend.placeholder:'请输入'+field.field_name:''"
                                              autosize
                                              type="textarea">
                                    </el-input>
                                </div>
                            </div>
                        </template>
                        <template v-else-if="field.field_type==='textarea'">
                            <div class="textarea_field_wrap">
                                <div class="textarea_field_label">
                                    <div v-if="field.is_system===1" class="field_name" v-text="field.field_name"></div>
                                    <el-input v-else v-model="field.field_name" placeholder="请输入标题"></el-input>
                                </div>
                                <div class="textarea_field_value">
                                    <el-input v-model="quotationForm[field.field_key].value"
                                              v-if="templateType==='add'"
                                              :autosize="{ minRows: 2, maxRows: 10000}"
                                              :placeholder="field.is_system===1?field.extend.placeholder:'请输入'+field.field_name"
                                              autosize
                                              type="textarea">
                                    </el-input>
                                    <div v-else class="detail_field_value"
                                         v-text="quotationForm[field.field_key].value"></div>
                                </div>
                            </div>
                        </template>
                        <template v-else-if="field.field_type==='contact'">
                            <div class="input_field_wrap">
                                <div class="field_label_wrap">
                                    <div class="field_name" v-text="field.field_name"></div>
                                </div>
                                <div class="field_value_wrap">
                                    <el-select :ref="`${field.field_key}_contact_select`"
                                               v-if="templateType==='add'"
                                               v-model="quotationForm[field.field_key].value"
                                               :multiple-limit="1"
                                               :placeholder="field.placeholder"
                                               :remote-method="getUserList"
                                               collapse-tags
                                               filterable
                                               multiple
                                               remote
                                               @focus="handleContactSelectFocus"
                                               @remove-tag="handleRemoveContactTag($event,field)">
                                        <el-option v-for="user in userList"
                                                   :key="user.uid"
                                                   :label="user.name"
                                                   :value="user.uid"
                                                   @click.native="handleClickContactItem(user,field)">
                                        </el-option>
                                    </el-select>
                                    <div v-else
                                         class="detail_field_value"
                                         v-text="quotationForm[field.field_key].text&&quotationForm[field.field_key].text.length?quotationForm[field.field_key].text[0].name:''"></div>
                                </div>
                            </div>
                        </template>
                        <template v-else-if="field.field_type==='radio_customer'">
                            <div class="input_field_wrap">
                                <div class="field_label_wrap">
                                    <div class="field_name" v-text="field.field_name"></div>
                                </div>
                                <div class="field_value_wrap">
                                    <div class="customer_contact_select_wrap">
                                        <el-select :key="field.field_key"
                                                   v-model="quotationForm[field.field_key].value"
                                                   :disabled="templateType!=='add'"
                                                   :placeholder="field.extend.placeholder"
                                                   :remote-method="query=>getCustomerList(query,field)"
                                                   filterable
                                                   remote
                                                   @focus="handleRelateCustomerRadioFocus(field)">
                                            <el-option v-for="item in field.extend.options"
                                                       :key="item.id"
                                                       :label="item.name.value"
                                                       :value="item.id"
                                                       @click.native="handleClickRelateCustomerRadio(item,field)"></el-option>
                                        </el-select>
                                        <i v-if="templateType==='add'"
                                           class="el-icon-circle-plus"
                                           @click="handleClickAddRelateForm(field,'customers')"></i>
                                    </div>
                                </div>
                            </div>
                        </template>
                        <template v-else-if="field.field_type==='customer_contact'">
                            <div class="input_field_wrap">
                                <div class="field_label_wrap">
                                    <div class="field_name" v-text="field.field_name"></div>
                                </div>
                                <div class="field_value_wrap">
                                    <div v-if="templateType==='add'" class="customer_contact_select_wrap">
                                        <el-select :ref="`customer_contact_select_${field.field_key}`"
                                                   v-model="quotationForm[field.field_key].value"
                                                   :multiple-limit="1"
                                                   :placeholder="quotationForm.customer_id && quotationForm.customer_id.value === ''?'请先选择关联客户':field.placeholder"
                                                   clearable
                                                   multiple
                                                   @focus="handleCustomerContactSelectFocus(field)"
                                                   @remove-tag="handleRemoveCustomerContactSelectTag">
                                            <el-option v-for="item in field.options"
                                                       :label="item.name"
                                                       :value="item.id"
                                                       @click.native="handleSelectCustomerContact(item)"></el-option>
                                        </el-select>
                                        <i class="el-icon-circle-plus"
                                           @click="handleClickAddRelateForm(field,'customer_contacts')"></i>
                                    </div>
                                    <div v-else class="detail_field_value"
                                         v-text="quotationForm[field.field_key].text&&quotationForm[field.field_key].text.length?quotationForm[field.field_key].text[0].name:''"></div>
                                </div>
                            </div>
                        </template>
                        <template v-else-if="field.field_type==='telephone'">
                            <div class="input_field_wrap">
                                <div class="field_label_wrap">
                                    <div class="field_name" v-text="field.field_name"></div>
                                </div>
                                <div class="field_value_wrap">
                                    <el-input v-model="quotationForm[field.field_key].value"
                                              :disabled="templateType!=='add'"
                                              :placeholder="field.is_system===1?field.extend.placeholder:'请输入'+field.field_name"
                                              autosize
                                              type="textarea">
                                    </el-input>
                                </div>
                            </div>
                        </template>
                        <template v-else-if="field.field_type==='date'">
                            <div class="input_field_wrap">
                                <div class="field_label_wrap">
                                    <div class="field_name" v-text="field.field_name"></div>
                                </div>
                                <div class="field_value_wrap">
                                    <el-date-picker :ref="'date_picker_'+field.field_key"
                                                    v-model="quotationForm[field.field_key].value"
                                                    v-if="templateType==='add'"
                                                    :editable="false"
                                                    :placeholder="field.extend.placeholder"
                                                    format="yyyy年MM月dd日"
                                                    type="date"
                                                    value-format="yyyy-MM-dd"
                                                    @change="handleSelectDateChange(field)">
                                    </el-date-picker>
                                    <div v-else class="detail_field_value"
                                         v-text="quotationForm[field.field_key].value"></div>
                                </div>
                            </div>
                        </template>
                        <template v-else-if="field.field_type==='explain'">
                            <div class="explain_field_wrap">
                                <div v-if="templateType==='detail'||field.is_system===1"
                                     class="explain_field"
                                     v-text="field.field_name"></div>
                                <el-input v-else
                                          v-model="field.field_name"
                                          maxlength="15"
                                          placeholder="请输入标题"></el-input>
                            </div>
                        </template>
                        <template v-else-if="field.field_type==='goods'">
                            <div class="table_field_wrap">
                                <el-table :data="quotationForm[field.field_key]" border>
                                    <el-table-column align="center" label="序号" type="index"
                                                     width="50"></el-table-column>
                                    <el-table-column v-for="child in field._child"
                                                     :align="child.field_type==='money'||child.field_type==='number'||child.field_type==='money_compute_mode'?'right':'left'"
                                                     :min-width="child.extend.table_width">
                                        <template slot="header" slot-scope="{row}">
                                            <div v-if="child.field_type==='money'" class="table_header_wrap">
                                                <span v-text="child.field_name"></span>
                                                <el-select v-model="currency"
                                                           :disabled="templateType!=='add'"
                                                           placeholder="请选择币种"
                                                           size="mini"
                                                           @change="handlePriceUnitChange">
                                                    <el-option key="CNY" label="人民币" value="CNY"></el-option>
                                                    <el-option key="USD" label="美元" value="USD"></el-option>
                                                </el-select>
                                            </div>
                                            <span v-else v-text="child.field_name"></span>
                                        </template>
                                        <template slot-scope="{row}">
                                            <div v-if="child.field_type==='input'" class="table_input_field_wrap">
                                                <el-input v-model="row[child.field_key]"
                                                          :disabled="templateType!=='add'"
                                                          autosize
                                                          placeholder="请输入"
                                                          type="textarea">
                                                </el-input>
                                                <div v-if="child.field_key==='goods_name'&&templateType==='add'"
                                                     class="handle_icon_wrap"
                                                     @click="handleClickSelectProject(row,child)">
                                                    <i class="iconfont icon-cangku1"></i>
                                                </div>
                                            </div>
                                            <div v-else-if="child.field_type==='money'">
                                                <el-input v-model="row[child.field_key].text"
                                                          :disabled="templateType!=='add'"
                                                          autosize
                                                          placeholder="请输入"
                                                          type="textarea"
                                                          @blur="handlePriceInputBlur(child,row)">
                                                </el-input>
                                            </div>
                                            <div v-else-if="child.field_type==='number'">
                                                <el-input v-model="row[child.field_key]"
                                                          :disabled="templateType!=='add'"
                                                          autosize
                                                          placeholder="请输入"
                                                          type="textarea"
                                                          @blur="handleNumberInputBlur(child,row)">
                                                </el-input>
                                            </div>
                                            <div v-else-if="child.field_type==='money_compute_mode'">
                                                <el-input v-model="row[child.field_key].text"
                                                          autosize
                                                          placeholder="自动计算"
                                                          readonly
                                                          type="textarea">
                                                </el-input>
                                            </div>
                                            <div v-else-if="child.field_type==='textarea'">
                                                <el-input v-model="row[child.field_key].value"
                                                          :disabled="templateType!=='add'"
                                                          autosize
                                                          placeholder="请输入"
                                                          type="textarea">
                                                </el-input>
                                            </div>
                                        </template>
                                    </el-table-column>
                                </el-table>
                            </div>
                        </template>
                        <template v-else-if="field.field_type==='money_compute_mode'">
                            <div class="total_price_wrap">
                                <div class="total_price_inner_wrap">
                                    总计：<span v-text="quotationForm[field.field_key].text"></span>
                                    <br>
                                    大写：<span
                                        v-text="quotationForm[field.field_key].chinese_text?quotationForm[field.field_key].chinese_text:'人民币'"></span>
                                </div>
                            </div>
                        </template>
                        <div v-if="templateType!=='detail'&&!field.extend.hasOwnProperty('handle_icon_show')&&handleIconIsShow(index)"
                             class="field_handle_icon_wrap">
                            <div class="remove_icon_wrap">
                                <i v-if="field.is_system===0||(field.field_type==='goods'&&quotationForm[field.field_key].length>1)"
                                   class="el-icon-remove"
                                   @click="handleClickDelTemplateField(field,index)"></i>
                            </div>
                            <div class="plus_icon_wrap">
                                <i class="el-icon-circle-plus" @click="handleClickAddTemplateField(field,index)"></i>
                            </div>
                        </div>
                    </div>
                </draggable>
            </div>
        </div>
        <div v-else-if="project_quotation_tmpl_form==='project_quotation_tmpl_6'"
             ref="project_quotation_tmpl_6"
             class="template_6_wrap">
            <div class="template_header_wrap">
                <div class="logo_wrap"
                     @click="handleClickUploadLogo">
                    <img v-if="quotationForm.company_logo" :src="quotationForm.company_logo" alt=""
                         class="logo">
                    <div v-else class="upload_text">点击上传LOGO</div>
                </div>
                <div class="quotation_title">
                    <el-input v-if="templateType==='add'"
                              v-model="quotationForm.title"
                              maxlength="20"
                              placeholder="请输入标题"
                              size="small"></el-input>
                    <span v-else v-text="quotationForm.title"></span>
                </div>
            </div>
            <div class="template_content_wrap">
                <draggable :animation="300"
                           :disabled="templateType==='detail'"
                           :list="templateFieldsList"
                           :move="onDragFormItemMove"
                           class="form_module_content_wrap"
                           filter=".is_can_not_drag"
                           @end="onDragFormItemEnd">
                    <div v-for="(field,index) in templateFieldsList.slice(0,product_list_index-1)"
                         :class="{'col_span_24':field.extend.col_span===24,'mb_0':field.field_type==='goods','is_can_not_drag':field.extend.hasOwnProperty('can_draggable')}"
                         class="template_field_item_wrap">
                        <template v-if="field.field_type==='input'">
                            <div class="input_field_wrap">
                                <div class="field_label_wrap">
                                    <el-input v-model="field.field_name"
                                              :disabled="templateType==='detail'||field.is_system===1"
                                              autosize
                                              maxlength="10"
                                              :placeholder="templateType=='add'?'请输入标题':''"
                                              type="textarea"></el-input>
                                </div>
                                <div class="field_value_wrap">
                                    <div v-if="field.field_key==='project_name'">
                                        <el-popover v-model="projectListVisible"
                                                    placement="bottom"
                                                    popper-class="project_list_popover"
                                                    trigger="manual"
                                                    width="300">
                                            <el-input slot="reference"
                                                      v-model="quotationForm[field.field_key].value"
                                                      :disabled="templateType!=='add'"
                                                      :placeholder="field.is_system===1?field.extend.placeholder:'请输入'+field.field_name"
                                                      autosize
                                                      type="textarea"
                                                      @input="handleProjectNameInput(field)">
                                            </el-input>
                                            <ul class="project_list">
                                                <li v-for="item in projectList"
                                                    :key="item.project_id"
                                                    class="project_item"
                                                    @click="handleClickProjectName(item,field)"
                                                    v-text="item.name.value"></li>
                                            </ul>
                                        </el-popover>
                                    </div>
                                    <el-input v-model="quotationForm[field.field_key].value"
                                              v-else
                                              :disabled="templateType!=='add'"
                                              :placeholder="templateType=='add'?field.is_system===1?field.extend.placeholder:'请输入'+field.field_name:''"
                                              autosize
                                              type="textarea">
                                    </el-input>
                                </div>
                            </div>
                        </template>
                        <template v-else-if="field.field_type==='textarea'">
                            <div class="textarea_field_wrap">
                                <div class="textarea_field_label">
                                    <div v-if="field.is_system===1" class="field_name" v-text="field.field_name"></div>
                                    <el-input v-else v-model="field.field_name" placeholder="请输入标题"></el-input>
                                </div>
                                <div class="textarea_field_value">
                                    <el-input v-model="quotationForm[field.field_key].value"
                                              v-if="templateType==='add'"
                                              :autosize="{ minRows: 2, maxRows: 10000}"
                                              :placeholder="field.is_system===1?field.extend.placeholder:'请输入'+field.field_name"
                                              autosize
                                              type="textarea">
                                    </el-input>
                                    <div v-else class="detail_field_value"
                                         v-text="quotationForm[field.field_key].value"></div>
                                </div>
                            </div>
                        </template>
                        <template v-else-if="field.field_type==='contact'">
                            <div class="input_field_wrap">
                                <div class="field_label_wrap">
                                    <div class="field_name" v-text="field.field_name"></div>
                                </div>
                                <div class="field_value_wrap">
                                    <el-select :ref="`${field.field_key}_contact_select`"
                                               v-if="templateType==='add'"
                                               v-model="quotationForm[field.field_key].value"
                                               :multiple-limit="1"
                                               :placeholder="field.placeholder"
                                               :remote-method="getUserList"
                                               collapse-tags
                                               filterable
                                               multiple
                                               remote
                                               @focus="handleContactSelectFocus"
                                               @remove-tag="handleRemoveContactTag($event,field)">
                                        <el-option v-for="user in userList"
                                                   :key="user.uid"
                                                   :label="user.name"
                                                   :value="user.uid"
                                                   @click.native="handleClickContactItem(user,field)">
                                        </el-option>
                                    </el-select>
                                    <div v-else
                                         class="detail_field_value"
                                         v-text="quotationForm[field.field_key].text&&quotationForm[field.field_key].text.length?quotationForm[field.field_key].text[0].name:''"></div>
                                </div>
                            </div>
                        </template>
                        <template v-else-if="field.field_type==='radio_customer'">
                            <div class="input_field_wrap">
                                <div class="field_label_wrap">
                                    <div class="field_name" v-text="field.field_name"></div>
                                </div>
                                <div class="field_value_wrap">
                                    <div class="customer_contact_select_wrap">
                                        <el-select :key="field.field_key"
                                                   v-model="quotationForm[field.field_key].value"
                                                   :disabled="templateType!=='add'"
                                                   :placeholder="field.extend.placeholder"
                                                   :remote-method="query=>getCustomerList(query,field)"
                                                   filterable
                                                   remote
                                                   @focus="handleRelateCustomerRadioFocus(field)">
                                            <el-option v-for="item in field.extend.options"
                                                       :key="item.id"
                                                       :label="item.name.value"
                                                       :value="item.id"
                                                       @click.native="handleClickRelateCustomerRadio(item,field)"></el-option>
                                        </el-select>
                                        <i v-if="templateType==='add'"
                                           class="el-icon-circle-plus"
                                           @click="handleClickAddRelateForm(field,'customers')"></i>
                                    </div>
                                </div>
                            </div>
                        </template>
                        <template v-else-if="field.field_type==='customer_contact'">
                            <div class="input_field_wrap">
                                <div class="field_label_wrap">
                                    <div class="field_name" v-text="field.field_name"></div>
                                </div>
                                <div class="field_value_wrap">
                                    <div v-if="templateType==='add'" class="customer_contact_select_wrap">
                                        <el-select :ref="`customer_contact_select_${field.field_key}`"
                                                   v-model="quotationForm[field.field_key].value"
                                                   :multiple-limit="1"
                                                   :placeholder="quotationForm.customer_id && quotationForm.customer_id.value === ''?'请先选择关联客户':field.placeholder"
                                                   clearable
                                                   multiple
                                                   @focus="handleCustomerContactSelectFocus(field)"
                                                   @remove-tag="handleRemoveCustomerContactSelectTag">
                                            <el-option v-for="item in field.options"
                                                       :label="item.name"
                                                       :value="item.id"
                                                       @click.native="handleSelectCustomerContact(item)"></el-option>
                                        </el-select>
                                        <i class="el-icon-circle-plus"
                                           @click="handleClickAddRelateForm(field,'customer_contacts')"></i>
                                    </div>
                                    <div v-else class="detail_field_value"
                                         v-text="quotationForm[field.field_key].text&&quotationForm[field.field_key].text.length?quotationForm[field.field_key].text[0].name:''"></div>
                                </div>
                            </div>
                        </template>
                        <template v-else-if="field.field_type==='telephone'">
                            <div class="input_field_wrap">
                                <div class="field_label_wrap">
                                    <div class="field_name" v-text="field.field_name"></div>
                                </div>
                                <div class="field_value_wrap">
                                    <el-input v-model="quotationForm[field.field_key].value"
                                              :disabled="templateType!=='add'"
                                              :placeholder="field.is_system===1?field.extend.placeholder:'请输入'+field.field_name"
                                              autosize
                                              type="textarea">
                                    </el-input>
                                </div>
                            </div>
                        </template>
                        <template v-else-if="field.field_type==='date'">
                            <div class="input_field_wrap">
                                <div class="field_label_wrap">
                                    <div class="field_name" v-text="field.field_name"></div>
                                </div>
                                <div class="field_value_wrap">
                                    <el-date-picker :ref="'date_picker_'+field.field_key"
                                                    v-model="quotationForm[field.field_key].value"
                                                    v-if="templateType==='add'"
                                                    :editable="false"
                                                    :placeholder="field.extend.placeholder"
                                                    format="yyyy年MM月dd日"
                                                    type="date"
                                                    value-format="yyyy-MM-dd"
                                                    @change="handleSelectDateChange(field)">
                                    </el-date-picker>
                                    <div v-else class="detail_field_value"
                                         v-text="quotationForm[field.field_key].value"></div>
                                </div>
                            </div>
                        </template>
                        <template v-else-if="field.field_type==='explain'">
                            <div class="explain_field_wrap">
                                <div v-if="templateType==='detail'||field.is_system===1"
                                     class="explain_field"
                                     v-text="field.field_name"></div>
                                <el-input v-else
                                          v-model="field.field_name"
                                          maxlength="15"
                                          placeholder="请输入标题"></el-input>
                            </div>
                        </template>
                        <template v-else-if="field.field_type==='goods'">
                            <div class="table_field_wrap">
                                <el-table :data="quotationForm[field.field_key]" border>
                                    <el-table-column align="center" label="序号" type="index"
                                                     width="50"></el-table-column>
                                    <el-table-column v-for="child in field._child"
                                                     :align="child.field_type==='money'||child.field_type==='number'||child.field_type==='money_compute_mode'?'right':'left'"
                                                     :min-width="child.extend.table_width">
                                        <template slot="header" slot-scope="{row}">
                                            <div v-if="child.field_type==='money'" class="table_header_wrap">
                                                <span v-text="child.field_name"></span>
                                                <el-select v-model="currency"
                                                           :disabled="templateType!=='add'"
                                                           placeholder="请选择币种"
                                                           size="mini"
                                                           @change="handlePriceUnitChange">
                                                    <el-option key="CNY" label="人民币" value="CNY"></el-option>
                                                    <el-option key="USD" label="美元" value="USD"></el-option>
                                                </el-select>
                                            </div>
                                            <span v-else v-text="child.field_name"></span>
                                        </template>
                                        <template slot-scope="{row}">
                                            <div v-if="child.field_type==='input'" class="table_input_field_wrap">
                                                <el-input v-model="row[child.field_key]"
                                                          :disabled="templateType!=='add'"
                                                          autosize
                                                          placeholder="请输入"
                                                          type="textarea">
                                                </el-input>
                                                <div v-if="child.field_key==='goods_name'&&templateType==='add'"
                                                     class="handle_icon_wrap"
                                                     @click="handleClickSelectProject(row,child)">
                                                    <i class="iconfont icon-cangku1"></i>
                                                </div>
                                            </div>
                                            <div v-else-if="child.field_type==='money'">
                                                <el-input v-model="row[child.field_key].text"
                                                          :disabled="templateType!=='add'"
                                                          autosize
                                                          placeholder="请输入"
                                                          type="textarea"
                                                          @blur="handlePriceInputBlur(child,row)">
                                                </el-input>
                                            </div>
                                            <div v-else-if="child.field_type==='number'">
                                                <el-input v-model="row[child.field_key]"
                                                          :disabled="templateType!=='add'"
                                                          autosize
                                                          placeholder="请输入"
                                                          type="textarea"
                                                          @blur="handleNumberInputBlur(child,row)">
                                                </el-input>
                                            </div>
                                            <div v-else-if="child.field_type==='money_compute_mode'">
                                                <el-input v-model="row[child.field_key].text"
                                                          autosize
                                                          placeholder="自动计算"
                                                          readonly
                                                          type="textarea">
                                                </el-input>
                                            </div>
                                            <div v-else-if="child.field_type==='textarea'">
                                                <el-input v-model="row[child.field_key]"
                                                          :disabled="templateType!=='add'"
                                                          autosize
                                                          placeholder="请输入"
                                                          type="textarea">
                                                </el-input>
                                            </div>
                                        </template>
                                    </el-table-column>
                                </el-table>
                            </div>
                        </template>
                        <div v-if="templateType!=='detail'&&!field.extend.hasOwnProperty('handle_icon_show')&&handleIconIsShow(index)"
                             class="field_handle_icon_wrap">
                            <div class="remove_icon_wrap">
                                <i v-if="field.is_system===0||(field.field_type==='goods'&&quotationForm[field.field_key].length>1)"
                                   class="el-icon-remove"
                                   @click="handleClickDelTemplateField(field,index)"></i>
                            </div>
                            <div class="plus_icon_wrap">
                                <i class="el-icon-circle-plus" @click="handleClickAddTemplateField(field,index)"></i>
                            </div>
                        </div>
                    </div>
                </draggable>
            </div>
            <div class="template_footer_wrap">
                <div class="footer_left_wrap">
                    <div v-for="(field,index) in templateFieldsList.filter(item=>item.field_type==='textarea')"
                         class="template_field_item_wrap">
                        <div class="textarea_field_wrap">
                            <div class="textarea_field_label">
                                <div v-if="field.is_system===1"
                                     class="field_name"
                                     v-text="field.field_name"></div>
                                <el-input v-else v-model="field.field_name" placeholder="请输入标题"></el-input>
                            </div>
                            <div class="textarea_field_value">
                                <el-input v-model="quotationForm[field.field_key].value"
                                          :autosize="{ minRows: 1, maxRows: 7}"
                                          :disabled="templateType!=='add'"
                                          :placeholder="field.is_system===1?field.extend.placeholder:'请输入'+field.field_name"
                                          maxlength="225"
                                          type="textarea">
                                </el-input>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="footer_right_wrap">
                    <div class="right_outer_wrap">
                        <div class="right_inner_wrap">
                            <div v-for="(field,index) in templateFieldsList.filter(item=>item.field_type==='money_compute_mode')"
                                 class="template_field_item_wrap">
                                <div class="total_price_wrap">
                                    <div class="total_price_label">
                                        总计：<span v-text="quotationForm[field.field_key].text"></span>
                                    </div>
                                    <div class="chinese_text">
                                        大写：<span
                                            v-text="quotationForm[field.field_key].chinese_text?quotationForm[field.field_key].chinese_text:'人民币'"></span>
                                    </div>
                                </div>
                            </div>
                            <div>
                                <div v-for="(field,index) in templateFieldsList.slice(templateFieldsList.length-2)"
                                     class="template_field_item_wrap">
                                    <template v-if="field.field_type==='contact'">
                                        <div class="input_field_wrap">
                                            <div class="field_label_wrap">
                                                <div class="field_name" v-text="field.field_name"></div>
                                            </div>
                                            <div class="field_value_wrap">
                                                <el-select :ref="`${field.field_key}_contact_select`"
                                                           v-if="templateType==='add'"
                                                           v-model="quotationForm[field.field_key].value"
                                                           :multiple-limit="1"
                                                           :placeholder="field.placeholder"
                                                           :remote-method="getUserList"
                                                           collapse-tags
                                                           filterable
                                                           multiple
                                                           remote
                                                           @focus="handleContactSelectFocus"
                                                           @remove-tag="handleRemoveContactTag($event,field)">
                                                    <el-option v-for="user in userList"
                                                               :key="user.uid"
                                                               :label="user.name"
                                                               :value="user.uid"
                                                               @click.native="handleClickContactItem(user,field)">
                                                    </el-option>
                                                </el-select>
                                                <div v-else
                                                     class="detail_field_value"
                                                     v-text="quotationForm[field.field_key].text&&quotationForm[field.field_key].text.length?quotationForm[field.field_key].text[0].name:''"></div>
                                            </div>
                                        </div>
                                    </template>
                                    <template v-else-if="field.field_type==='input'">
                                        <div class="input_field_wrap">
                                            <div class="field_label_wrap">
                                                <div class="field_name" v-text="field.field_name"></div>
                                            </div>
                                            <div class="field_value_wrap">
                                                <el-input v-model="quotationForm[field.field_key].value"
                                                          :disabled="templateType!=='add'"
                                                          :placeholder="field.is_system===1?field.extend.placeholder:'请输入'+field.field_name"
                                                          :rows="1"
                                                          autosize
                                                          type="textarea">
                                                </el-input>
                                            </div>
                                        </div>
                                    </template>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div v-else-if="project_quotation_tmpl_form==='project_quotation_tmpl_7'"
             ref="project_quotation_tmpl_7"
             class="template_7_wrap">
            <div class="template_header_wrap">
                <div class="left_logo_wrap">
                    <div :class="{'no_border':quotationForm.company_logo!==''}"
                         class="logo_outer_wrap"
                         @click="handleClickUploadLogo">
                        <img v-if="quotationForm.company_logo" :src="quotationForm.company_logo" alt=""
                             class="logo">
                        <div v-else class="upload_text">点击上传LOGO</div>
                    </div>
                </div>
                <div class="right_quotation_title_wrap">
                    <div class="quotation_title_wrap">
                        <el-input v-if="templateType==='add'"
                                  v-model="quotationForm.title"
                                  maxlength="20"
                                  placeholder="请输入标题"
                                  size="small"></el-input>
                        <span v-else v-text="quotationForm.title"></span>
                    </div>
                </div>
            </div>
            <div class="template_content_wrap">
                <draggable :animation="300"
                           :disabled="templateType==='detail'"
                           :list="templateFieldsList"
                           :move="onDragFormItemMove"
                           class="form_module_content_wrap"
                           filter=".is_can_not_drag"
                           @end="onDragFormItemEnd">
                    <div v-for="(field,index) in templateFieldsList.slice(0,product_list_index+1)"
                         :class="{'col_span_24':field.extend.col_span===24,'mb_0':field.field_type==='goods','is_can_not_drag':field.extend.hasOwnProperty('can_draggable')}"
                         class="template_field_item_wrap">
                        <template v-if="field.field_type==='input'">
                            <div class="input_field_wrap">
                                <div class="field_label_wrap">
                                    <el-input v-model="field.field_name"
                                              :disabled="templateType==='detail'||field.is_system===1"
                                              autosize
                                              maxlength="10"
                                              :placeholder="templateType=='add'?'请输入标题':''"
                                              type="textarea"></el-input>
                                </div>
                                <div class="field_value_wrap">
                                    <div v-if="field.field_key==='project_name'">
                                        <el-popover v-model="projectListVisible"
                                                    placement="bottom"
                                                    popper-class="project_list_popover"
                                                    trigger="manual"
                                                    width="300">
                                            <el-input slot="reference"
                                                      v-model="quotationForm[field.field_key].value"
                                                      :disabled="templateType!=='add'"
                                                      :placeholder="field.is_system===1?field.extend.placeholder:'请输入'+field.field_name"
                                                      autosize
                                                      type="textarea"
                                                      @input="handleProjectNameInput(field)">
                                            </el-input>
                                            <ul class="project_list">
                                                <li v-for="item in projectList"
                                                    :key="item.project_id"
                                                    class="project_item"
                                                    @click="handleClickProjectName(item,field)"
                                                    v-text="item.name.value"></li>
                                            </ul>
                                        </el-popover>
                                    </div>
                                    <el-input v-else
                                              v-model="quotationForm[field.field_key].value"
                                              :disabled="templateType!=='add'"
                                              :placeholder="templateType=='add'?field.is_system===1?field.extend.placeholder:'请输入'+field.field_name:''"
                                              autosize
                                              type="textarea">
                                    </el-input>
                                </div>
                            </div>
                        </template>
                        <template v-else-if="field.field_type==='textarea'">
                            <div class="textarea_field_wrap">
                                <div class="textarea_field_label">
                                    <div v-if="field.is_system===1" class="field_name" v-text="field.field_name"></div>
                                    <el-input v-else v-model="field.field_name" placeholder="请输入标题"></el-input>
                                </div>
                                <div class="textarea_field_value">
                                    <el-input v-if="templateType==='add'"
                                              v-model="quotationForm[field.field_key].value"
                                              :autosize="{ minRows: 2, maxRows: 10000}"
                                              :placeholder="field.is_system===1?field.extend.placeholder:'请输入'+field.field_name"
                                              autosize
                                              type="textarea">
                                    </el-input>
                                    <div v-else class="detail_field_value"
                                         v-text="quotationForm[field.field_key].value"></div>
                                </div>
                            </div>
                        </template>
                        <template v-else-if="field.field_type==='contact'">
                            <div class="input_field_wrap">
                                <div class="field_label_wrap">
                                    <div class="field_name" v-text="field.field_name"></div>
                                </div>
                                <div class="field_value_wrap">
                                    <el-select v-if="templateType==='add'"
                                               :ref="`${field.field_key}_contact_select`"
                                               v-model="quotationForm[field.field_key].value"
                                               :multiple-limit="1"
                                               :placeholder="field.placeholder"
                                               :remote-method="getUserList"
                                               collapse-tags
                                               filterable
                                               multiple
                                               remote
                                               @focus="handleContactSelectFocus"
                                               @remove-tag="handleRemoveContactTag($event,field)">
                                        <el-option v-for="user in userList"
                                                   :key="user.uid"
                                                   :label="user.name"
                                                   :value="user.uid"
                                                   @click.native="handleClickContactItem(user,field)">
                                        </el-option>
                                    </el-select>
                                    <div v-else
                                         class="detail_field_value"
                                         v-text="quotationForm[field.field_key].text&&quotationForm[field.field_key].text.length?quotationForm[field.field_key].text[0].name:''"></div>
                                </div>
                            </div>
                        </template>
                        <template v-else-if="field.field_type==='radio_customer'">
                            <div class="input_field_wrap">
                                <div class="field_label_wrap">
                                    <div class="field_name" v-text="field.field_name"></div>
                                </div>
                                <div class="field_value_wrap">
                                    <div class="customer_contact_select_wrap">
                                        <el-select :key="field.field_key"
                                                   v-model="quotationForm[field.field_key].value"
                                                   :disabled="templateType!=='add'"
                                                   :placeholder="field.extend.placeholder"
                                                   :remote-method="query=>getCustomerList(query,field)"
                                                   filterable
                                                   remote
                                                   @focus="handleRelateCustomerRadioFocus(field)">
                                            <el-option v-for="item in field.extend.options"
                                                       :key="item.id"
                                                       :label="item.name.value"
                                                       :value="item.id"
                                                       @click.native="handleClickRelateCustomerRadio(item,field)"></el-option>
                                        </el-select>
                                        <i v-if="templateType==='add'"
                                           class="el-icon-circle-plus"
                                           @click="handleClickAddRelateForm(field,'customers')"></i>
                                    </div>
                                </div>
                            </div>
                        </template>
                        <template v-else-if="field.field_type==='customer_contact'">
                            <div class="input_field_wrap">
                                <div class="field_label_wrap">
                                    <div class="field_name" v-text="field.field_name"></div>
                                </div>
                                <div class="field_value_wrap">
                                    <div v-if="templateType==='add'" class="customer_contact_select_wrap">
                                        <el-select :ref="`customer_contact_select_${field.field_key}`"
                                                   v-model="quotationForm[field.field_key].value"
                                                   :multiple-limit="1"
                                                   :placeholder="quotationForm.customer_id && quotationForm.customer_id.value === ''?'请先选择关联客户':field.placeholder"
                                                   clearable
                                                   multiple
                                                   @focus="handleCustomerContactSelectFocus(field)"
                                                   @remove-tag="handleRemoveCustomerContactSelectTag">
                                            <el-option v-for="item in field.options"
                                                       :label="item.name"
                                                       :value="item.id"
                                                       @click.native="handleSelectCustomerContact(item)"></el-option>
                                        </el-select>
                                        <i class="el-icon-circle-plus"
                                           @click="handleClickAddRelateForm(field,'customer_contacts')"></i>
                                    </div>
                                    <div v-else class="detail_field_value"
                                         v-text="quotationForm[field.field_key].text&&quotationForm[field.field_key].text.length?quotationForm[field.field_key].text[0].name:''"></div>
                                </div>
                            </div>
                        </template>
                        <template v-else-if="field.field_type==='telephone'">
                            <div class="input_field_wrap">
                                <div class="field_label_wrap">
                                    <div class="field_name" v-text="field.field_name"></div>
                                </div>
                                <div class="field_value_wrap">
                                    <el-input v-model="quotationForm[field.field_key].value"
                                              :disabled="templateType!=='add'"
                                              :placeholder="field.is_system===1?field.extend.placeholder:'请输入'+field.field_name"
                                              autosize
                                              type="textarea">
                                    </el-input>
                                </div>
                            </div>
                        </template>
                        <template v-else-if="field.field_type==='date'">
                            <div class="input_field_wrap">
                                <div class="field_label_wrap">
                                    <div class="field_name" v-text="field.field_name"></div>
                                </div>
                                <div class="field_value_wrap">
                                    <el-date-picker v-if="templateType==='add'"
                                                    :ref="'date_picker_'+field.field_key"
                                                    v-model="quotationForm[field.field_key].value"
                                                    :editable="false"
                                                    :placeholder="field.extend.placeholder"
                                                    format="yyyy年MM月dd日"
                                                    type="date"
                                                    value-format="yyyy-MM-dd"
                                                    @change="handleSelectDateChange(field)">
                                    </el-date-picker>
                                    <div v-else class="detail_field_value"
                                         v-text="quotationForm[field.field_key].value"></div>
                                </div>
                            </div>
                        </template>
                        <template v-else-if="field.field_type==='explain'">
                            <div class="explain_field_wrap">
                                <div v-if="templateType==='detail'||field.is_system===1"
                                     class="explain_field"
                                     v-text="field.field_name"></div>
                                <el-input v-else
                                          v-model="field.field_name"
                                          maxlength="15"
                                          placeholder="请输入标题"></el-input>
                            </div>
                        </template>
                        <template v-else-if="field.field_type==='goods'">
                            <div class="table_field_wrap">
                                <el-table :data="quotationForm[field.field_key]" border stripe>
                                    <el-table-column label="#" type="index" width="40"></el-table-column>
                                    <el-table-column v-for="child in field._child"
                                                     :align="child.field_type==='money'||child.field_type==='number'||child.field_type==='money_compute_mode'?'right':'left'"
                                                     :min-width="child.extend.table_width">
                                        <template slot="header" slot-scope="{row}">
                                            <div v-if="child.field_type==='money'" class="table_header_wrap">
                                                <span v-text="child.field_name"></span>
                                                <el-select v-model="currency"
                                                           :disabled="templateType!=='add'"
                                                           placeholder="请选择币种"
                                                           size="mini"
                                                           @change="handlePriceUnitChange">
                                                    <el-option key="CNY" label="人民币" value="CNY"></el-option>
                                                    <el-option key="USD" label="美元" value="USD"></el-option>
                                                </el-select>
                                            </div>
                                            <span v-else v-text="child.field_name"></span>
                                        </template>
                                        <template slot-scope="{row}">
                                            <div v-if="child.field_type==='input'" class="table_input_field_wrap">
                                                <el-input v-model="row[child.field_key]"
                                                          :disabled="templateType!=='add'"
                                                          autosize
                                                          placeholder="请输入"
                                                          type="textarea">
                                                </el-input>
                                                <div v-if="child.field_key==='goods_name'&&templateType==='add'"
                                                     class="handle_icon_wrap"
                                                     @click="handleClickSelectProject(row,child)">
                                                    <i class="iconfont icon-cangku1"></i>
                                                </div>
                                            </div>
                                            <div v-else-if="child.field_type==='money'">
                                                <el-input v-model="row[child.field_key].text"
                                                          :disabled="templateType!=='add'"
                                                          autosize
                                                          placeholder="请输入"
                                                          type="textarea"
                                                          @blur="handlePriceInputBlur(child,row)">
                                                </el-input>
                                            </div>
                                            <div v-else-if="child.field_type==='number'">
                                                <el-input v-model="row[child.field_key]"
                                                          :disabled="templateType!=='add'"
                                                          autosize
                                                          placeholder="请输入"
                                                          type="textarea"
                                                          @blur="handleNumberInputBlur(child,row)">
                                                </el-input>
                                            </div>
                                            <div v-else-if="child.field_type==='money_compute_mode'">
                                                <el-input v-model="row[child.field_key].text"
                                                          autosize
                                                          placeholder="自动计算"
                                                          readonly
                                                          type="textarea">
                                                </el-input>
                                            </div>
                                            <div v-else-if="child.field_type==='textarea'">
                                                <el-input v-model="row[child.field_key]"
                                                          :disabled="templateType!=='add'"
                                                          autosize
                                                          placeholder="请输入"
                                                          type="textarea">
                                                </el-input>
                                            </div>
                                        </template>
                                    </el-table-column>
                                </el-table>
                            </div>
                        </template>
                        <template v-else-if="field.field_type==='money_compute_mode'">
                            <div class="total_price_wrap">
                                <div class="total_price_inner_wrap">
                                    <div>
                                        <div>总计：</div>
                                        <div>大写：人民币</div>
                                    </div>
                                </div>
                            </div>
                        </template>
                        <div v-if="templateType!=='detail'&&!field.extend.hasOwnProperty('handle_icon_show')&&handleIconIsShow(index)"
                             class="field_handle_icon_wrap">
                            <div class="remove_icon_wrap">
                                <i v-if="field.is_system===0||(field.field_type==='goods'&&quotationForm[field.field_key].length>1)"
                                   class="el-icon-remove"
                                   @click="handleClickDelTemplateField(field,index)"></i>
                            </div>
                            <div class="plus_icon_wrap">
                                <i class="el-icon-circle-plus" @click="handleClickAddTemplateField(field,index)"></i>
                            </div>
                        </div>
                    </div>
                </draggable>
            </div>
            <div class="template_footer_wrap">
                <div class="footer_left_wrap">
                    <div class="quotation_title_wrap">XX公司</div>
                </div>
                <div class="footer_right_wrap">
                    <div v-for="(field,index) in templateFieldsList.slice(templateFieldsList.length-2)">
                        <div v-if="field.field_type==='input'" class="input_field_wrap">
                            <div class="field_label_wrap" v-text="field.field_name"></div>
                            <div class="field_value_wrap">
                                <div v-if="field.field_key==='project_name'">
                                    <el-popover v-model="projectListVisible"
                                                placement="bottom"
                                                popper-class="project_list_popover"
                                                trigger="manual"
                                                width="300">
                                        <el-input slot="reference"
                                                  v-model="quotationForm[field.field_key].value"
                                                  :disabled="templateType!=='add'"
                                                  :placeholder="field.is_system===1?field.extend.placeholder:'请输入'+field.field_name"
                                                  autosize
                                                  type="textarea"
                                                  @input="handleProjectNameInput(field)">
                                        </el-input>
                                        <ul class="project_list">
                                            <li v-for="item in projectList"
                                                :key="item.project_id"
                                                class="project_item"
                                                @click="handleClickProjectName(item,field)"
                                                v-text="item.name.value"></li>
                                        </ul>
                                    </el-popover>
                                </div>
                                <el-input v-else
                                          v-model="quotationForm[field.field_key].value"
                                          :disabled="templateType!=='add'"
                                          :placeholder="templateType=='add'?field.is_system===1?field.extend.placeholder:'请输入'+field.field_name:''"
                                          autosize
                                          type="textarea">
                                </el-input>
                            </div>
                        </div>
                        <div v-else-if="field.field_type==='textarea'" class="textarea_field_wrap"
                             style="margin-bottom: 8px;">
                            <div class="textarea_field_label">
                                <div v-if="field.is_system===1" class="field_name" v-text="field.field_name"></div>
                                <el-input v-else v-model="field.field_name" placeholder="请输入标题"></el-input>
                            </div>
                            <div class="textarea_field_value">
                                <el-input v-if="templateType==='add'"
                                          v-model="quotationForm[field.field_key].value"
                                          :autosize="{ minRows: 2, maxRows: 10000}"
                                          :placeholder="field.is_system===1?field.extend.placeholder:'请输入'+field.field_name"
                                          autosize
                                          type="textarea">
                                </el-input>
                                <div v-else class="detail_field_value"
                                     v-text="quotationForm[field.field_key].value"></div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div v-else-if="project_quotation_tmpl_form==='project_quotation_tmpl_8'"
             ref="project_quotation_tmpl_8"
             class="template_8_wrap">
            <div class="template_header_wrap">
                <div class="left_logo_wrap">
                    <div :class="{'no_border':quotationForm.company_logo!==''}"
                         class="logo_outer_wrap"
                         @click="handleClickUploadLogo">
                        <img v-if="quotationForm.company_logo" :src="quotationForm.company_logo" alt=""
                             class="logo">
                        <div v-else class="upload_text">点击上传LOGO</div>
                    </div>
                </div>
                <div class="right_quotation_title_wrap">
                    <div class="quotation_title_wrap">
                        <el-input v-if="templateType==='add'"
                                  v-model="quotationForm.title"
                                  maxlength="20"
                                  placeholder="请输入标题"
                                  size="small"></el-input>
                        <span v-else v-text="quotationForm.title"></span>
                    </div>
                </div>
            </div>
            <div class="template_content_wrap">
                <el-row style="flex-wrap: wrap" type="flex">
                    <el-col v-for="(field,index) in templateFieldsList"
                            :span="field.extend.col_span">
                        <template v-if="field.field_type==='input'">
                            <div class="input_field_wrap">
                                <div class="field_label_wrap">
                                    <el-input v-model="field.field_name"
                                              :disabled="templateType==='detail'||field.is_system===1"
                                              autosize
                                              maxlength="10"
                                              :placeholder="templateType=='add'?'请输入标题':''"
                                              type="textarea"></el-input>
                                </div>
                                <div class="field_value_wrap">
                                    <div v-if="field.field_key==='project_name'">
                                        <el-popover v-model="projectListVisible"
                                                    placement="bottom"
                                                    popper-class="project_list_popover"
                                                    trigger="manual"
                                                    width="300">
                                            <el-input slot="reference"
                                                      v-model="quotationForm[field.field_key].value"
                                                      :disabled="templateType!=='add'"
                                                      :placeholder="field.is_system===1?field.extend.placeholder:'请输入'+field.field_name"
                                                      autosize
                                                      type="textarea"
                                                      @input="handleProjectNameInput(field)">
                                            </el-input>
                                            <ul class="project_list">
                                                <li v-for="item in projectList"
                                                    :key="item.project_id"
                                                    class="project_item"
                                                    @click="handleClickProjectName(item,field)"
                                                    v-text="item.name.value"></li>
                                            </ul>
                                        </el-popover>
                                    </div>
                                    <el-input v-else
                                              v-model="quotationForm[field.field_key].value"
                                              :disabled="templateType!=='add'"
                                              :placeholder="templateType=='add'?field.is_system===1?field.extend.placeholder:'请输入'+field.field_name:''"
                                              autosize
                                              type="textarea">
                                    </el-input>
                                </div>
                            </div>
                        </template>
                        <template v-else-if="field.field_type==='explain'">
                            <div class="explain_field" v-text="field.field_name"></div>
                        </template>
                        <template v-else-if="field.field_type==='textarea'">
                            <div class="textarea_field_wrap">
                                <div class="textarea_field_label" v-text="field.field_name"></div>
                                <div class="textarea_field_value"
                                     v-text="field.extend.placeholder?field.extend.placeholder:'请输入'"></div>
                            </div>
                        </template>
                        <template v-else-if="field.field_type==='goods'">
                            <div class="table_field_wrap">
                                <el-table :data="quotationForm[field.field_key]" border>
                                    <el-table-column align="center" label="序号" type="index"
                                                     width="50"></el-table-column>
                                    <el-table-column label="产品名称" min-width="130"
                                                     prop="equipment_name"></el-table-column>
                                    <el-table-column label="产品描述" min-width="190"
                                                     prop="product_description"></el-table-column>
                                    <el-table-column align="right" label="单价" min-width="100"
                                                     prop="unit_price"></el-table-column>
                                    <el-table-column align="right" label="数量" min-width="75"
                                                     prop="quantity"></el-table-column>
                                    <el-table-column align="right" label="小计" min-width="100"
                                                     prop="subtotal_price"></el-table-column>
                                </el-table>
                            </div>
                        </template>
                        <template v-else-if="field.field_type==='money_compute_mode'">
                            <div class="total_price_wrap">
                                <div class="total_price_inner_wrap">
                                    <div>总计：</div>
                                    <div>大写：人民币</div>
                                </div>
                            </div>
                        </template>
                    </el-col>
                </el-row>
            </div>
        </div>
        <div v-else-if="project_quotation_tmpl_form==='project_quotation_tmpl_9'"
             ref="project_quotation_tmpl_9"
             class="template_9_wrap">
            <div class="template_header_wrap">
                <div class="left_quotation_title_wrap">
                    <div class="quotation_title_wrap">
                        <el-input v-if="templateType==='add'"
                                  v-model="quotationForm.title"
                                  maxlength="20"
                                  placeholder="请输入标题"
                                  size="small"></el-input>
                        <span v-else v-text="quotationForm.title"></span>
                    </div>
                </div>
                <div :class="{'no_border':quotationForm.company_logo!==''}"
                     class="right_logo_wrap"
                     @click="handleClickUploadLogo">
                    <img v-if="quotationForm.company_logo" :src="quotationForm.company_logo" alt=""
                         class="logo">
                    <div v-else class="upload_text">点击上传LOGO</div>
                </div>
            </div>
            <div class="template_content_wrap">
                <el-row style="flex-wrap: wrap" type="flex">
                    <el-col v-for="(field,index) in templateFieldsList"
                            :span="field.extend.col_span">
                        <template v-if="field.field_type==='input'">
                            <div class="input_field_wrap">
                                <div class="field_label_wrap">
                                    <el-input v-model="field.field_name"
                                              :disabled="templateType==='detail'||field.is_system===1"
                                              autosize
                                              maxlength="10"
                                              :placeholder="templateType=='add'?'请输入标题':''"
                                              type="textarea"></el-input>
                                </div>
                                <div class="field_value_wrap">
                                    <div v-if="field.field_key==='project_name'">
                                        <el-popover v-model="projectListVisible"
                                                    placement="bottom"
                                                    popper-class="project_list_popover"
                                                    trigger="manual"
                                                    width="300">
                                            <el-input slot="reference"
                                                      v-model="quotationForm[field.field_key].value"
                                                      :disabled="templateType!=='add'"
                                                      :placeholder="field.is_system===1?field.extend.placeholder:'请输入'+field.field_name"
                                                      autosize
                                                      type="textarea"
                                                      @input="handleProjectNameInput(field)">
                                            </el-input>
                                            <ul class="project_list">
                                                <li v-for="item in projectList"
                                                    :key="item.project_id"
                                                    class="project_item"
                                                    @click="handleClickProjectName(item,field)"
                                                    v-text="item.name.value"></li>
                                            </ul>
                                        </el-popover>
                                    </div>
                                    <el-input v-else
                                              v-model="quotationForm[field.field_key].value"
                                              :disabled="templateType!=='add'"
                                              :placeholder="templateType=='add'?field.is_system===1?field.extend.placeholder:'请输入'+field.field_name:''"
                                              autosize
                                              type="textarea">
                                    </el-input>
                                </div>
                            </div>
                        </template>
                        <template v-else-if="field.field_type==='explain'">
                            <div class="explain_field" v-text="field.field_name"></div>
                        </template>
                        <template v-else-if="field.field_type==='textarea'">
                            <div class="textarea_field_wrap">
                                <div class="textarea_field_label" v-text="field.field_name"></div>
                                <div class="textarea_field_value"
                                     v-text="field.extend.placeholder?field.extend.placeholder:'请输入'"></div>
                            </div>
                        </template>
                        <template v-else-if="field.field_type==='goods'">
                            <div class="table_field_wrap">
                                <el-table :data="quotationForm[field.field_key]" border>
                                    <el-table-column align="center" label="序号" type="index"
                                                     width="50"></el-table-column>
                                    <el-table-column label="产品名称" min-width="280"
                                                     prop="equipment_name"></el-table-column>
                                    <el-table-column label="规格型号" min-width="300"
                                                     prop="sku_name"></el-table-column>
                                    <el-table-column align="right" label="单价" min-width="100"
                                                     prop="unit_price"></el-table-column>
                                    <el-table-column align="right" label="数量" min-width="75"
                                                     prop="quantity"></el-table-column>
                                    <el-table-column align="right" label="小计" min-width="100"
                                                     prop="subtotal_price"></el-table-column>
                                </el-table>
                            </div>
                        </template>
                        <template v-else-if="field.field_type==='money_compute_mode'">
                            <div class="total_price_wrap">
                                <div class="total_price_inner_wrap">
                                    <div>共计：xxx</div>
                                </div>
                            </div>
                        </template>
                    </el-col>
                </el-row>
            </div>
            <div class="template_footer_wrap"></div>
        </div>
        <div v-else-if="project_quotation_tmpl_form==='project_quotation_tmpl_10'"
             ref="project_quotation_tmpl_10"
             class="template_10_wrap">
            <div class="template_header_wrap">
                <div class="right_quotation_title_wrap">
                    <div class="quotation_title_wrap">
                        <el-input v-if="templateType==='add'"
                                  v-model="quotationForm.title"
                                  maxlength="20"
                                  placeholder="请输入标题"
                                  size="small"></el-input>
                        <span v-else v-text="quotationForm.title"></span>
                    </div>
                </div>
                <div :class="{'no_border':quotationForm.company_logo!==''}"
                     class="left_logo_wrap"
                     @click="handleClickUploadLogo">
                    <img v-if="quotationForm.company_logo" :src="quotationForm.company_logo" alt=""
                         class="logo">
                    <div v-else class="upload_text">点击上传LOGO</div>
                </div>
            </div>
            <div class="template_content_wrap">
                <el-row style="flex-wrap: wrap" type="flex">
                    <el-col v-for="(field,index) in templateFieldsList"
                            :span="field.extend.col_span">
                        <template v-if="field.field_type==='input'">
                            <div class="input_field_wrap">
                                <div class="field_label_wrap">
                                    <el-input v-model="field.field_name"
                                              :disabled="templateType==='detail'||field.is_system===1"
                                              autosize
                                              maxlength="10"
                                              :placeholder="templateType=='add'?'请输入标题':''"
                                              type="textarea"></el-input>
                                </div>
                                <div class="field_value_wrap">
                                    <div v-if="field.field_key==='project_name'">
                                        <el-popover v-model="projectListVisible"
                                                    placement="bottom"
                                                    popper-class="project_list_popover"
                                                    trigger="manual"
                                                    width="300">
                                            <el-input slot="reference"
                                                      v-model="quotationForm[field.field_key].value"
                                                      :disabled="templateType!=='add'"
                                                      :placeholder="field.is_system===1?field.extend.placeholder:'请输入'+field.field_name"
                                                      autosize
                                                      type="textarea"
                                                      @input="handleProjectNameInput(field)">
                                            </el-input>
                                            <ul class="project_list">
                                                <li v-for="item in projectList"
                                                    :key="item.project_id"
                                                    class="project_item"
                                                    @click="handleClickProjectName(item,field)"
                                                    v-text="item.name.value"></li>
                                            </ul>
                                        </el-popover>
                                    </div>
                                    <el-input v-else
                                              v-model="quotationForm[field.field_key].value"
                                              :disabled="templateType!=='add'"
                                              :placeholder="templateType=='add'?field.is_system===1?field.extend.placeholder:'请输入'+field.field_name:''"
                                              autosize
                                              type="textarea">
                                    </el-input>
                                </div>
                            </div>
                        </template>
                        <template v-else-if="field.field_type==='explain'">
                            <div class="explain_field" v-text="field.field_name"></div>
                        </template>
                        <template v-else-if="field.field_type==='textarea'">
                            <div class="textarea_field_wrap">
                                <div class="textarea_field_label" v-text="field.field_name"></div>
                                <div class="textarea_field_value"
                                     v-text="field.extend.placeholder?field.extend.placeholder:'请输入'"></div>
                            </div>
                        </template>
                        <template v-else-if="field.field_type==='goods'">
                            <div class="table_field_wrap">
                                <el-table :data="quotationForm[field.field_key]" border>
                                    <el-table-column align="center" label="序号" type="index"
                                                     width="50"></el-table-column>
                                    <el-table-column label="产品类别" min-width="100"
                                                     prop="product_category"></el-table-column>
                                    <el-table-column label="设备名称" min-width="130"
                                                     prop="equipment_name"></el-table-column>
                                    <el-table-column label="产品描述" min-width="190"
                                                     prop="product_description"></el-table-column>
                                    <el-table-column align="right" label="单价" min-width="100"
                                                     prop="unit_price"></el-table-column>
                                    <el-table-column align="center" label="单位" min-width="50"
                                                     prop="unit"></el-table-column>
                                    <el-table-column align="right" label="数量" min-width="75"
                                                     prop="quantity"></el-table-column>
                                    <el-table-column align="right" label="小计" min-width="100"
                                                     prop="subtotal_price"></el-table-column>
                                    <el-table-column label="备注" prop="remarks"></el-table-column>
                                </el-table>
                            </div>
                        </template>
                        <template v-else-if="field.field_type==='money_compute_mode'">
                            <div class="total_price_wrap">
                                <div class="total_price_inner_wrap">
                                    <div>共计：xxx</div>
                                </div>
                            </div>
                        </template>
                    </el-col>
                </el-row>
            </div>
            <div class="template_footer_wrap"></div>
        </div>
        <div v-else-if="project_quotation_tmpl_form==='project_quotation_tmpl_11'"
             ref="project_quotation_tmpl_11"
             class="template_11_wrap">
            <div class="template_header_wrap">
                <div class="left_logo_wrap">
                    <div :class="{'no_border':quotationForm.company_logo!==''}"
                         class="logo_outer_wrap"
                         @click="handleClickUploadLogo">
                        <img v-if="quotationForm.company_logo" :src="quotationForm.company_logo" alt=""
                             class="logo">
                        <div v-else class="upload_text">点击上传LOGO</div>
                    </div>
                </div>
                <div class="right_quotation_title_wrap">
                    <div class="quotation_title_wrap">
                        <el-input v-if="templateType==='add'"
                                  v-model="quotationForm.title"
                                  maxlength="20"
                                  placeholder="请输入标题"
                                  size="small"></el-input>
                        <span v-else v-text="quotationForm.title"></span>
                    </div>
                </div>
            </div>
            <div class="template_content_wrap">
                <el-row style="flex-wrap: wrap" type="flex">
                    <el-col v-for="(field,index) in templateFieldsList"
                            :span="field.extend.col_span">
                        <template v-if="field.field_type==='input'">
                            <div class="input_field_wrap">
                                <div class="field_label_wrap">
                                    <el-input v-model="field.field_name"
                                              :disabled="templateType==='detail'||field.is_system===1"
                                              autosize
                                              maxlength="10"
                                              :placeholder="templateType=='add'?'请输入标题':''"
                                              type="textarea"></el-input>
                                </div>
                                <div class="field_value_wrap">
                                    <div v-if="field.field_key==='project_name'">
                                        <el-popover v-model="projectListVisible"
                                                    placement="bottom"
                                                    popper-class="project_list_popover"
                                                    trigger="manual"
                                                    width="300">
                                            <el-input slot="reference"
                                                      v-model="quotationForm[field.field_key].value"
                                                      :disabled="templateType!=='add'"
                                                      :placeholder="field.is_system===1?field.extend.placeholder:'请输入'+field.field_name"
                                                      autosize
                                                      type="textarea"
                                                      @input="handleProjectNameInput(field)">
                                            </el-input>
                                            <ul class="project_list">
                                                <li v-for="item in projectList"
                                                    :key="item.project_id"
                                                    class="project_item"
                                                    @click="handleClickProjectName(item,field)"
                                                    v-text="item.name.value"></li>
                                            </ul>
                                        </el-popover>
                                    </div>
                                    <el-input v-else
                                              v-model="quotationForm[field.field_key].value"
                                              :disabled="templateType!=='add'"
                                              :placeholder="templateType=='add'?field.is_system===1?field.extend.placeholder:'请输入'+field.field_name:''"
                                              autosize
                                              type="textarea">
                                    </el-input>
                                </div>
                            </div>
                        </template>
                        <template v-else-if="field.field_type==='explain'">
                            <div class="explain_field" v-text="field.field_name"></div>
                        </template>
                        <template v-else-if="field.field_type==='textarea'">
                            <div class="textarea_field_wrap">
                                <div class="textarea_field_label" v-text="field.field_name"></div>
                                <div class="textarea_field_value"
                                     v-text="field.extend.placeholder?field.extend.placeholder:'请输入'"></div>
                            </div>
                        </template>
                        <template v-else-if="field.field_type==='goods'">
                            <div class="table_field_wrap">
                                <el-table :data="quotationForm[field.field_key]" border>
                                    <el-table-column align="center" label="序号" type="index"
                                                     width="50"></el-table-column>
                                    <el-table-column label="产品类别" min-width="100"
                                                     prop="product_category"></el-table-column>
                                    <el-table-column label="设备名称" min-width="130"
                                                     prop="equipment_name"></el-table-column>
                                    <el-table-column label="产品描述" min-width="190"
                                                     prop="product_description"></el-table-column>
                                    <el-table-column align="right" label="单价" min-width="100"
                                                     prop="unit_price"></el-table-column>
                                    <el-table-column align="center" label="单位" min-width="50"
                                                     prop="unit"></el-table-column>
                                    <el-table-column align="right" label="数量" min-width="75"
                                                     prop="quantity"></el-table-column>
                                    <el-table-column align="right" label="小计" min-width="100"
                                                     prop="subtotal_price"></el-table-column>
                                    <el-table-column label="备注" prop="remarks"></el-table-column>
                                </el-table>
                            </div>
                        </template>
                        <template v-else-if="field.field_type==='money_compute_mode'">
                            <div class="total_price_wrap">
                                <div class="total_price_inner_wrap">
                                    <div>共计：xxx</div>
                                </div>
                            </div>
                        </template>
                    </el-col>
                </el-row>
            </div>
            <div class="template_footer_wrap"></div>
        </div>
        <div v-else-if="project_quotation_tmpl_form==='project_quotation_tmpl_12'"
             ref="project_quotation_tmpl_12"
             class="template_12_wrap">
            <div class="template_header_wrap">
                <div :class="{'no_border':quotationForm.company_logo!==''}"
                     class="left_logo_wrap"
                     @click="handleClickUploadLogo">
                    <img v-if="quotationForm.company_logo" :src="quotationForm.company_logo" alt=""
                         class="logo">
                    <div v-else class="upload_text">点击上传LOGO</div>
                </div>
                <div class="right_quotation_title_wrap">
                    <div class="quotation_title_wrap">
                        <el-input v-if="templateType==='add'"
                                  v-model="quotationForm.title"
                                  maxlength="20"
                                  placeholder="请输入标题"
                                  size="small"></el-input>
                        <span v-else v-text="quotationForm.title"></span>
                    </div>
                </div>
            </div>
            <div class="template_content_wrap">
                <el-row style="flex-wrap: wrap" type="flex">
                    <el-col v-for="(field,index) in templateFieldsList.slice(0,templateFieldsList.length-2)"
                            :span="field.extend.col_span">
                        <template v-if="field.field_type==='input'">
                            <div class="input_field_wrap">
                                <div class="field_label_wrap">
                                    <el-input v-model="field.field_name"
                                              :disabled="templateType==='detail'||field.is_system===1"
                                              autosize
                                              maxlength="10"
                                              :placeholder="templateType=='add'?'请输入标题':''"
                                              type="textarea"></el-input>
                                </div>
                                <div class="field_value_wrap">
                                    <div v-if="field.field_key==='project_name'">
                                        <el-popover v-model="projectListVisible"
                                                    placement="bottom"
                                                    popper-class="project_list_popover"
                                                    trigger="manual"
                                                    width="300">
                                            <el-input slot="reference"
                                                      v-model="quotationForm[field.field_key].value"
                                                      :disabled="templateType!=='add'"
                                                      :placeholder="field.is_system===1?field.extend.placeholder:'请输入'+field.field_name"
                                                      autosize
                                                      type="textarea"
                                                      @input="handleProjectNameInput(field)">
                                            </el-input>
                                            <ul class="project_list">
                                                <li v-for="item in projectList"
                                                    :key="item.project_id"
                                                    class="project_item"
                                                    @click="handleClickProjectName(item,field)"
                                                    v-text="item.name.value"></li>
                                            </ul>
                                        </el-popover>
                                    </div>
                                    <el-input v-else
                                              v-model="quotationForm[field.field_key].value"
                                              :disabled="templateType!=='add'"
                                              :placeholder="templateType=='add'?field.is_system===1?field.extend.placeholder:'请输入'+field.field_name:''"
                                              autosize
                                              type="textarea">
                                    </el-input>
                                </div>
                            </div>
                        </template>
                        <template v-else-if="field.field_type==='explain'">
                            <div class="explain_field" v-text="field.field_name"></div>
                        </template>
                        <template v-else-if="field.field_type==='textarea'">
                            <div class="textarea_field_wrap">
                                <div class="textarea_field_label" v-text="field.field_name"></div>
                                <div class="textarea_field_value"
                                     v-text="field.extend.placeholder?field.extend.placeholder:'请输入'"></div>
                            </div>
                        </template>
                        <template v-else-if="field.field_type==='goods'">
                            <div class="table_field_wrap">
                                <el-table :data="quotationForm[field.field_key]" border>
                                    <el-table-column align="center" label="序号" type="index"
                                                     width="50"></el-table-column>
                                    <el-table-column label="产品类别" min-width="100"
                                                     prop="product_category"></el-table-column>
                                    <el-table-column label="设备名称" min-width="130"
                                                     prop="equipment_name"></el-table-column>
                                    <el-table-column label="产品描述" min-width="190"
                                                     prop="product_description"></el-table-column>
                                    <el-table-column align="right" label="单价" min-width="100"
                                                     prop="unit_price"></el-table-column>
                                    <el-table-column align="center" label="单位" min-width="50"
                                                     prop="unit"></el-table-column>
                                    <el-table-column align="right" label="数量" min-width="75"
                                                     prop="quantity"></el-table-column>
                                    <el-table-column align="right" label="小计" min-width="100"
                                                     prop="subtotal_price"></el-table-column>
                                    <el-table-column label="备注" prop="remarks"></el-table-column>
                                </el-table>
                            </div>
                        </template>
                        <template v-else-if="field.field_type==='money_compute_mode'">
                            <div class="total_price_wrap">
                                <div class="total_price_inner_wrap">
                                    <div>共计：xxx</div>
                                </div>
                            </div>
                        </template>
                    </el-col>
                </el-row>
            </div>
            <div class="template_footer_wrap">
                <div class="footer_left_wrap">
                    <div class="quotation_title_wrap">XX公司</div>
                </div>
                <div class="footer_right_wrap">
                    <el-row style="flex-wrap: wrap" type="flex">
                        <el-col v-for="(field,index) in templateFieldsList.slice(templateFieldsList.length-2)"
                                :span="24">
                            <template v-if="field.field_type==='input'">
                                <div class="input_field_wrap">
                                    <div class="field_label_wrap" v-text="field.field_name"></div>
                                    <div class="field_value_wrap"
                                         v-text="field.extend.placeholder?field.extend.placeholder:'请输入'"></div>
                                </div>
                            </template>
                            <template v-else-if="field.field_type==='textarea'">
                                <div class="textarea_field_wrap">
                                    <div class="textarea_field_label" v-text="field.field_name"></div>
                                    <div class="textarea_field_value"
                                         v-text="field.extend.placeholder?field.extend.placeholder:'请输入'"></div>
                                </div>
                            </template>
                        </el-col>
                    </el-row>
                </div>
            </div>
        </div>
        <el-dialog v-if="relateCustomFormVisible"
                   :before-close="handleClickRelateFormCancel"
                   :close-on-click-modal="false"
                   :close-on-press-escape="false"
                   :title="relate_pk_id?'编辑' + nowFieldData.field_name:'新增' + nowFieldData.field_name"
                   :visible.sync="relateCustomFormVisible"
                   append-to-body
                   custom-class="custom_form_dialog custom-form-dialog"
                   width="560px">
            <div class="relate_custom_form_body">
                <CustomFormPc ref="relateCustomForm"
                              :field_list="relateCustomFormFields"
                              :form_detail="relateCustomFormData"
                              :pk_id="relate_pk_id"
                              @submit-form="submitRelateFormData"/>
            </div>
            <div slot="footer">
                <el-button size="small" @click="handleClickRelateFormCancel">取消</el-button>
                <el-button :disabled="btnDisabled"
                           size="small"
                           type="primary"
                           @click="handleClickRelateFormConfirm">保存
                </el-button>
            </div>
        </el-dialog>
        <!--选择订单产品弹窗-->
        <SelectOrderProducts v-if="selectProductVisible"
                             ref="selectOrderProducts"
                             :dialogVisible.sync="selectProductVisible"
                             :source="'quotation'"
                             @send-goods-data="handleClickSelectProductsConfirm">
        </SelectOrderProducts>
    </div>
</template>
<script>
import draggable from 'vuedraggable'
import CustomFormPc from '@/components/pComponents/CustomFormPc'
import {uploadImg} from "@/utils/uploadOss";
import {mapState} from "vuex";
import {getNowDate, numberPriceToChinese, tableDataFieldShow} from '@/utils'
import html2canvas from "html2canvas";
import SelectOrderProducts from "@/components/pComponents/SelectOrderProducts";
import {
    addContact,
    contactDetail,
    CustomerPrivateAdd,
    editContact,
    GetContactList,
    GetCustomerPrivateList,
    getFormFields,
    getFormSnapshotFields,
    GetUserList,
    projectList,
    projectQuotationReSubmitDetail
} from "@/api";

export default {
    name: "templateComponent",
    data() {
        return {
            quotationForm: {
                title: 'XX公司报价单',
                company_logo: 'https://download.hecoos.com/enlightv/2024-51/acafb05b80f7b29e09cddd6f0c0e24b2.png',
                project_id: '',
                /*title: '',
                    company_logo: '',
                    project_id: '',*/
            },
            templateFieldsList: [],
            fieldKeyIndex: 1,
            userList: [],
            relateFieldForm: '',
            relateCustomFormFields: [],
            relateCustomFormData: {},
            relateCustomFormVisible: false,
            relate_pk_id: 0,
            btnDisabled: false,
            nowFieldData: {},
            nowFormData: {},
            currency: 'CNY',
            selectProductVisible: false,
            projectListVisible: false,
            projectList: [],
            loading: false,
        }
    },
    props: {
        project_quotation_tmpl_form: {
            type: String,
            default: ''
        },
        form_snapshot_key: {
            type: String,
            default: ''
        },
        project_quotation_id: {
            type: Number,
            default: 0
        },
        templateType: {
            type: String,
            default: 'add'
        },
        fields_list: {
            type: Array,
            default: () => []
        },
        quotation_detail: {
            type: Object,
            default: () => {
                return {}
            }
        }
    },
    components: {draggable, CustomFormPc, SelectOrderProducts},
    computed: {
        product_list_index() {
            return this.templateFieldsList.findIndex(item => item.field_key === 'quotation_goods') + 2
        },
        ...mapState(['userInfo', 'relateProjectData'])
    },
    created() {
        if (this.templateType === 'add') {
            this.loading = true
            if (this.project_quotation_id) {
                projectQuotationReSubmitDetail({
                    project_quotation_id: this.project_quotation_id
                }).then(res => {
                    if (res.code === 200) {
                        this.formInfoList = res.data.custom_fields
                        const {formData, fieldList} = this.deepCreateFormData(this.formInfoList)
                        for (let dataKey in res.data) {
                            this.quotationForm[dataKey] = res.data[dataKey]
                        }
                        this.templateFieldsList = fieldList
                        const customer_id = this.templateFieldsList.find(item => item.field_key === 'customer_id')
                        this.getCustomerList('', customer_id)
                        const customer_contact_field = this.templateFieldsList.find(item => item.field_type === 'customer_contact')
                        this.getRelateContactList('', customer_contact_field, false)
                    } else {
                        this.$message.error(res.message)
                    }
                    this.loading = false
                })
            } else {
                if (this.form_snapshot_key) {
                    getFormSnapshotFields({
                        project_quotation_tmpl_form: this.project_quotation_tmpl_form,
                        form_snapshot_key: this.form_snapshot_key
                    }).then(res => {
                        if (res.code === 200) {
                            this.formInfoList = res.data
                            const {formData, fieldList} = this.deepCreateFormData(this.formInfoList)
                            this.quotationForm = {...formData, ...this.quotationForm}
                            this.templateFieldsList = fieldList
                        } else {
                            this.$message.error(res.message)
                        }
                        this.loading = false
                    }).catch(() => {
                        this.loading = false
                    })
                } else {
                    getFormFields({
                        field_form: this.project_quotation_tmpl_form
                    }).then(res => {
                        if (res.code === 200) {
                            this.formInfoList = res.data
                            const {formData, fieldList} = this.deepCreateFormData(this.formInfoList)
                            this.quotationForm = {...formData, ...this.quotationForm}
                            this.templateFieldsList = fieldList
                            if (Object.keys(this.relateProjectData).length > 0) {
                                this.quotationForm.project_id = this.relateProjectData.project_id
                                this.quotationForm.project_name = this.relateProjectData.project_name
                                this.quotationForm.customer_id = this.relateProjectData.customer_id
                                this.quotationForm.contact_id = this.relateProjectData.contact_id
                                this.quotationForm.contact_phone = this.relateProjectData.contact_phone
                                if (this.quotationForm.customer_id.text) {
                                    const customer_id = this.templateFieldsList.find(item => item.field_key === 'customer_id')
                                    this.getCustomerList(this.quotationForm.customer_id.text, customer_id)
                                }
                                if (this.quotationForm.contact_id.text && this.quotationForm.contact_id.text.length) {
                                    const customer_contact_field = this.templateFieldsList.find(item => item.field_type === 'customer_contact')
                                    this.getRelateContactList(this.quotationForm.contact_id.text[0], customer_contact_field, false)
                                }
                                this.$store.dispatch('saveRelateProjectData', {})
                            }
                        } else {
                            this.$message.error(res.message)
                        }
                        this.loading = false
                    }).catch(() => {
                        this.loading = false
                    })
                }
            }
        } else {
            if (this.fields_list.length) {
                const {formData, fieldList} = this.deepCreateFormData(this.fields_list)
                this.quotationForm = {...formData, ...this.quotationForm}
                this.templateFieldsList = fieldList
                if (Object.keys(this.quotation_detail).length > 0) {
                    for (const key in this.quotation_detail) {
                        this.quotationForm[key] = this.quotation_detail[key]
                    }
                }
            }
        }
    },
    mounted() {

    },
    methods: {
        // 深度拷贝生成表单数据
        deepCreateFormData(field_data, is_parent) {
            let fieldList = []
            let formData = {}
            field_data.forEach(field => {
                switch (field.field_type) {
                    case 'input':
                        formData[field.field_key] = is_parent ? '' : {
                            value: field.field_key === 'quoter_phone' ? this.userInfo.user.phone : '',
                        }
                        break
                    case 'textarea':
                        formData[field.field_key] = is_parent ? '' : {
                            value: '',
                        }
                        break
                    case 'number':
                        formData[field.field_key] = is_parent ? '' : {
                            value: '',
                            text: '',
                        }
                        break
                    case 'money':
                        formData[field.field_key] = {
                            value: '',
                            text: '',
                            currency: 'CNY',
                            chinese_text: '',
                            value_converted: '',
                        }
                        break
                    case 'compute_mode':
                        formData[field.field_key] = {
                            value: '',
                            text: '',
                            chinese_text: '',
                        }
                        break
                    case 'money_compute_mode':
                        formData[field.field_key] = {
                            value: '',
                            text: '',
                            currency: 'CNY',
                            value_converted: '',
                        }
                        break
                    case 'telephone':
                        formData[field.field_key] = {
                            value: '',
                            phone_type: '',
                            prefix: '+86',
                        }
                        break
                    case 'customer_contact':
                        formData[field.field_key] = {
                            value: [],
                            text: []
                        }
                        break
                    case 'radio_customer':
                        formData[field.field_key] = {
                            value: '',
                            text: ''
                        }
                        break
                    case 'contact':
                        if (field.extend.default && this.templateType === 'add') {
                            formData[field.field_key] = {
                                value: [this.userInfo.user.id],
                                text: [{
                                    id: this.userInfo.user.id,
                                    name: this.userInfo.user.name,
                                    avatar: this.userInfo.user.avatar,
                                }]
                            }
                            this.getUserList('', [this.userInfo.user.id])
                        } else {
                            formData[field.field_key] = {
                                value: [],
                                text: [],
                            }
                        }
                        break
                    case 'date':
                        const today = getNowDate(field.date_type)
                        if (field.field_key === 'quotation_at') {
                            formData[field.field_key] = {
                                value: this.templateType === 'add' ? today : '',
                                text: '',
                            }
                        } else {
                            formData[field.field_key] = {
                                value: this.templateType === 'add' ? this.getDateAfterSevenDays(today) : '',
                                text: '',
                            }
                        }
                        if (this.templateType === 'add') {
                            setTimeout(() => {
                                this.$set(formData[field.field_key], 'text', this.$refs['date_picker_' + field.field_key][0].displayValue)
                            }, 300)
                        }
                        break
                    case 'goods':
                        const fieldData = this.deepCreateFormData(field._child, true)
                        formData[field.field_key] = [
                            {
                                goods_id: 0,
                                goods_name: "",
                                goods_type: 1,
                                sku_id: 0,
                                sku_key: "",
                                sku: "",
                                part_id: 1,
                                part_name: "",
                                price: {
                                    value: '',
                                    text: "",
                                    currency: "CNY",
                                    value_converted: '',
                                },
                                num: '',
                                subtotal_price: {
                                    value: '',
                                    text: "",
                                    currency: "CNY",
                                    value_converted: '',
                                },
                                unit: "",
                                description: "",
                            },
                        ]
                        break
                }
                fieldList.push(field)
            })
            return {
                formData,
                fieldList
            }
        },

        //点击上传logo
        handleClickUploadLogo() {
            if (this.templateType === 'detail') return false
            const that = this
            const input = document.createElement('input')
            input.setAttribute('type', 'file')
            input.setAttribute('accept', 'image/png,image/jpeg,image/jpg')
            input.click()
            input.onchange = function () {
                const fail = this.files[0];
                uploadImg(fail, fail.size).then(res => {
                    if (res.file_path) {
                        that.quotationForm.company_logo = res.file_path
                    }
                }).catch(error => {

                })
            }
        },

        //拖拽组件事件
        onDragFormItemMove(e) {
            if (e.relatedContext.element && e.relatedContext.element.extend.hasOwnProperty('can_dock')) return false
        },

        //拖拽结束事件
        onDragFormItemEnd() {
            this.templateFieldsList.forEach((field, index) => {
                field.sort = index + 1
            })
        },

        //操作按钮是否显示
        handleIconIsShow(index) {
            let count = 0;
            for (let i = 0; i < index; i++) {
                count += this.templateFieldsList[i].extend.col_span;
            }
            return count % 24 < 12 || this.templateFieldsList[index].extend.col_span === 24; // 在第一列的条件
        },

        //点击添加字段
        handleClickAddTemplateField(field, index) {
            if (field.field_type === 'table') {
                const {formData} = this.deepCreateFormData(field._child)
                this.quotationForm[field.field_key].push(formData)
            } else if (field.field_type === 'explain') {
                const obj = {
                    field_name: "",
                    field_form: "quotation_template",
                    field_key: this.templateType === 'add' ? 'custom_field_' + this.fieldKeyIndex : 'field_' + this.fieldKeyIndex,
                    field_type: "explain",
                    p_field_key: "",
                    quote_field_form: "",
                    quote_field_key: "",
                    is_system: 0,
                    is_system_key: 0,
                    is_reset: 1,
                    is_unique: 0,
                    is_required: 0,
                    extend: {
                        col_span: 24,
                    },
                    status: 0,
                    sort: 1,
                    rules: []
                }
                this.templateFieldsList.splice(index + 1, 0, obj)
                this.fieldKeyIndex++
            } else if (field.field_type === 'textarea') {
                const obj = {
                    field_name: "",
                    field_form: "quotation_template",
                    field_key: this.templateType === 'add' ? 'custom_field_' + this.fieldKeyIndex : 'field_' + this.fieldKeyIndex,
                    field_type: "textarea",
                    p_field_key: "",
                    quote_field_form: "",
                    quote_field_key: "",
                    is_system: 0,
                    is_system_key: 0,
                    is_reset: 1,
                    is_unique: 0,
                    is_required: 0,
                    extend: {
                        col_span: 24,
                        placeholder: '请输入',
                    },
                    status: 0,
                    sort: 1,
                    rules: []
                }
                this.templateFieldsList.splice(index + 1, 0, obj)
                this.$set(this.quotationForm, obj.field_key, {
                    value: ''
                })
                this.fieldKeyIndex++
            } else {
                const sort = field.extend.col_span === 24 ? 1 : 2
                const obj1 = {
                    field_name: "",
                    field_form: "quotation_template",
                    field_key: this.templateType === 'add' ? 'custom_field_' + this.fieldKeyIndex : 'field_' + this.fieldKeyIndex,
                    field_type: "input",
                    p_field_key: "",
                    quote_field_form: "",
                    quote_field_key: "",
                    is_system: 0,
                    is_system_key: 0,
                    is_reset: 1,
                    is_unique: 0,
                    is_required: 0,
                    extend: {
                        col_span: 12,
                        placeholder: '请输入',
                    },
                    status: 0,
                    sort: 1,
                    rules: []
                }
                this.templateFieldsList.splice(index + sort, 0, obj1)
                this.$set(this.quotationForm, obj1.field_key, {
                    value: ''
                })
                this.fieldKeyIndex++
                const obj2 = {
                    field_name: "",
                    field_form: "quotation_template",
                    field_key: this.templateType === 'add' ? 'custom_field_' + this.fieldKeyIndex : 'field_' + this.fieldKeyIndex,
                    field_type: "input",
                    p_field_key: "",
                    quote_field_form: "",
                    quote_field_key: "",
                    is_system: 0,
                    is_system_key: 0,
                    is_reset: 1,
                    is_unique: 0,
                    is_required: 0,
                    extend: {
                        col_span: 12,
                        placeholder: '请输入',
                    },
                    status: 0,
                    sort: 1,
                    rules: []
                }
                this.templateFieldsList.splice(index + sort + 1, 0, obj2)
                this.$set(this.quotationForm, obj2.field_key, {
                    value: ''
                })
                this.fieldKeyIndex++
            }
        },

        //点击删除字段
        handleClickDelTemplateField(field, index) {
            if (field.field_type === 'table') {
                this.quotationForm[field.field_key].pop()
            } else if (field.field_type === 'explain') {
                this.templateFieldsList.splice(index, 1)
            } else if (field.field_type === 'textarea') {
                this.templateFieldsList.splice(index, 1)
            } else {
                this.templateFieldsList.splice(index, 1)
                this.templateFieldsList.splice(index, 1)
            }
        },

        //项目名称输入事件
        handleProjectNameInput(field) {
            this.quotationForm.project_id = ''
            const keyword = this.quotationForm[field.field_key].value;
            projectList({
                page: 1,
                size: 100,
                keyword: keyword,
                custom_filter: []
            }).then(res => {
                if (res.code === 200) {
                    this.projectList = res.data.data
                    if (this.projectList.length) {
                        this.projectListVisible = true
                    } else {
                        this.projectListVisible = false
                    }
                } else {
                    this.$message.error(res.message)
                }
            })
        },

        //选择项目名称
        handleClickProjectName(item, field) {
            this.quotationForm.project_id = item.project_id
            this.$set(this.quotationForm[field.field_key], 'value', item.name.value)
            this.$set(this.quotationForm, 'customer_id', item.customer_id)
            this.$set(this.quotationForm, 'contact_id', item.contact_id)
            const customer_id = this.templateFieldsList.find(item => item.field_key === 'customer_id')
            this.getCustomerList(item.customer_id.text, customer_id)
            const customer_contact_field = this.templateFieldsList.find(item => item.field_type === 'customer_contact')
            this.getRelateContactList('', customer_contact_field, false)
            this.$set(this.quotationForm.contact_phone, 'value', item.contact_phone)
            this.projectListVisible = false
        },

        //关联客户选择框聚焦事件
        handleRelateCustomerRadioFocus(field) {
            if (!field.extend.hasOwnProperty('options') || field.extend.options.length === 0) {
                this.getCustomerList('', field)
            }
        },

        //获取客户列表
        getCustomerList(keyword, field) {
            GetCustomerPrivateList({
                keyword: keyword
            }).then(res => {
                if (res.code === 200) {
                    this.$set(field.extend, 'options', res.data.data)
                }
            }).catch(() => {

            })
        },

        //选择关联客户事件
        handleClickRelateCustomerRadio(item, field) {
            this.quotationForm[field.field_key].text = item.name.value
            const customer_contact_field = this.templateFieldsList.find(item => item.field_type === 'customer_contact')
            this.getRelateContactList('', customer_contact_field, true)
        },

        //联系人选择框聚焦
        handleContactSelectFocus() {
            if (this.userList.length === 0) {
                this.getUserList()
            }
        },

        //联系人选择事件
        handleClickContactItem(user, field) {
            if (this.quotationForm[field.field_key].value.includes(user.uid)) {
                //选中事件
                this.quotationForm[field.field_key].text = [{
                    id: user.uid,
                    name: user.name,
                    avatar: user.avatar,
                }]
                this.$refs[`${field.field_key}_contact_select`][0].blur()
                this.quotationForm.quoter_phone.value = user.phone
            } else {
                //取消选中事件
                this.quotationForm[field.field_key].text = []
            }
        },

        //已选联系人标签移除
        handleRemoveContactTag(tag, field) {
            this.quotationForm[field.field_key].text.splice(this.quotationForm[field.field_key].text.findIndex(item => item.id === tag), 1)
        },

        //获取用户列表
        getUserList(keyword, uids) {
            GetUserList({
                keyword,
                uids
            }).then(res => {
                if (res.code === 200) {
                    this.userList = res.data || []
                } else {
                    this.$message.error(res.message)
                }
            })
        },

        //日期选择框选择事件
        handleSelectDateChange(field) {
            this.$set(this.quotationForm[field.field_key], 'text', this.$refs['date_picker_' + field.field_key][0].displayValue)
            if (field.field_key === 'quotation_at') {
                this.$set(this.quotationForm.expiration_at, 'value', this.getDateAfterSevenDays(this.quotationForm[field.field_key].value))
                this.$nextTick(() => {
                    this.$set(this.quotationForm.expiration_at, 'text', this.$refs['date_picker_expiration_at'][0].displayValue)
                    this.$message.warning(`该报价单生效时间将持续至${this.quotationForm.expiration_at.text} 23:59:59`)
                })
            }
        },

        //获取7天后的日期
        getDateAfterSevenDays(today) {
            const date = new Date(today);
            date.setDate(date.getDate() + 7);
            const year = date.getFullYear();
            const month = String(date.getMonth() + 1).padStart(2, '0'); // 月份从0开始，所以加1
            const day = String(date.getDate()).padStart(2, '0');
            return `${year}-${month}-${day}`
        },

        //获取关联联系人列表
        getRelateContactList(name, field, auto_fill) {
            if ((this.quotationForm.customer_id && this.quotationForm.customer_id.value) || this.relate_customer_id !== 0) {
                GetContactList({
                    customer_id: this.quotationForm.customer_id.value,
                    name: name
                }).then(res => {
                    if (res.code === 200) {
                        if (res.data.list.length) {
                            this.$set(field, 'options', res.data.list)
                            if (auto_fill) {
                                this.$set(this.quotationForm[field.field_key], 'value', [res.data.list[0].id])
                                this.$set(this.quotationForm[field.field_key], 'text', [res.data.list[0].name])
                                this.$set(this.quotationForm.contact_phone, 'value', res.data.list[0].phone)
                            }
                        } else {
                            this.$set(this.quotationForm[field.field_key], 'value', [])
                            this.$set(this.quotationForm[field.field_key], 'text', [])
                        }
                    } else {
                        this.$message.error(res.message)
                    }
                })
            }
        },

        //关联联系人选择框聚焦事件
        handleCustomerContactSelectFocus(field) {
            if ((!field.hasOwnProperty('options') || field.options.length === 0) && this.quotationForm.customer_id.value) {
                this.getRelateContactList('', field)
            }
        },

        //已选联系人标签移除事件
        handleRemoveCustomerContactSelectTag() {
            this.$set(this.quotationForm.contact_id, 'text', [])
        },

        //关联联系人选择事件
        handleSelectCustomerContact(item) {
            this.$set(this.quotationForm.contact_id, 'text', [item.name])
            this.$set(this.quotationForm.contact_phone, 'value', item.phone)
        },

        //点击添加关联表单
        handleClickAddRelateForm(field, field_form) {
            if (field_form === 'customer_contacts' && this.quotationForm.customer_id && this.quotationForm.customer_id.value === '') return this.$message.error('请先选择关联客户')
            this.relateFieldForm = field_form
            this.nowFieldData = field
            this.relate_pk_id = 0
            getFormFields({
                field_form
            }).then(res => {
                if (res.code === 200) {
                    this.relateCustomFormFields = res.data
                    this.relateCustomFormVisible = true
                } else {
                    this.$message.error(res.message)
                }
            }).catch(() => {

            })
        },

        //新增关联表单取消事件
        handleClickRelateFormCancel() {
            this.relateCustomFormVisible = false
            this.relate_pk_id = 0
        },

        //新增关联表单确认事件
        handleClickRelateFormConfirm() {
            this.$refs.relateCustomForm.handleClickPublish()
        },

        //点击选择产品
        handleClickSelectProject(formData, field) {
            this.nowFieldData = field
            this.nowFormData = formData
            this.selectProductVisible = true

            /*const data = [
                {
                    "type": 1,
                    "goods_id": 51,
                    "goods_name": "水果大礼包礼盒（套）",
                    "goods_type": "bundle",
                    "goods_sku_id": 0,
                    "sku_key": "",
                    "goods_sku_name": "水果大礼包礼盒（套）",
                    "start_at": "",
                    "end_at": "",
                    "cost_price": "2110.00",
                    "guide_price": "6630.00",
                    "sale_guide_price": "6630.00",
                    "lease_guide_price": "4810.00",
                    "price": {
                        "value": "6630.00",
                        "text": "6630.00",
                        "currency": "CNY",
                        "value_converted": "6630.00"
                    },
                    "num": 1,
                    "subtotal_price": {
                        "value": 6630,
                        "text": "6,630.00",
                        "currency": "CNY",
                        "value_converted": 6630
                    },
                    "unit": "",
                    "is_virtual": 1,
                    "goods_image": "",
                    "is_sale": 1,
                    "is_lease": 1,
                    "description": "水果大礼包礼盒",
                    "_child": [
                        {
                            "type": 1,
                            "goods_id": 51,
                            "goods_name": "水果",
                            "goods_type": "stock",
                            "goods_sku_id": 63,
                            "sku_key": "",
                            "goods_sku_name": "西红柿（可用）",
                            "part_id": 11,
                            "part_name": "水果",
                            "start_at": "",
                            "end_at": "",
                            "cost_price": "110.00",
                            "guide_price": "3130.00",
                            "num": 1,
                            "price": {
                                "value": 0,
                                "text": 0,
                                "currency": "CNY",
                                "value_converted": 0
                            },
                            "subtotal_price": {
                                "value": 0,
                                "text": 0,
                                "currency": "CNY",
                                "value_converted": 0
                            },
                            "unit": "",
                            "is_virtual": 1
                        },
                        {
                            "type": 1,
                            "goods_id": 51,
                            "goods_name": "水果手机",
                            "goods_type": "basic",
                            "goods_sku_id": 1,
                            "sku_key": "1,3",
                            "goods_sku_name": "手机-小米-白色-64G",
                            "part_id": 12,
                            "part_name": "水果手机",
                            "start_at": "",
                            "end_at": "",
                            "cost_price": "1000.00",
                            "guide_price": "1500.00",
                            "num": 1,
                            "price": {
                                "value": 0,
                                "text": 0,
                                "currency": "CNY",
                                "value_converted": 0
                            },
                            "subtotal_price": {
                                "value": 0,
                                "text": 0,
                                "currency": "CNY",
                                "value_converted": 0
                            },
                            "unit": "台",
                            "is_virtual": 1
                        },
                        {
                            "type": 1,
                            "goods_id": 51,
                            "goods_name": "水果电脑",
                            "goods_type": "basic",
                            "goods_sku_id": 7,
                            "sku_key": "6,7",
                            "goods_sku_name": "电脑3",
                            "part_id": 13,
                            "part_name": "水果电脑",
                            "start_at": "",
                            "end_at": "",
                            "cost_price": "1000.00",
                            "guide_price": "2000.00",
                            "num": 1,
                            "price": {
                                "value": 0,
                                "text": 0,
                                "currency": "CNY",
                                "value_converted": 0
                            },
                            "subtotal_price": {
                                "value": 0,
                                "text": 0,
                                "currency": "CNY",
                                "value_converted": 0
                            },
                            "unit": "台",
                            "is_virtual": 1
                        }
                    ]
                },
                {
                    "type": 1,
                    "goods_id": 47,
                    "goods_name": "西红柿（可用）",
                    "goods_type": "stock",
                    "goods_sku_id": 63,
                    "sku_key": "",
                    "goods_sku_name": "",
                    "start_at": "",
                    "end_at": "",
                    "cost_price": "110.00",
                    "guide_price": "3130.00",
                    "lease_guide_price": "310.00",
                    "sale_guide_price": "3130.00",
                    "price": {
                        "value": "3130.00",
                        "text": "3130.00",
                        "currency": "CNY",
                        "value_converted": "3130.00"
                    },
                    "num": 1,
                    "subtotal_price": {
                        "value": 3130,
                        "text": "3,130.00",
                        "currency": "CNY",
                        "value_converted": 3130
                    },
                    "unit": "",
                    "is_virtual": 1,
                    "goods_image": "",
                    "is_sale": 1,
                    "is_lease": 1,
                    "description": "水果大礼包礼盒"
                },
                {
                    "type": 1,
                    "goods_id": 2,
                    "goods_name": "电脑",
                    "goods_type": "basic",
                    "goods_sku_id": 5,
                    "sku_key": "5,7",
                    "goods_sku_name": "电脑1",
                    "start_at": "",
                    "end_at": "",
                    "cost_price": "1000.00",
                    "guide_price": "2000.00",
                    "lease_guide_price": "2500.00",
                    "sale_guide_price": "2000.00",
                    "price": {
                        "value": "2000.00",
                        "text": "2000.00",
                        "currency": "CNY",
                        "value_converted": "2000.00"
                    },
                    "num": 1,
                    "subtotal_price": {
                        "value": 2000,
                        "text": "2,000.00",
                        "currency": "CNY",
                        "value_converted": 2000
                    },
                    "unit": "台",
                    "is_virtual": 1,
                    "goods_image": "https://download.hecoos.com/enlightv/2025-03/024dbeffd3f4fe9661a597360d604293.jpg",
                    "is_sale": 1,
                    "is_lease": 1,
                    "description": "1111111111111111111111111111111111111111111111111111111111111111111111"
                },
                {
                    "type": 1,
                    "goods_id": 1,
                    "goods_name": "手机",
                    "goods_type": "basic",
                    "goods_sku_id": 1,
                    "sku_key": "1,3",
                    "goods_sku_name": "手机-小米-白色-64G",
                    "start_at": "",
                    "end_at": "",
                    "cost_price": "1000.00",
                    "guide_price": "1500.00",
                    "lease_guide_price": "2000.00",
                    "sale_guide_price": "1500.00",
                    "price": {
                        "value": "1500.00",
                        "text": "1500.00",
                        "currency": "CNY",
                        "value_converted": "1500.00"
                    },
                    "num": 1,
                    "subtotal_price": {
                        "value": 1500,
                        "text": "1,500.00",
                        "currency": "CNY",
                        "value_converted": 1500
                    },
                    "unit": "台",
                    "is_virtual": 1,
                    "goods_image": "https://download.hecoos.com/enlightv/2024-43/c73350a32956fbe8fca6e9da9ac21198.svg",
                    "is_sale": 1,
                    "is_lease": 1,
                    "description": "手机手机手机手机手机"
                }
            ]
            this.quotationForm.quotation_goods = JSON.parse(JSON.stringify(data))
            this.computedTotalPriceFun()*/
        },

        handleClickSelectProductsConfirm(data) {
            this.quotationForm.quotation_goods = JSON.parse(JSON.stringify(data))
            this.computedTotalPriceFun()
        },

        //价格输入框失焦事件
        handlePriceInputBlur(field, row) {
            let value = row[field.field_key].text.replace(/[^\d.]/g, '')
            this.$set(row.price, 'value', value ? Number(value) : 0)
            this.$set(row.price, 'text', value ? Number(value).toLocaleString(undefined, {
                minimumFractionDigits: 2,
                maximumFractionDigits: 2
            }) : 0)
            this.computedModeFun(row);
        },

        //数量输入框失焦事件
        handleNumberInputBlur(field, row) {
            let value = row[field.field_key].replace(/[^\d.]/g, '')
            this.$set(row, field.field_key, value ? Number(value) : 0)
            this.computedModeFun(row);
        },

        //计算公式
        computedModeFun(row) {
            const subtotal_price = row.price.value * row.num
            this.$set(row.subtotal_price, 'value', Number(subtotal_price))
            this.$set(row.subtotal_price, 'text', Number(subtotal_price).toLocaleString(undefined, {
                minimumFractionDigits: 2,
                maximumFractionDigits: 2
            }))
            this.computedTotalPriceFun()
        },

        //计算商品总金额
        computedTotalPriceFun() {
            const total_price = this.quotationForm.quotation_goods.reduce((total, item) => {
                return total + item.subtotal_price.value
            }, 0)
            this.quotationForm.total_price.value = total_price
            this.quotationForm.total_price.text = Number(total_price).toLocaleString(undefined, {
                minimumFractionDigits: 2,
                maximumFractionDigits: 2,
            })
            const total_price_field = this.templateFieldsList.find(item => item.field_key === 'total_price')
            if (total_price_field.extend.format.includes('1')) {
                this.$set(this.quotationForm.total_price, 'chinese_text', numberPriceToChinese(total_price, true))
            }
        },

        //单价单位切换事件
        handlePriceUnitChange(val) {
            // let currency = val === 'CNY' ? '￥' : '$'
            this.quotationForm.quotation_goods.forEach(item => {
                item.price.currency = val
                /*if (item.price.text !== '') {
                        item.price.text = item.price.text.replace(currency, val)
                    }
                    if (item.subtotal_price.text !== '') {
                        item.subtotal_price.text = item.subtotal_price.text.replace(currency, val)
                    }*/
            })
            this.quotationForm.total_price.currency = val
            if (this.quotationForm.total_price.text !== '') {
                this.quotationForm.total_price.text = this.quotationForm.total_price.text.replace(currency, val)
            }
        },

        //提交关联表单数据
        submitRelateFormData(customForm) {
            this.btnDisabled = true
            if (this.relate_pk_id) {
                //编辑
                if (this.relateFieldForm === 'customer_contacts') {
                    editContact(this.relate_pk_id, customForm).then(res => {
                        if (res.code === 200) {
                            this.$message.success(res.message)
                            this.quotationForm[this.nowFieldData.field_key].text.find(user => user.id === this.relate_pk_id).name = customForm.name.value
                            this.btnDisabled = false
                            this.handleClickRelateFormCancel()
                        } else {
                            this.$message.error(res.message)
                        }
                    })
                } else if (this.relateFieldForm === 'customers') {

                }
            } else {
                //新增
                if (this.relateFieldForm === 'customer_contacts') {
                    if (this.customForm.customer_id && this.customForm.customer_id.value) {
                        customForm.customer_id = this.customForm.customer_id.value
                    }
                    if (this.relate_customer_id !== 0) {
                        customForm.customer_id = this.relate_customer_id
                    }
                    addContact(customForm).then(res => {
                        if (res.code === 200) {
                            this.$message.success(res.message)
                            this.handleClickRelateFormCancel()
                            this.getRelateContactList('', this.nowFieldData)
                            this.btnDisabled = false
                        } else {
                            this.$message.error(res.message)
                        }
                    }).catch(() => {
                    })
                } else if (this.relateFieldForm === 'customers') {
                    CustomerPrivateAdd(customForm).then(res => {
                        if (res.code === 200) {
                            this.$message.success(res.message)
                            this.handleClickRelateFormCancel()
                            this.getCustomerList('', this.nowFieldData)
                            this.btnDisabled = false
                        } else {
                            this.$message.error(res.message)
                        }
                    })
                }
            }
        },
    },
}
</script>
<style lang="scss">
.template_review_wrapper {
    width: 100%;

    .el-textarea {
        .el-textarea__inner {
            resize: unset;
            border: none;
            background-color: transparent;
        }

        &.is-disabled {
            .el-textarea__inner {
                color: #666666;
                cursor: text;
            }
        }
    }

    .el-input {
        .el-input__inner {
            border: none;
            background-color: transparent;
        }

        &.is-disabled .el-input__inner {
            cursor: text;
            color: #333333;
        }
    }

    .el-select {
        width: 100%;
    }

    .el-date-editor.el-input {
        width: 100%;

        .el-input__inner {
            padding: 8px 30px !important;
        }
    }

    .el-table__body-wrapper {
        overflow-x: hidden;
    }

    .el-table {
        td.el-table__cell {
            padding: 0;

            .cell {
                padding: 0;
            }
        }
    }

    .no_border {
        border: none !important;
    }

    .customer_contact_select_wrap {
        width: 100%;
        position: relative;

        .el-icon-circle-plus {
            color: #BFBFBF;
            font-size: 16px !important;
            cursor: pointer;
            position: absolute;
            right: 10px;
            top: 50%;
            transform: translateY(-50%);
        }

        .el-select__tags {
            .el-tag {
                cursor: pointer;
            }
        }
    }

    .table_header_wrap {
        display: flex;
        align-items: center;
        gap: 4px;

        .el-select {
            flex: 1;

            .el-input--mini .el-input__inner {
                line-height: 22px;
                height: 22px;
            }

            .el-input__suffix {
                display: none;
            }
        }
    }

    .table_input_field_wrap {
        display: flex;
        align-items: center;
        padding-right: 4px;

        .el-textarea {
            flex: 1;
        }
    }

    .form_module_content_wrap {
        display: flex;
        flex-wrap: wrap;

        .template_field_item_wrap {
            width: 50%;
            transition: background-color 0.3s;
            position: relative;

            &:hover {
                background: rgba(0, 0, 0, 0.04);

                .field_handle_icon_wrap {
                    display: block;
                }
            }

            .field_handle_icon_wrap {
                height: 38px;
                position: absolute;
                left: -18px;
                bottom: -8px;
                padding-right: 2px;
                display: none;

                .remove_icon_wrap {
                    cursor: pointer;
                    width: 16px;
                    height: 16px;
                    position: relative;

                    &::before {
                        content: '';
                        width: 1px;
                        height: 38px;
                        background: #E44144;
                        position: absolute;
                        right: -2px;
                        top: -8px;
                        display: none;
                    }

                    &:hover {
                        &::before {
                            display: block;
                        }
                    }

                    .el-icon-remove {
                        font-size: 16px;
                        color: #E44144;
                    }
                }

                .plus_icon_wrap {
                    cursor: pointer;
                    margin-top: 6px;
                    width: 16px;
                    height: 16px;
                    position: relative;

                    &::before {
                        content: '';
                        width: 38px;
                        height: 1px;
                        background: #2990FF;
                        position: absolute;
                        right: -39px;
                        bottom: 8px;
                        display: none;
                    }

                    &:hover {
                        &::before {
                            display: block;
                        }
                    }

                    .el-icon-circle-plus {
                        font-size: 16px;
                        color: #2990FF;
                    }
                }
            }

            &.col_span_24 {
                width: 100%;
            }
        }
    }

    .template_1_wrap {
        width: 100%;
        background-color: #FFFFFF;

        .template_header_wrap {
            padding: 12px;
            border-radius: 4px 4px 0 0;
            background: #3D4B59;
            display: flex;
            align-items: center;
            border-left: 1px solid #3D4B59;
            border-right: 1px solid #3D4B59;
            position: relative;

            .logo_wrap {
                border-radius: 4px;
                border: 1px dashed rgba(255, 255, 255, 0.36);
                cursor: pointer;
                width: 152px;
                height: 32px;
                display: flex;
                align-items: center;
                justify-content: center;
                position: absolute;
                left: 12px;

                .upload_text {
                    line-height: 22px;
                    color: #FFFFFF;
                    font-size: 12px;
                }

                .logo {
                    width: 100%;
                    height: 100%;
                    object-fit: cover;
                    border-radius: 4px;
                }
            }

            .quotation_title {
                font-size: 22px;
                font-weight: 700;
                line-height: 32px;
                color: #FFFFFF;
                flex: 1;
                text-align: center;

                .el-input {
                    width: calc(100% - 304px);

                    .el-input__inner {
                        color: #FFFFFF;
                        text-align: center;
                        font-size: 22px;
                    }
                }
            }
        }

        .template_content_wrap {
            width: 100%;
            border-left: 1px solid #4B5356;
            border-right: 1px solid #4B5356;
            border-bottom: 1px solid #4B5356;
            border-radius: 0 0 4px 4px;

            .input_field_wrap {
                display: flex;
                gap: 4px;
                min-height: 100%;

                .field_label_wrap {
                    width: 130px;
                    border-right: 1px solid rgba(0, 0, 0, 0.08);

                    .field_name {
                        padding: 8px 0 8px 12px;
                        line-height: 22px;
                        color: #666666;
                    }
                }

                .field_value_wrap {
                    flex: 1;
                    min-height: 100%;

                    .el-input {
                        .el-input__inner {
                            height: 38px !important;
                            line-height: 22px;
                            padding: 8px 12px;
                        }
                    }

                    .el-select {
                        .el-tag--small {
                            height: 22px;
                            line-height: 22px;
                            margin-left: 12px;
                        }
                    }
                }

                .el-textarea {
                    .el-textarea__inner {
                        padding: 8px 12px;
                        line-height: 22px;
                    }
                }
            }

            .textarea_field_label {
                box-shadow: inset 0px -1px 0px rgba(0, 0, 0, 0.08);

                .field_name {
                    padding: 8px 12px;
                    font-size: 16px;
                    font-weight: 700;
                    line-height: 24px;
                    color: #333333;
                }

                .el-input {
                    .el-input__inner {
                        color: #333333;
                        padding: 8px 12px;
                        font-size: 16px;
                        font-weight: 700;
                        line-height: 24px;
                    }
                }
            }

            .textarea_field_value {
                color: #999999;
                line-height: 22px;

                .el-textarea {
                    .el-textarea__inner {
                        padding: 8px 12px;
                        line-height: 22px;
                    }
                }
            }

            .detail_field_value {
                padding: 8px 12px;
                color: #333333;
            }

            .explain_field_wrap {
                .explain_field {
                    width: 100%;
                    height: 38px;
                    padding: 8px 12px;
                    font-size: 16px;
                    font-weight: 700;
                    line-height: 24px;
                    color: #333333;
                }

                .el-input {
                    .el-input__inner {
                        color: #333333;
                        padding: 8px 12px;
                        font-size: 16px;
                        font-weight: 700;
                        line-height: 24px;
                    }
                }
            }

            .el-table {
                th.el-table__cell {
                    background-color: #3D4B59;
                    padding: 8px 0;
                    border-color: #E8E8E8;

                    .cell {
                        color: #FFFFFF;
                        line-height: 22px;
                        font-weight: 400;
                    }
                }

                td.el-table__cell {
                    border-color: #E8E8E8;

                    .cell {
                        .el-textarea__inner {
                            color: #666666;
                            padding: 8px 8px 8px 10px;
                            line-height: 22px;
                        }

                        .el-input__inner {
                            color: #666666;
                            padding: 8px 8px 8px 10px;
                            line-height: 22px;
                        }
                    }
                }
            }

            .table_header_wrap {
                .el-select {
                    .el-input__inner {
                        color: #FFFFFF;
                    }
                }
            }

            .template_field_item_wrap {
                box-shadow: inset 0px -1px 0px rgba(0, 0, 0, 0.08);
            }
        }

        .total_price_wrap {
            padding: 8px 16px;
            border-radius: 0 0 4px 4px;
            background: #3D4B59;
            line-height: 22px;
            color: #FFFFFF;
            font-weight: 700;
            text-align: right;
            border-left: 1px solid #3D4B59;
            border-right: 1px solid #3D4B59;
        }
    }

    .template_2_wrap {
        width: 100%;

        .template_header_wrap {
            padding: 12px 24px;
            border-radius: 4px 4px 0 0;
            background: #3D4B59;
            display: flex;
            align-items: center;
            border-left: 1px solid #3D4B59;
            border-right: 1px solid #3D4B59;

            .quotation_title {
                font-size: 22px;
                font-weight: 700;
                line-height: 32px;
                color: #FFFFFF;
                flex: 1;

                .el-input {
                    width: calc(100% - 152px);

                    .el-input__inner {
                        color: #FFFFFF;
                        font-size: 22px;
                        padding: 0;
                    }
                }
            }

            .logo_wrap {
                border-radius: 4px;
                border: 1px dashed rgba(255, 255, 255, 0.36);
                cursor: pointer;
                width: 152px;
                height: 32px;
                display: flex;
                align-items: center;
                justify-content: center;

                .upload_text {
                    line-height: 22px;
                    color: #FFFFFF;
                    font-size: 12px;
                }

                .logo {
                    width: 100%;
                    height: 100%;
                    object-fit: cover;
                    border-radius: 4px;
                }
            }
        }

        .template_content_wrap {
            width: 100%;
            border-left: 1px solid #3D4B59;
            border-right: 1px solid #3D4B59;
            border-bottom: 1px solid #3D4B59;
            background-color: #FFFFFF;
            border-radius: 0 0 4px 4px;

            .template_field_item_wrap {
                &.top_three_field {
                    background-color: #3D4B59;

                    .textarea_field_label {
                        color: #FFFFFF;

                        .el-input__inner {
                            font-weight: bold;
                        }
                    }

                    .textarea_field_value {
                        color: #999999;
                        border-bottom: 1px solid rgba(255, 255, 255, 0.12);
                    }

                    .input_field_wrap {
                        .field_label_wrap {
                            color: #FFFFFF;
                            line-height: 22px;
                        }

                        .field_value_wrap {
                            color: #FFFFFF;
                            line-height: 22px;
                            flex: 1;
                            border-bottom: 1px solid rgba(255, 255, 255, 0.12);

                            .el-select {
                                .el-input__inner {
                                    height: 22px !important;
                                    line-height: 22px !important;
                                }
                            }

                            .el-textarea {
                                min-height: 22px !important;

                                .el-textarea__inner {
                                    padding: 0;
                                }
                            }
                        }
                    }

                    .explain_field {
                        color: #FFFFFF;
                    }

                    .el-input__inner {
                        color: #FFFFFF;
                    }

                    .el-textarea__inner {
                        color: #FFFFFF;
                    }
                }

                &.the_fifth_field {
                    padding: 0 !important;
                    background-color: #FFFFFF;
                    margin-bottom: 8px;

                    .input_field_wrap {
                        padding: 4px 24px 12px;
                        width: 100%;
                        background-color: #3D4B59;
                        clip-path: polygon(0 100%, 0 0, 100% 0, 90% 100%);
                    }
                }

                .input_field_wrap {
                    display: flex;
                    gap: 4px;

                    .field_label_wrap {
                        color: #666666;
                        line-height: 22px;
                        width: 112px;
                    }

                    .field_value_wrap {
                        color: #999999;
                        line-height: 22px;
                        flex: 1;
                        border-bottom: 1px solid rgba(0, 0, 0, 0.08);

                        .el-select {
                            .el-input__inner {
                                height: 22px !important;
                                line-height: 22px !important;
                                padding-left: 0 !important;
                            }

                            .el-tag--mini {
                                height: 18px;
                                line-height: 18px;
                            }
                        }

                        .el-date-editor {
                            .el-input__prefix {
                                left: -6px;
                            }

                            .el-input__inner {
                                height: 22px;
                                line-height: 22px;
                                padding: 0 22px !important;
                            }
                        }
                    }

                    .el-textarea {
                        min-height: 22px !important;

                        .el-textarea__inner {
                            padding: 0 !important;
                            font-size: 14px;
                        }
                    }

                    .el-input__icon {
                        line-height: 22px !important;
                    }
                }

                .explain_field_wrap {
                    .el-input {
                        .el-input__inner {
                            padding: 0;
                            color: #333333;
                            font-size: 16px;
                            font-weight: 700;
                            line-height: 24px;
                        }
                    }

                    .explain_field {
                        width: 100%;
                        font-size: 16px;
                        font-weight: 700;
                        line-height: 24px;
                        color: #333333;
                        margin-bottom: 4px;
                        margin-top: 12px;
                    }
                }

                .textarea_field_label {

                    .field_name {
                        padding: 8px 0;
                        font-size: 16px;
                        font-weight: 700;
                        line-height: 24px;
                        color: #333333;
                    }

                    .el-input {
                        .el-input__inner {
                            color: #333333;
                            padding: 0;
                            font-size: 16px;
                            font-weight: 700;
                            line-height: 24px;
                        }
                    }
                }

                .textarea_field_value {
                    color: #666666;
                    line-height: 22px;
                    border-bottom: 1px solid rgba(0, 0, 0, 0.08);
                    margin-bottom: 8px;

                    .el-textarea {
                        .el-textarea__inner {
                            padding: 0;
                            line-height: 22px;
                        }
                    }
                }

                .el-table {
                    th.el-table__cell {
                        background-color: #EDF0F4;
                        padding: 8px 0;
                        border-color: #E8E8E8;

                        .cell {
                            color: #333333;
                            line-height: 22px;
                            font-weight: 400;
                        }
                    }

                    td.el-table__cell {
                        border-color: #E8E8E8;

                        .cell {
                            .el-textarea__inner {
                                color: #666666;
                                padding: 8px 8px 8px 10px;
                                line-height: 22px;
                            }

                            .el-input__inner {
                                color: #666666;
                                padding: 8px 8px 8px 10px;
                                line-height: 22px;
                            }
                        }
                    }
                }

                .total_price_wrap {
                    padding: 8px 16px;
                    border-radius: 0 0 4px 4px;
                    background: #3D4B59;
                    line-height: 22px;
                    color: #FFFFFF;
                    font-weight: 700;
                    text-align: right;
                    clip-path: polygon(0 100%, 0 30px, 58% 30px, 63% 0, 100% 0, 100% 100%);
                    flex: 1;
                }

                .field_handle_icon_wrap {
                    bottom: -14px;

                    .plus_icon_wrap {
                        margin-top: 0;
                    }
                }
            }
        }
    }

    .template_3_wrap {
        width: 100%;
        background-color: #FFFFFF;

        .template_header_wrap {
            padding: 12px 16px;
            margin-bottom: 4px;

            .header_inner_wrap {
                display: flex;
                align-items: center;
                justify-content: space-between;
                border-bottom: 2px solid #333333;
                padding-bottom: 8px;

                .quotation_title {
                    font-size: 22px;
                    font-weight: 700;
                    line-height: 32px;
                    color: #FFFFFF;
                    flex: 1;

                    .el-input {
                        width: 100%;

                        .el-input__inner {
                            color: #333333;
                            font-size: 22px;
                            padding: 0;
                        }
                    }
                }

                .logo_wrap {
                    border-radius: 4px;
                    border: 1px dashed rgba(0, 0, 0, 0.36);
                    cursor: pointer;
                    width: 152px;
                    height: 32px;
                    display: flex;
                    align-items: center;
                    justify-content: center;

                    .upload_text {
                        line-height: 22px;
                        color: #000000;
                        font-size: 12px;
                    }

                    .logo {
                        width: 100%;
                        height: 100%;
                        object-fit: cover;
                        border-radius: 4px;
                    }
                }
            }
        }

        .template_content_wrap {
            width: 100%;
            padding: 0 16px;

            .template_field_item_wrap {
                margin-bottom: 8px;

                .explain_field_wrap {
                    .explain_field {
                        width: 100%;
                        font-size: 16px;
                        font-weight: 700;
                        line-height: 24px;
                        color: #333333;
                    }

                    .el-input__inner {
                        padding: 0;
                        color: #333333;
                        font-size: 16px;
                        font-weight: 700;
                        line-height: 24px;
                        height: 24px;
                    }
                }

                .input_field_wrap {
                    display: flex;
                    gap: 4px;

                    .field_label_wrap {
                        width: 112px;
                        color: #666666;
                        line-height: 18px;
                    }

                    .field_value_wrap {
                        color: #999999;
                        line-height: 18px;
                        flex: 1;
                        box-sizing: border-box;

                        .el-select {
                            .el-input__inner {
                                height: 18px !important;
                                line-height: 18px !important;
                                padding-left: 0 !important;
                            }

                            .el-tag--small {
                                height: 18px;
                                line-height: 18px;
                                margin: 0;
                            }
                        }

                        .el-date-editor {
                            .el-input__prefix {
                                left: -6px;
                            }

                            .el-input__inner {
                                height: 18px;
                                line-height: 18px;
                                padding: 0 22px !important;
                            }
                        }
                    }

                    .el-textarea {
                        min-height: 22px !important;

                        .el-textarea__inner {
                            padding: 0 !important;
                            font-size: 14px;
                        }
                    }

                    .el-input__icon {
                        line-height: 18px !important;
                    }
                }

                .textarea_field_wrap {
                    border-bottom: 2px solid #333333;

                    .textarea_field_label {
                        font-size: 12px;
                        font-weight: 700;
                        line-height: 18px;
                        color: #333333;

                        .el-input__inner {
                            padding: 0;
                            line-height: 18px;
                            height: 18px;
                            font-size: 12px;
                            font-weight: 700;
                        }
                    }

                    .textarea_field_value {
                        color: #666666;
                        line-height: 18px;
                        font-size: 12px;
                        flex: 1;

                        .el-textarea__inner {
                            padding: 0;
                            line-height: 18px;
                            font-size: 12px;
                        }
                    }
                }

                .table_field_wrap {
                    border-top: 2px solid #333333;

                    .el-table {
                        th.el-table__cell {
                            padding: 8px 0;
                            border-color: #E8E8E8;

                            .cell {
                                color: #333333;
                                line-height: 22px;
                                font-weight: 700;
                            }
                        }

                        td.el-table__cell {
                            padding: 0;
                            line-height: 22px;
                            border-color: rgba(0, 0, 0, 0.08);

                            .cell {
                                color: #666666;
                                line-height: 18px;
                                font-size: 12px;

                                .el-textarea__inner {
                                    color: #666666;
                                    padding: 8px 8px 8px 10px;
                                    line-height: 18px;
                                }

                                .el-input__inner {
                                    color: #666666;
                                    padding: 8px 8px 8px 10px;
                                    line-height: 18px;
                                }
                            }
                        }
                    }
                }

                .total_price_wrap {
                    padding: 8px 16px;
                    background: #333333;
                    line-height: 18px;
                    font-size: 12px;
                    color: #FFFFFF;
                    font-weight: 700;
                    text-align: right;
                }

                .field_handle_icon_wrap {
                    bottom: -14px;

                    .remove_icon_wrap {
                        &::before {
                            height: 22px;
                            top: 0;
                        }
                    }

                    .plus_icon_wrap {
                        margin-top: 0;
                    }
                }
            }
        }

        .template_footer_wrap {
            width: 100%;
            height: 12px;
            border-radius: 0 0 4px 4px;
            background: #F3BB5B;
            margin-top: 4px;
        }
    }

    .template_4_wrap {
        background-color: #EEEEEE;
        position: relative;
        min-height: 100%;
        border-radius: 4px;
        width: 100%;

        .template_header_wrap {
            padding: 12px 0;
            position: relative;

            &::before {
                content: '';
                width: 90px;
                height: 8px;
                border-radius: 4px 0px 10px 0px;
                background-color: #F0AA32;
                position: absolute;
                left: 0;
                top: 0;
            }

            .quotation_title {
                color: #333333;
                font-size: 22px;
                line-height: 32px;
                text-align: center;
                font-weight: bold;
            }

            .el-input {
                width: 100%;

                .el-input__inner {
                    color: #333333;
                    font-size: 22px;
                    text-align: center;
                    font-weight: bold;
                }
            }
        }

        .template_content_wrap {
            padding: 12px 16px;
            width: 100%;

            .table_field_wrap {
                border-top: 2px solid #333333;
                border-bottom: 2px solid #333333;
                border-left: 1px solid rgba(0, 0, 0, 0.08);
                border-right: 1px solid rgba(0, 0, 0, 0.08);
                margin: 8px 0;

                .el-table {
                    th.el-table__cell {
                        background-color: #EEEEEE;
                        padding: 8px 0;
                        border-color: rgba(0, 0, 0, 0.08);

                        .cell {
                            color: #333333;
                            line-height: 22px;
                            font-weight: 700;
                        }
                    }

                    td.el-table__cell {
                        padding: 8px 0;
                        line-height: 22px;
                        background-color: #EEEEEE;
                        border-color: rgba(0, 0, 0, 0.08);

                        .cell {
                            color: #666666;
                            line-height: 18px;
                            font-size: 12px;
                        }
                    }
                }
            }

            .total_price_wrap {
                padding: 4px 16px;
                line-height: 18px;
                font-size: 12px;
                color: #333333;
                font-weight: 700;
                text-align: right;
            }

            .field_handle_icon_wrap {
                bottom: -14px;

                .remove_icon_wrap {
                    &::before {
                        height: 22px;
                        top: 0;
                    }
                }

                .plus_icon_wrap {
                    margin-top: 0;
                }
            }
        }

        .template_footer_wrap {
            padding: 0 16px 24px;
            display: flex;
            align-items: center;
            justify-content: space-between;
            gap: 60px;
            position: relative;

            &:after {
                content: '';
                width: 8px;
                height: 129px;
                opacity: 1;
                border-radius: 40px 0px 4px 0px;
                background: #F0AA32;
                position: absolute;
                right: 0;
                bottom: 0;
            }

            .footer_left_wrap {
                .logo_wrap {
                    width: 200px;
                    height: 106px;
                    border-radius: 4px;
                    border: 1px dashed rgba(0, 0, 0, 0.36);
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    cursor: pointer;

                    .upload_text {
                        line-height: 22px;
                        text-align: center;
                        font-size: 12px;
                        color: #333333;
                    }

                    .logo {
                        width: 100%;
                        height: 100%;
                        object-fit: cover;
                        border-radius: 4px;
                    }
                }
            }

            .footer_right_wrap {
                flex: 1;
            }
        }

        .template_field_item_wrap {
            margin-bottom: 8px;

            .explain_field_wrap {
                .explain_field {
                    width: 100%;
                    font-size: 16px;
                    font-weight: 700;
                    line-height: 24px;
                    color: #333333;
                }

                .el-input__inner {
                    padding: 0;
                    color: #333333;
                    font-size: 16px;
                    font-weight: 700;
                    line-height: 24px;
                    height: 24px;
                }
            }

            .input_field_wrap {
                display: flex;
                gap: 4px;

                .field_label_wrap {
                    width: 112px;
                    color: #666666;
                    line-height: 18px;
                }

                .field_value_wrap {
                    color: #999999;
                    line-height: 18px;
                    flex: 1;
                    box-sizing: border-box;

                    .el-select {
                        .el-input__inner {
                            height: 18px !important;
                            line-height: 18px !important;
                            padding-left: 0 !important;
                        }

                        .el-tag--small {
                            height: 18px;
                            line-height: 18px;
                            margin: 0;
                        }
                    }

                    .el-date-editor {
                        .el-input__prefix {
                            left: -6px;
                        }

                        .el-input__inner {
                            height: 18px;
                            line-height: 18px;
                            padding: 0 22px !important;
                        }
                    }
                }

                .el-textarea {
                    min-height: 22px !important;

                    .el-textarea__inner {
                        padding: 0 !important;
                        font-size: 14px;
                    }
                }

                .el-input__icon {
                    line-height: 18px !important;
                }
            }

            .textarea_field_wrap {
                border-bottom: 2px solid #333333;

                .textarea_field_label {
                    font-size: 12px;
                    font-weight: 700;
                    line-height: 18px;
                    color: #333333;

                    .el-input__inner {
                        padding: 0;
                        line-height: 18px;
                        height: 18px;
                        font-size: 12px;
                        font-weight: 700;
                    }
                }

                .textarea_field_value {
                    color: #666666;
                    line-height: 18px;
                    font-size: 12px;
                    flex: 1;

                    .el-textarea__inner {
                        padding: 0;
                        line-height: 18px;
                        font-size: 12px;
                    }
                }
            }

            .table_field_wrap {
                border-top: 2px solid #333333;

                .el-table {
                    th.el-table__cell {
                        padding: 4px 0;
                        border-color: #E8E8E8;

                        .cell {
                            color: #333333;
                            line-height: 22px;
                            font-weight: 400;
                        }
                    }

                    td.el-table__cell {
                        padding: 0;
                        line-height: 22px;
                        border-color: rgba(0, 0, 0, 0.08);

                        .cell {
                            color: #666666;
                            line-height: 18px;
                            font-size: 12px;

                            .el-textarea__inner {
                                color: #666666;
                                padding: 8px 8px 8px 10px;
                                line-height: 18px;
                            }

                            .el-input__inner {
                                color: #666666;
                                padding: 8px 8px 8px 10px;
                                line-height: 18px;
                            }
                        }
                    }
                }
            }
        }
    }

    .template_5_wrap {
        width: 100%;
        background: linear-gradient(180deg, rgba(255, 255, 255, 1) 0%, rgba(245, 249, 255, 1) 100%);
        min-height: 100%;
        position: relative;

        &::before {
            content: '';
            width: 8px;
            height: 100%;
            position: absolute;
            left: 0;
            top: 0;
            background: linear-gradient(151.32deg, rgba(204, 204, 204, 0) 0%, rgba(132, 132, 133, 1) 100%);
        }

        .template_header_wrap {
            padding: 16px;
            display: flex;
            align-items: center;
            justify-content: space-between;

            .quotation_title {
                color: #333333;
                font-size: 22px;
                line-height: 32px;
                text-align: center;
                font-weight: bold;
                flex: 1;

                .el-input {
                    width: 100%;

                    .el-input__inner {
                        color: #333333;
                        font-size: 22px;
                        font-weight: bold;
                    }
                }
            }

            .logo_wrap {
                border-radius: 4px;
                border: 1px dashed rgba(0, 0, 0, 0.36);
                cursor: pointer;
                width: 152px;
                height: 32px;
                display: flex;
                align-items: center;
                justify-content: center;

                .upload_text {
                    line-height: 22px;
                    color: #000000;
                    font-size: 12px;
                }

                .logo {
                    width: 100%;
                    height: 100%;
                    object-fit: cover;
                    border-radius: 4px;
                }
            }
        }

        .template_content_wrap {
            padding: 0 16px;
            width: 100%;

            .template_field_item_wrap {
                margin-bottom: 8px;

                .explain_field_wrap {
                    .explain_field {
                        width: 100%;
                        font-size: 16px;
                        font-weight: 700;
                        line-height: 24px;
                        color: #333333;
                    }

                    .el-input__inner {
                        padding: 0;
                        color: #333333;
                        font-size: 16px;
                        font-weight: 700;
                        line-height: 24px;
                        height: 24px;
                    }
                }

                .input_field_wrap {
                    display: flex;
                    gap: 4px;

                    .field_label_wrap {
                        width: 112px;
                        color: #666666;
                        line-height: 18px;
                    }

                    .field_value_wrap {
                        color: #999999;
                        line-height: 18px;
                        flex: 1;
                        box-sizing: border-box;

                        .el-select {
                            .el-input__inner {
                                height: 18px !important;
                                line-height: 18px !important;
                                padding-left: 0 !important;
                            }

                            .el-tag--small {
                                height: 18px;
                                line-height: 18px;
                                margin: 0;
                            }
                        }

                        .el-date-editor {
                            .el-input__prefix {
                                left: -6px;
                            }

                            .el-input__inner {
                                height: 18px;
                                line-height: 18px;
                                padding: 0 22px !important;
                            }
                        }
                    }

                    .el-textarea {
                        min-height: 22px !important;

                        .el-textarea__inner {
                            padding: 0 !important;
                            font-size: 14px;
                        }
                    }

                    .el-input__icon {
                        line-height: 18px !important;
                    }
                }

                .textarea_field_wrap {
                    border-bottom: 2px solid #333333;
                    display: flex;
                    gap: 8px;
                    padding-bottom: 8px;

                    .textarea_field_label {
                        font-size: 12px;
                        font-weight: 700;
                        line-height: 18px;
                        color: #333333;

                        .el-input__inner {
                            padding: 0;
                            line-height: 18px;
                            height: 18px;
                            font-size: 12px;
                            font-weight: 700;
                        }
                    }

                    .textarea_field_value {
                        color: #666666;
                        line-height: 18px;
                        font-size: 12px;
                        flex: 1;

                        .el-textarea__inner {
                            padding: 0;
                            line-height: 18px;
                            font-size: 12px;
                        }
                    }
                }

                .table_field_wrap {
                    border-top: 2px solid #333333;

                    .el-table {
                        th.el-table__cell {
                            padding: 4px 0;
                            border-color: #E8E8E8;

                            .cell {
                                color: #333333;
                                line-height: 22px;
                                font-weight: 400;
                            }
                        }

                        td.el-table__cell {
                            padding: 0;
                            line-height: 22px;
                            border-color: rgba(0, 0, 0, 0.08);

                            .cell {
                                color: #666666;
                                line-height: 18px;
                                font-size: 12px;

                                .el-textarea__inner {
                                    color: #666666;
                                    padding: 8px 8px 8px 10px;
                                    line-height: 18px;
                                }

                                .el-input__inner {
                                    color: #666666;
                                    padding: 8px 8px 8px 10px;
                                    line-height: 18px;
                                }
                            }
                        }
                    }
                }

                .total_price_wrap {
                    display: flex;
                    justify-content: end;
                    position: relative;

                    &::after {
                        content: '';
                        width: 16px;
                        height: 72px;
                        background-color: #E9EBEF;
                        position: absolute;
                        top: -10px;
                        right: -16px;
                        clip-path: polygon(0 10px, 100% 0, 100% 100%, 0 62px);
                    }

                    .total_price_inner_wrap {
                        min-width: 132px;
                        font-weight: 700;
                        padding: 8px;
                        color: #333333;
                        line-height: 18px;
                        font-size: 12px;
                        background-color: #E9EBEF;
                        border-radius: 4px 0 0 4px;
                    }
                }

                .field_handle_icon_wrap {
                    bottom: -14px;

                    .remove_icon_wrap {
                        &::before {
                            height: 22px;
                            top: 0;
                        }
                    }

                    .plus_icon_wrap {
                        margin-top: 0;
                    }
                }
            }
        }
    }

    .template_6_wrap {
        background: #FFFFFF;
        min-height: 100%;
        width: 100%;

        .template_header_wrap {
            display: flex;
            align-items: center;
            justify-content: space-between;
            padding: 10px 16px 0 16px;
            position: relative;
            border-radius: 4px 0 0 0;

            .logo_wrap {
                width: 306px;
                height: 64px;
                background: #43454B;
                border-radius: 4px 0 0 0;
                padding: 16px;
                clip-path: polygon(0 100%, 0 0, 90% 0, 100% 100%);
                margin: -10px 0 0 -16px;

                .upload_text {
                    width: 152px;
                    line-height: 22px;
                    color: #FFFFFF;
                    padding: 5px 0;
                }

                .logo {
                    width: 152px;
                    height: 100%;
                    object-fit: cover;
                    border-radius: 4px;
                }
            }

            .quotation_title {
                width: 400px;
                color: #333333;
                font-size: 22px;
                line-height: 32px;
                text-align: center;
                font-weight: bold;

                .el-input {
                    width: 100%;

                    .el-input__inner {
                        color: #333333;
                        font-size: 22px;
                        font-weight: bold;
                        text-align: right;
                        padding: 0;
                    }
                }
            }
        }

        .template_content_wrap {
            padding: 16px 16px 0;
            width: 100%;
        }

        .template_footer_wrap {
            padding: 0 16px 16px;
            display: flex;
            gap: 30px;
            position: relative;
            justify-content: start;

            .footer_left_wrap {
                flex: 1;
                padding-top: 34px;

                .template_field_item_wrap {
                    margin-bottom: 0;

                    .textarea_field_wrap {
                        height: 154px;
                        display: flex;
                        border-top: 2px solid #333333;
                        border-bottom: 2px solid #333333;
                        padding: 8px 0;
                        gap: 4px;

                        .textarea_field_label {
                            font-size: 12px;
                            font-weight: 700;
                            line-height: 18px;
                            color: #333333;
                        }

                        .textarea_field_value {
                            color: #999999;
                            line-height: 18px;
                            font-size: 12px;
                            flex: 1;

                            .el-textarea {
                                width: 100%;

                                .el-textarea__inner {
                                    padding: 0 !important;
                                    font-size: 12px;
                                    line-height: 18px;
                                }
                            }
                        }
                    }
                }
            }

            .footer_right_wrap {
                flex: 1;
                height: 188px;
                position: relative;

                .right_outer_wrap {
                    width: 440px;
                    height: 286px;
                    background: #43454B;
                    clip-path: polygon(60px 100%, 0 98px, 424px 98px, 424px 0, 100% 0, 100% 100%);
                    display: flex;
                    align-items: end;
                    justify-content: end;
                    position: absolute;
                    right: -16px;
                    bottom: 0;

                    .right_inner_wrap {
                        width: 380px;
                        height: 188px;
                        padding: 8px 16px 16px 0;
                        display: flex;
                        flex-direction: column;
                        justify-content: space-between;
                        align-items: end;

                        .total_price_wrap {
                            .total_price_label {
                                color: #FFFFFF;
                                font-size: 12px;
                                font-weight: 700;
                                letter-spacing: 0px;
                                line-height: 18px;
                            }

                            .chinese_text {
                                font-size: 12px;
                                line-height: 18px;
                                color: rgba(255, 255, 255, 0.9);
                            }
                        }

                        .template_field_item_wrap {
                            margin-bottom: 0;

                            .input_field_wrap {
                                display: flex;
                                margin-top: 8px;
                                justify-content: end;

                                .field_label_wrap {
                                    color: #FFFFFF;
                                    line-height: 18px;
                                    font-size: 12px;
                                    text-align: right;
                                }

                                .field_value_wrap {
                                    color: #FFFFFF;
                                    line-height: 18px;
                                    font-size: 12px;
                                    width: 120px;

                                    .el-textarea {
                                        .el-textarea__inner {
                                            color: #FFFFFF;
                                        }
                                    }
                                }
                            }
                        }
                    }
                }
            }
        }

        .template_field_item_wrap {
            margin-bottom: 8px;

            .table_field_wrap {
                padding-top: 8px;

                .el-table {
                    th.el-table__cell {
                        padding: 4px 0;
                        border-color: rgba(0, 0, 0, 0.08);
                        background-color: #EDF0F4;

                        &:first-child {
                            background: rgba(0, 0, 0, 0.04);
                        }

                        .cell {
                            color: #333333;
                            line-height: 22px;
                            font-weight: 700;
                        }
                    }

                    td.el-table__cell {
                        padding: 4px 0;
                        line-height: 22px;
                        border-color: rgba(0, 0, 0, 0.08);

                        &:first-child {
                            background: rgba(0, 0, 0, 0.04);
                        }

                        .cell {
                            color: #666666;
                            line-height: 18px;
                            font-size: 12px;
                        }
                    }
                }
            }

            .input_field_wrap {
                display: flex;
                gap: 4px;

                .field_label_wrap {
                    width: 112px;
                    color: #666666;
                    line-height: 18px;
                }

                .field_value_wrap {
                    color: #999999;
                    line-height: 18px;
                    flex: 1;
                    box-sizing: border-box;

                    .el-select {
                        .el-input__inner {
                            height: 18px !important;
                            line-height: 18px !important;
                            padding-left: 0 !important;
                        }

                        .el-tag--small {
                            height: 18px;
                            line-height: 18px;
                            margin: 0;
                        }
                    }

                    .el-date-editor {
                        .el-input__prefix {
                            left: -6px;
                        }

                        .el-input__inner {
                            height: 18px;
                            line-height: 18px;
                            padding: 0 22px !important;
                        }
                    }
                }

                .el-textarea {
                    min-height: 22px !important;

                    .el-textarea__inner {
                        padding: 0 !important;
                        font-size: 12px;
                        line-height: 18px;
                    }
                }

                .el-input__icon {
                    line-height: 18px !important;
                }
            }

            .field_handle_icon_wrap {
                bottom: -14px;

                .remove_icon_wrap {
                    &::before {
                        height: 22px;
                        top: 0;
                    }
                }

                .plus_icon_wrap {
                    margin-top: 0;
                }
            }
        }
    }

    .template_7_wrap {
        background: #FFFFFF;
        min-height: 100%;
        width: 100%;

        .template_field_item_wrap {
            margin-bottom: 8px;

            &:hover {
                background: none;
            }
        }

        .template_header_wrap {
            padding: 0 16px;
            display: flex;
            align-items: center;

            .left_logo_wrap {
                width: 259px;
                padding: 24px 0 16px 0;
                border-bottom: 12px solid #2990FF;

                .logo_outer_wrap {
                    width: 152px;
                    height: 32px;
                    border-radius: 4px;
                    border: 1px dashed rgba(0, 0, 0, 0.36);
                    cursor: pointer;
                    display: flex;
                    align-items: center;
                    justify-content: center;

                    .upload_text {
                        line-height: 22px;
                        color: #000000;
                        padding: 5px 0;
                    }

                    .logo {
                        width: 100%;
                        height: 100%;
                        object-fit: cover;
                        border-radius: 4px;
                    }
                }
            }

            .right_quotation_title_wrap {
                flex: 1;
                padding: 24px 0 16px 0;
                border-bottom: 12px solid #021934;
                display: flex;
                justify-content: end;

                .quotation_title_wrap {
                    font-size: 32px;
                    font-weight: 700;
                    line-height: 32px;
                    color: #222222;
                    height: 32px;

                    .el-input {
                        width: 100%;
                        height: 32px;

                        .el-input__inner {
                            color: #333333;
                            font-size: 32px;
                            font-weight: bold;
                            text-align: right;
                            padding: 0;
                        }
                    }
                }
            }
        }

        .template_content_wrap {
            padding: 16px 16px 8px;
            width: 100%;

            .field_value_wrap {
                flex: 1;
            }

            .table_field_wrap {
                margin-top: 8px;

                .el-table {
                    border-top: none;
                    border-left: none;
                    border-bottom: none;

                    &.el-table--striped .el-table__body tr.el-table__row--striped td.el-table__cell {
                        background: #FFFFFF !important;
                    }

                    th.el-table__cell {
                        padding: 8px 0;
                        border: none;

                        &:first-child {
                            border-bottom: none;
                            background-color: #FFFFFF;

                            .cell {
                                color: #2990FF;
                            }
                        }

                        .cell {
                            color: #333333;
                            line-height: 22px;
                            font-weight: 700;
                        }
                    }

                    td.el-table__cell {
                        padding: 0;
                        line-height: 22px;
                        border-color: rgba(0, 0, 0, 0.08);
                        background-color: #E3F1FF;

                        &:first-child {
                            border-bottom: none;
                            background-color: #FFFFFF;

                            .cell {
                                color: #2990FF;
                            }
                        }

                        .cell {
                            color: #666666;
                            line-height: 18px;
                            font-size: 12px;

                            .el-textarea__inner {
                                color: #666666;
                                padding: 8px 8px 8px 10px;
                                line-height: 18px;
                            }

                            .el-input__inner {
                                color: #666666;
                                padding: 8px 8px 8px 10px;
                                line-height: 18px;
                            }
                        }
                    }
                }
            }

            .total_price_wrap {
                width: 100%;
                display: flex;
                justify-content: end;

                .total_price_inner_wrap {
                    min-width: 235px;
                    height: 52px;
                    padding: 8px 12px;
                    background-color: #E3F1FF;
                    color: #2990FF;
                    font-size: 12px;
                    line-height: 18px;
                    font-weight: bold;
                    display: flex;
                    justify-content: end;
                }
            }
        }

        .template_footer_wrap {
            padding: 8px 0;
            display: flex;
            align-items: end;
            justify-content: space-between;

            .footer_left_wrap {
                flex: 1;
                padding-bottom: 8px;
                padding-left: 16px;
                border-bottom: 8px solid #021934;
                border-radius: 0 0 0 4px;

                .quotation_title_wrap {
                    font-size: 16px;
                    font-weight: 700;
                    line-height: 24px;
                    color: #333333;
                }
            }

            .footer_right_wrap {
                flex: 1;
                border-bottom: 8px solid #2990FF;
                padding-right: 16px;

                .input_field_wrap {
                    justify-content: end;

                    .field_label_wrap {
                        width: auto;
                        text-align: right;
                    }
                }

                .textarea_field_wrap {
                    justify-content: end;
                    border-bottom: none;
                    padding-bottom: 0;
                }
            }
        }

        .input_field_wrap {
            display: flex;
            gap: 4px;

            .field_label_wrap {
                width: 112px;
                color: #333333;
                line-height: 18px;

                .field_name {
                    font-size: 12px;
                    line-height: 18px;
                    color: #333333;
                }
            }

            .field_value_wrap {
                color: #999999;
                line-height: 18px;
                box-sizing: border-box;

                .el-select {
                    .el-input__inner {
                        font-size: 12px !important;
                        height: 18px !important;
                        line-height: 18px !important;
                        padding-left: 0 !important;
                        color: #333333 !important;
                    }

                    .el-tag--small {
                        height: 18px;
                        line-height: 18px;
                        margin: 0;
                    }
                }

                .el-date-editor {
                    .el-input__prefix {
                        left: -6px;
                    }

                    .el-input__inner {
                        height: 18px;
                        line-height: 18px;
                        padding: 0 22px !important;
                    }
                }
            }

            .el-textarea {
                min-height: 18px !important;

                .el-textarea__inner {
                    padding: 0 !important;
                    font-size: 12px;
                    line-height: 18px;
                }
            }

            .el-input__icon {
                line-height: 18px !important;
            }
        }

        .textarea_field_wrap {
            border-bottom: 1px solid #021934;
            display: flex;
            padding-bottom: 8px;
            gap: 4px;

            .textarea_field_label {
                font-size: 12px;
                line-height: 18px;
                color: #333333;
            }

            .textarea_field_value {
                color: #999999;
                line-height: 18px;
                font-size: 12px;

                .el-textarea {
                    min-height: 18px !important;

                    .el-textarea__inner {
                        padding: 0 !important;
                        font-size: 12px;
                        line-height: 18px;
                    }
                }
            }
        }
    }

    .template_8_wrap {
        background: #FFFFFF;
        min-height: 100%;
        width: 100%;

        .template_header_wrap {
            padding: 12px;
            border-radius: 4px 4px 0 0;
            background: #2990FF;
            position: relative;

            .left_logo_wrap {
                width: 152px;
                height: 32px;
                border-radius: 4px;
                border: 1px dashed rgba(255, 255, 255, 0.36);
                cursor: pointer;
                display: flex;
                align-items: center;
                justify-content: center;
                position: absolute;
                left: 16px;

                .upload_text {
                    line-height: 22px;
                    color: #FFFFFF;
                    padding: 5px 0;
                }

                .logo {
                    width: 100%;
                    height: 100%;
                    object-fit: cover;
                    border-radius: 4px;
                }
            }

            .right_quotation_title_wrap {
                flex: 1;

                .quotation_title_wrap {
                    font-size: 22px;
                    font-weight: 700;
                    line-height: 32px;
                    color: #FFFFFF;
                    text-align: center;
                }
            }
        }

        .template_content_wrap {
            border-left: 1px solid #2990FF;
            border-right: 1px solid #2990FF;
            border-bottom: 1px solid #2990FF;
            border-radius: 0 0 4px 4px;
            width: 100%;

            .explain_field {
                padding: 6px 12px;
                font-size: 16px;
                font-weight: 700;
                line-height: 24px;
                color: #333333;
                box-shadow: inset 0px -1px 0px rgba(0, 0, 0, 0.08);
            }

            .input_field_wrap {
                display: flex;
                box-shadow: inset 0px -1px 0px rgba(0, 0, 0, 0.08);

                .field_label_wrap {
                    color: #333333;
                    line-height: 22px;
                    padding: 8px 0 8px 12px;
                    border-right: 1px solid #E8E8E8;
                    width: 130px;
                    letter-spacing: 0;
                }

                .field_value_wrap {
                    color: #999999;
                    line-height: 22px;
                    padding: 8px 12px;
                    border-right: 1px solid #E8E8E8;
                    flex: 1;
                }
            }

            .total_price_wrap {
                padding: 8px 12px;
                display: flex;
                justify-content: end;
                background-color: #EDF0F4;

                .total_price_inner_wrap {
                    font-weight: 700;
                    line-height: 22px;
                    color: #333333;
                }
            }

            .table_field_wrap {
                .el-table {
                    th.el-table__cell {
                        padding: 8px 0;
                        background-color: #EDF0F4;

                        .cell {
                            color: #333333;
                            line-height: 22px;
                            font-weight: 400;

                        }
                    }

                    td.el-table__cell {
                        padding: 8px 0;
                        line-height: 22px;
                        border-color: rgba(0, 0, 0, 0.08);

                        .cell {
                            color: #666666;
                            line-height: 22px;
                            font-size: 14px;
                        }
                    }
                }
            }

            .textarea_field_wrap {
                padding: 8px 12px;
                display: flex;
                box-shadow: inset 0px -1px 0px rgba(0, 0, 0, 0.08);
                min-height: 90px;

                .textarea_field_label {
                    color: #666666;
                }

                .textarea_field_value {
                    color: #666666;
                }
            }
        }
    }

    .template_9_wrap {
        background: #FFFFFF;
        min-height: 100%;
        width: 100%;

        .template_header_wrap {
            padding: 16px;
            width: 100%;
            height: 64px;
            background-image: url("https://download.hecoos.com/enlightv/2024-51/0b6aea589a1ff8aa8952feed25692d39.png");
            background-size: cover;
            background-repeat: no-repeat;
            display: flex;
            justify-content: space-between;
            align-items: center;

            .left_quotation_title_wrap {
                flex: 1;

                .quotation_title_wrap {
                    font-size: 22px;
                    font-weight: 700;
                    line-height: 32px;
                    color: #FFFFFF;
                }
            }

            .right_logo_wrap {
                width: 152px;
                height: 32px;
                opacity: 1;
                border-radius: 4px;
                border: 1px dashed rgba(255, 255, 255, 0.36);
                cursor: pointer;
                text-align: center;

                .upload_text {
                    line-height: 22px;
                    color: #FFFFFF;
                    padding: 5px 0;
                }

                .logo {
                    width: 100%;
                    height: 100%;
                    object-fit: cover;
                    border-radius: 4px;
                }
            }
        }

        .template_content_wrap {
            padding: 0 16px 16px;
            width: 100%;

            .explain_field {
                padding: 6px 12px;
                font-size: 16px;
                font-weight: 700;
                line-height: 24px;
                color: #333333;
                box-shadow: inset 0px -1px 0px rgba(0, 0, 0, 0.08);
                border-left: 1px solid #E8E8E8;
                border-right: 1px solid #E8E8E8;
            }

            .input_field_wrap {
                display: flex;
                box-shadow: inset 0px -1px 0px rgba(0, 0, 0, 0.08);

                &:nth-child(odd) {
                    border-left: 1px solid #E8E8E8;
                }

                .field_label_wrap {
                    color: #333333;
                    line-height: 18px;
                    font-size: 12px;
                    padding: 8px 0 8px 12px;
                    border-right: 1px solid #E8E8E8;
                    width: 130px;
                    letter-spacing: 0;
                }

                .field_value_wrap {
                    color: #999999;
                    font-size: 12px;
                    line-height: 18px;
                    padding: 8px 12px;
                    border-right: 1px solid #E8E8E8;
                    flex: 1;
                }
            }

            .table_field_wrap {
                .el-table {
                    th.el-table__cell {
                        padding: 8px 0;
                        background-color: #DF1A33;
                        border-color: rgba(0, 0, 0, 0.08);

                        .cell {
                            color: #FFFFFF;
                            line-height: 22px;
                            font-weight: 700;
                        }
                    }

                    td.el-table__cell {
                        padding: 8px 0;
                        line-height: 22px;
                        border-color: rgba(0, 0, 0, 0.08);

                        &:first-child {
                            background-color: rgba(0, 0, 0, 0.04);
                        }

                        .cell {
                            color: #666666;
                            line-height: 18px;
                            font-size: 12px;
                        }
                    }
                }
            }

            .total_price_wrap {
                display: flex;
                justify-content: end;
                border-bottom: 2px solid #DF1A33;

                .total_price_inner_wrap {
                    width: 234px;
                    font-weight: 700;
                    line-height: 22px;
                    color: #FFFFFF;
                    padding: 8px 12px;
                    background-color: #DF1A33;
                    text-align: right;
                }
            }

            .textarea_field_wrap {
                padding: 8px 12px;
                display: flex;
                box-shadow: inset 0px -1px 0px rgba(0, 0, 0, 0.08);
                min-height: 90px;
                border-left: 1px solid #E8E8E8;
                border-right: 1px solid #E8E8E8;

                .textarea_field_label {
                    color: #666666;
                }

                .textarea_field_value {
                    color: #666666;
                }
            }
        }

        .template_footer_wrap {
            width: 100%;
            height: 16px;
            background-image: url("https://download.hecoos.com/enlightv/2024-51/1a68de7e7a1ca49ce931c72ad9a67a54.png");
            background-size: cover;
            background-repeat: no-repeat;
            border-radius: 0 0 4px 4px;
        }
    }

    .template_10_wrap {
        background: #FFFFFF;
        min-height: 100%;
        width: 100%;

        .template_header_wrap {
            padding: 12px;
            border-radius: 4px 4px 0 0;
            background: #57B5B3;
            display: flex;
            align-items: center;
            justify-content: space-between;

            .left_logo_wrap {
                width: 152px;
                height: 32px;
                border-radius: 4px;
                border: 1px dashed rgba(255, 255, 255, 0.36);
                cursor: pointer;
                display: flex;
                align-items: center;
                justify-content: center;

                .upload_text {
                    line-height: 22px;
                    color: #FFFFFF;
                    padding: 5px 0;
                }

                .logo {
                    width: 100%;
                    height: 100%;
                    object-fit: cover;
                    border-radius: 4px;
                }
            }

            .right_quotation_title_wrap {
                flex: 1;

                .quotation_title_wrap {
                    font-size: 22px;
                    font-weight: 700;
                    line-height: 32px;
                    color: #FFFFFF;
                }
            }
        }

        .template_content_wrap {
            padding: 0 16px 16px;
            width: 100%;

            .explain_field {
                padding: 6px 12px 6px 28px;
                font-size: 16px;
                font-weight: 700;
                line-height: 24px;
                color: #333333;
                box-shadow: inset 0px -1px 0px rgba(0, 0, 0, 0.08);
                background-color: #CAE6E6;
                margin-left: -16px;
                margin-right: -16px;
            }

            .input_field_wrap {
                display: flex;
                box-shadow: inset 0px -1px 0px rgba(0, 0, 0, 0.08);

                &:nth-child(odd) {
                    border-left: 1px solid #E8E8E8;
                }

                .field_label_wrap {
                    color: #333333;
                    line-height: 22px;
                    padding: 8px 0 8px 12px;
                    border-right: 1px solid #E8E8E8;
                    width: 130px;
                    letter-spacing: 0;
                }

                .field_value_wrap {
                    color: #999999;
                    line-height: 22px;
                    padding: 8px 12px;
                    border-right: 1px solid #E8E8E8;
                    flex: 1;
                }
            }

            .total_price_wrap {
                display: flex;
                justify-content: end;
                border-bottom: 2px solid #57B5B3;

                .total_price_inner_wrap {
                    width: 234px;
                    font-weight: 700;
                    line-height: 22px;
                    color: #FFFFFF;
                    padding: 8px 0 8px 12px;
                    background-color: #57B5B3;
                    text-align: right;
                }
            }

            .table_field_wrap {
                .el-table {
                    &.el-table--striped .el-table__body tr.el-table__row--striped td.el-table__cell {
                        background: #F5F5F5;
                    }

                    th.el-table__cell {
                        padding: 8px 0;
                        background-color: #57B5B3;

                        .cell {
                            color: #FFFFFF;
                            line-height: 22px;
                            font-weight: 700;
                        }
                    }

                    td.el-table__cell {
                        padding: 8px 0;
                        line-height: 22px;
                        border-color: rgba(0, 0, 0, 0.08);
                        background: #FFFFFF;

                        .cell {
                            color: #666666;
                            line-height: 18px;
                            font-size: 12px;
                        }
                    }
                }
            }

            .textarea_field_wrap {
                padding: 8px 12px;
                display: flex;
                box-shadow: inset 0px -1px 0px rgba(0, 0, 0, 0.08);
                min-height: 146px;
                border-left: 1px solid #E8E8E8;
                border-right: 1px solid #E8E8E8;
                border-bottom: 1px solid #E8E8E8;

                .textarea_field_label {
                    color: #666666;
                }

                .textarea_field_value {
                    color: #666666;
                }
            }
        }

        .template_footer_wrap {
            width: 100%;
            height: 16px;
            background: #57B5B3;
            border-top: 8px solid #CAE6E6;
            border-radius: 0 0 4px 4px;
        }
    }

    .template_11_wrap {
        background: #FFFFFF;
        min-height: 100%;
        width: 100%;

        .template_header_wrap {
            display: flex;
            align-items: center;

            .left_logo_wrap {
                width: 379px;
                padding: 16px;
                background-color: #06314F;
                position: relative;

                &::after {
                    content: '';
                    position: absolute;
                    top: 0;
                    right: 16px;
                    width: 4px;
                    height: 100%;
                    background: #DB0805;
                }

                .logo_outer_wrap {
                    width: 152px;
                    height: 32px;
                    opacity: 1;
                    border-radius: 4px;
                    border: 1px dashed rgba(255, 255, 255, 0.36);
                    cursor: pointer;
                    text-align: center;

                    .upload_text {
                        line-height: 22px;
                        color: #FFFFFF;
                        padding: 5px 0;
                    }

                    .logo {
                        width: 100%;
                        height: 100%;
                        object-fit: cover;
                        border-radius: 4px;
                    }
                }
            }

            .right_quotation_title_wrap {
                flex: 1;
                background-color: #DB0805;
                padding: 16px;
                display: flex;
                justify-content: end;
                position: relative;

                &::before {
                    content: '';
                    position: absolute;
                    top: 0;
                    left: -10px;
                    width: 4px;
                    height: 100%;
                    background: #DB0805;
                }

                .quotation_title_wrap {
                    font-size: 22px;
                    font-weight: 700;
                    line-height: 32px;
                    color: #FFFFFF;
                }
            }
        }

        .template_content_wrap {
            padding: 0 16px 16px;
            width: 100%;

            .explain_field {
                padding: 6px 12px;
                font-size: 16px;
                font-weight: 700;
                line-height: 24px;
                color: #333333;
                box-shadow: inset 0px -1px 0px rgba(0, 0, 0, 0.08);
                border-left: 1px solid #E8E8E8;
                border-right: 1px solid #E8E8E8;
            }

            .input_field_wrap {
                display: flex;
                box-shadow: inset 0px -1px 0px rgba(0, 0, 0, 0.08);

                &:nth-child(odd) {
                    border-left: 1px solid #E8E8E8;
                }

                .field_label_wrap {
                    color: #333333;
                    line-height: 18px;
                    font-size: 12px;
                    padding: 8px 0 8px 12px;
                    border-right: 1px solid #E8E8E8;
                    width: 130px;
                    letter-spacing: 0;
                }

                .field_value_wrap {
                    color: #999999;
                    font-size: 12px;
                    line-height: 18px;
                    padding: 8px 12px;
                    border-right: 1px solid #E8E8E8;
                    flex: 1;
                }
            }

            .table_field_wrap {
                .el-table {
                    th.el-table__cell {
                        padding: 8px 0;
                        background-color: #EDF0F4;
                        border-color: rgba(0, 0, 0, 0.08);

                        &:first-child {
                            background-color: rgba(0, 0, 0, 0.04);
                        }

                        .cell {
                            color: #333333;
                            line-height: 22px;
                            font-weight: 700;
                        }
                    }

                    td.el-table__cell {
                        padding: 8px 0;
                        line-height: 22px;
                        border-color: rgba(0, 0, 0, 0.08);

                        &:first-child {
                            background-color: rgba(0, 0, 0, 0.04);
                        }

                        .cell {
                            color: #666666;
                            line-height: 18px;
                            font-size: 12px;
                        }
                    }
                }
            }

            .total_price_wrap {
                display: flex;
                justify-content: end;
                border-bottom: 2px solid #06304C;

                .total_price_inner_wrap {
                    min-width: 234px;
                    line-height: 18px;
                    color: #FFFFFF;
                    background-color: #06304C;
                    padding: 8px 0 8px 12px;
                    font-size: 12px;
                    text-align: right;
                    font-weight: bold;
                }
            }

            .textarea_field_wrap {
                padding: 8px 12px;
                display: flex;
                box-shadow: inset 0px -1px 0px rgba(0, 0, 0, 0.08);
                min-height: 90px;
                border-left: 1px solid #E8E8E8;
                border-right: 1px solid #E8E8E8;

                .textarea_field_label {
                    color: #666666;
                }

                .textarea_field_value {
                    color: #666666;
                }
            }
        }

        .template_footer_wrap {
            width: 100%;
            height: 16px;
            border-radius: 0 0 4px 4px;
            position: relative;

            &::before {
                content: '';
                position: absolute;
                top: 0;
                left: 0;
                width: 70%;
                height: 100%;
                background: #06304C;
                border-radius: 0 0 0 4px;
            }

            &::after {
                content: '';
                position: absolute;
                top: 0;
                right: 0;
                width: 30%;
                height: 100%;
                background: #DD0808;
                border-radius: 0 0 4px 0;
            }
        }
    }

    .template_12_wrap {
        background: #FFFFFF;
        min-height: 100%;
        width: 100%;

        .template_header_wrap {
            display: flex;
            align-items: center;
            justify-content: space-between;
            padding: 16px;
            border-bottom: 4px solid #DB0805;

            .left_logo_wrap {
                width: 152px;
                height: 32px;
                opacity: 1;
                border-radius: 4px;
                border: 1px dashed rgba(0, 0, 0, 0.36);
                cursor: pointer;
                text-align: center;

                .upload_text {
                    line-height: 22px;
                    color: #000000;
                    padding: 5px 0;
                }

                .logo {
                    width: 100%;
                    height: 100%;
                    object-fit: cover;
                    border-radius: 4px;
                }
            }

            .right_quotation_title_wrap {
                .quotation_title_wrap {
                    font-size: 22px;
                    font-weight: 700;
                    line-height: 32px;
                    color: #DB0805;
                }
            }
        }

        .template_content_wrap {
            padding: 0 16px 12px;
            width: 100%;

            .explain_field {
                padding: 6px 12px;
                font-size: 16px;
                font-weight: 700;
                line-height: 24px;
                color: #333333;
                box-shadow: inset 0px -1px 0px rgba(0, 0, 0, 0.08);
                border-left: 1px solid #E8E8E8;
                border-right: 1px solid #E8E8E8;
            }

            .input_field_wrap {
                display: flex;
                box-shadow: inset 0px -1px 0px rgba(0, 0, 0, 0.08);

                &:nth-child(odd) {
                    border-left: 1px solid #E8E8E8;
                }

                .field_label_wrap {
                    color: #333333;
                    line-height: 18px;
                    font-size: 12px;
                    padding: 8px 0 8px 12px;
                    border-right: 1px solid #E8E8E8;
                    width: 130px;
                    letter-spacing: 0;
                }

                .field_value_wrap {
                    color: #999999;
                    font-size: 12px;
                    line-height: 18px;
                    padding: 8px 12px;
                    border-right: 1px solid #E8E8E8;
                    flex: 1;
                }
            }

            .table_field_wrap {
                .el-table {
                    th.el-table__cell {
                        padding: 8px 0;
                        background-color: #DB0805;
                        border-color: rgba(0, 0, 0, 0.08);

                        .cell {
                            color: #FFFFFF;
                            line-height: 22px;
                            font-weight: 700;
                        }
                    }

                    td.el-table__cell {
                        padding: 8px 0;
                        line-height: 22px;
                        border-color: rgba(0, 0, 0, 0.08);

                        &:first-child {
                            background-color: rgba(0, 0, 0, 0.04);
                        }

                        .cell {
                            color: #666666;
                            line-height: 18px;
                            font-size: 12px;
                        }
                    }
                }
            }

            .total_price_wrap {
                display: flex;
                justify-content: end;
                border-bottom: 2px solid #222222;

                .total_price_inner_wrap {
                    min-width: 234px;
                    line-height: 18px;
                    color: #DB0805;
                    padding: 8px 0 8px 12px;
                    font-size: 12px;
                    text-align: right;
                    font-weight: bold;
                }
            }

            .textarea_field_wrap {
                padding: 8px 12px;
                display: flex;
                box-shadow: inset 0px -1px 0px rgba(0, 0, 0, 0.08);
                min-height: 90px;
                border-left: 1px solid #E8E8E8;
                border-right: 1px solid #E8E8E8;

                .textarea_field_label {
                    color: #666666;
                }

                .textarea_field_value {
                    color: #666666;
                }
            }
        }

        .template_footer_wrap {
            display: flex;
            align-items: end;
            justify-content: space-between;

            .footer_left_wrap {
                flex: 1;
                padding-bottom: 8px;
                padding-left: 16px;
                border-bottom: 16px solid #DB0805;
                border-radius: 0 0 0 4px;

                .quotation_title_wrap {
                    font-size: 16px;
                    font-weight: 700;
                    line-height: 24px;
                    color: #333333;
                }
            }

            .footer_right_wrap {
                flex: 1;
                border-bottom: 16px solid #DB0805;
                display: flex;
                justify-content: end;
                padding-right: 16px;

                .input_field_wrap {
                    display: flex;
                    margin-bottom: 8px;
                    justify-content: end;

                    .field_label_wrap {
                        color: #333333;
                        line-height: 18px;
                        font-size: 12px;
                    }

                    .field_value_wrap {
                        color: #999999;
                        line-height: 18px;
                        font-size: 12px;
                    }
                }
            }
        }
    }
}

.relate_custom_form_body {
    width: 100%;
    height: 490px;
    padding: 24px;
}

.project_list_popover {
    padding: 6px 0;

    .project_list {
        max-height: 300px;
        overflow-y: auto;

        .project_item {
            line-height: 22px;
            padding: 6px 20px;
            cursor: pointer;
            color: #333333;

            &:hover {
                background: #F5F7FA;
            }
        }
    }
}

@media print {
    .template_review_wrap .form_module_content_wrap {
        display: flex;
        flex-wrap: wrap;

        .template_field_item_wrap {
            width: 50%;
        }
    }
}
</style>